// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231cc88a%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%235a5c69%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e74a3b%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e74a3b%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Start Bootstrap - SB Admin 2 v4.1.3 (https://startbootstrap.com/theme/sb-admin-2)
 * Copyright 2013-2021 Start Bootstrap
 * Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-sb-admin-2/blob/master/LICENSE)
 */
/*!
 * Bootstrap v4.6.0 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
    --blue: #4e73df;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #e74a3b;
    --orange: #fd7e14;
    --yellow: #f6c23e;
    --green: #1cc88a;
    --teal: #20c9a6;
    --cyan: #36b9cc;
    --white: #fff;
    --gray: #858796;
    --gray-dark: #5a5c69;
    --primary: #4e73df;
    --secondary: #858796;
    --success: #1cc88a;
    --info: #36b9cc;
    --warning: #f6c23e;
    --danger: #e74a3b;
    --light: #f8f9fc;
    --dark: #5a5c69;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: "Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}

*,
::after,
::before {
    box-sizing: border-box
}

html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
    display: block
}

body {
    margin: 0;
    font-family: Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #858796;
    text-align: left;
    background-color: #fff
}

[tabindex="-1"]:focus:not(:focus-visible) {
    outline: 0 !important
}

hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: .5rem
}

p {
    margin-top: 0;
    margin-bottom: 1rem
}

abbr[data-original-title],
abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
    text-decoration-skip-ink: none
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit
}

dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem
}

ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0
}

dt {
    font-weight: 700
}

dd {
    margin-bottom: .5rem;
    margin-left: 0
}

blockquote {
    margin: 0 0 1rem
}

b,
strong {
    font-weight: bolder
}

small {
    font-size: 80%
}

sub,
sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

a {
    color: #4e73df;
    text-decoration: none;
    background-color: transparent
}

a:hover {
    color: #224abe;
    text-decoration: underline
}

a:not([href]):not([class]) {
    color: inherit;
    text-decoration: none
}

a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none
}

code,
kbd,
pre,
samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em
}

pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar
}

figure {
    margin: 0 0 1rem
}

img {
    vertical-align: middle;
    border-style: none
}

svg {
    overflow: hidden;
    vertical-align: middle
}

table {
    border-collapse: collapse
}

caption {
    padding-top: .75rem;
    padding-bottom: .75rem;
    color: #858796;
    text-align: left;
    caption-side: bottom
}

th {
    text-align: inherit;
    text-align: -webkit-match-parent
}

label {
    display: inline-block;
    margin-bottom: .5rem
}

button {
    border-radius: 0
}

button:focus:not(:focus-visible) {
    outline: 0
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit
}

button,
input {
    overflow: visible
}

button,
select {
    text-transform: none
}

[role=button] {
    cursor: pointer
}

select {
    word-wrap: normal
}

[type=button],
[type=reset],
[type=submit],
button {
    -webkit-appearance: button
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer
}

[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border-style: none
}

input[type=checkbox],
input[type=radio] {
    box-sizing: border-box;
    padding: 0
}

textarea {
    overflow: auto;
    resize: vertical
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0
}

legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: .5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal
}

progress {
    vertical-align: baseline
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    outline-offset: -2px;
    -webkit-appearance: none
}

[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button
}

output {
    display: inline-block
}

summary {
    display: list-item;
    cursor: pointer
}

template {
    display: none
}

[hidden] {
    display: none !important
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-bottom: .5rem;
    font-weight: 400;
    line-height: 1.2
}

.h1,
h1 {
    font-size: 2.5rem
}

.h2,
h2 {
    font-size: 2rem
}

.h3,
h3 {
    font-size: 1.75rem
}

.h4,
h4 {
    font-size: 1.5rem
}

.h5,
h5 {
    font-size: 1.25rem
}

.h6,
h6 {
    font-size: 1rem
}

.lead {
    font-size: 1.25rem;
    font-weight: 300
}

.display-1 {
    font-size: 6rem;
    font-weight: 300;
    line-height: 1.2
}

.display-2 {
    font-size: 5.5rem;
    font-weight: 300;
    line-height: 1.2
}

.display-3 {
    font-size: 4.5rem;
    font-weight: 300;
    line-height: 1.2
}

.display-4 {
    font-size: 3.5rem;
    font-weight: 300;
    line-height: 1.2
}

hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, .1)
}

.small,
small {
    font-size: 80%;
    font-weight: 400
}

.mark,
mark {
    padding: .2em;
    background-color: #fcf8e3
}

.list-unstyled {
    padding-left: 0;
    list-style: none
}

.list-inline {
    padding-left: 0;
    list-style: none
}

.list-inline-item {
    display: inline-block
}

.list-inline-item:not(:last-child) {
    margin-right: .5rem
}

.initialism {
    font-size: 90%;
    text-transform: uppercase
}

.blockquote {
    margin-bottom: 1rem;
    font-size: 1.25rem
}

.blockquote-footer {
    display: block;
    font-size: 80%;
    color: #858796
}

.blockquote-footer::before {
    content: "\\2014\\00A0"
}

.img-fluid {
    max-width: 100%;
    height: auto
}

.img-thumbnail {
    padding: .25rem;
    background-color: #fff;
    border: 1px solid #dddfeb;
    border-radius: .35rem;
    max-width: 100%;
    height: auto
}

.figure {
    display: inline-block
}

.figure-img {
    margin-bottom: .5rem;
    line-height: 1
}

.figure-caption {
    font-size: 90%;
    color: #858796
}

code {
    font-size: 87.5%;
    color: #e83e8c;
    word-wrap: break-word
}

a>code {
    color: inherit
}

kbd {
    padding: .2rem .4rem;
    font-size: 87.5%;
    color: #fff;
    background-color: #3a3b45;
    border-radius: .2rem
}

kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700
}

pre {
    display: block;
    font-size: 87.5%;
    color: #3a3b45
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal
}

.pre-scrollable {
    max-height: 340px;
    overflow-y: scroll
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    width: 100%;
    padding-right: .75rem;
    padding-left: .75rem;
    margin-right: auto;
    margin-left: auto
}

@media (min-width:576px) {

    .container,
    .container-sm {
        max-width: 540px
    }
}

@media (min-width:768px) {

    .container,
    .container-md,
    .container-sm {
        max-width: 720px
    }
}

@media (min-width:992px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm {
        max-width: 960px
    }
}

@media (min-width:1200px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
        max-width: 1140px
    }
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -.75rem;
    margin-left: -.75rem
}

.no-gutters {
    margin-right: 0;
    margin-left: 0
}

.no-gutters>.col,
.no-gutters>[class*=col-] {
    padding-right: 0;
    padding-left: 0
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: .75rem;
    padding-left: .75rem
}

.col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%
}

.row-cols-1>* {
    flex: 0 0 100%;
    max-width: 100%
}

.row-cols-2>* {
    flex: 0 0 50%;
    max-width: 50%
}

.row-cols-3>* {
    flex: 0 0 33.33333%;
    max-width: 33.33333%
}

.row-cols-4>* {
    flex: 0 0 25%;
    max-width: 25%
}

.row-cols-5>* {
    flex: 0 0 20%;
    max-width: 20%
}

.row-cols-6>* {
    flex: 0 0 16.66667%;
    max-width: 16.66667%
}

.col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%
}

.col-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%
}

.col-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%
}

.col-3 {
    flex: 0 0 25%;
    max-width: 25%
}

.col-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%
}

.col-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%
}

.col-6 {
    flex: 0 0 50%;
    max-width: 50%
}

.col-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%
}

.col-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%
}

.col-9 {
    flex: 0 0 75%;
    max-width: 75%
}

.col-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%
}

.col-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%
}

.col-12 {
    flex: 0 0 100%;
    max-width: 100%
}

.order-first {
    order: -1
}

.order-last {
    order: 13
}

.order-0 {
    order: 0
}

.order-1 {
    order: 1
}

.order-2 {
    order: 2
}

.order-3 {
    order: 3
}

.order-4 {
    order: 4
}

.order-5 {
    order: 5
}

.order-6 {
    order: 6
}

.order-7 {
    order: 7
}

.order-8 {
    order: 8
}

.order-9 {
    order: 9
}

.order-10 {
    order: 10
}

.order-11 {
    order: 11
}

.order-12 {
    order: 12
}

.offset-1 {
    margin-left: 8.33333%
}

.offset-2 {
    margin-left: 16.66667%
}

.offset-3 {
    margin-left: 25%
}

.offset-4 {
    margin-left: 33.33333%
}

.offset-5 {
    margin-left: 41.66667%
}

.offset-6 {
    margin-left: 50%
}

.offset-7 {
    margin-left: 58.33333%
}

.offset-8 {
    margin-left: 66.66667%
}

.offset-9 {
    margin-left: 75%
}

.offset-10 {
    margin-left: 83.33333%
}

.offset-11 {
    margin-left: 91.66667%
}

@media (min-width:576px) {
    .col-sm {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-sm-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-sm-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-sm-3>* {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .row-cols-sm-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-sm-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-sm-6>* {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-sm-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-sm-1 {
        flex: 0 0 8.33333%;
        max-width: 8.33333%
    }

    .col-sm-2 {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-sm-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-sm-4 {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .col-sm-5 {
        flex: 0 0 41.66667%;
        max-width: 41.66667%
    }

    .col-sm-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-sm-7 {
        flex: 0 0 58.33333%;
        max-width: 58.33333%
    }

    .col-sm-8 {
        flex: 0 0 66.66667%;
        max-width: 66.66667%
    }

    .col-sm-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-sm-10 {
        flex: 0 0 83.33333%;
        max-width: 83.33333%
    }

    .col-sm-11 {
        flex: 0 0 91.66667%;
        max-width: 91.66667%
    }

    .col-sm-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-sm-first {
        order: -1
    }

    .order-sm-last {
        order: 13
    }

    .order-sm-0 {
        order: 0
    }

    .order-sm-1 {
        order: 1
    }

    .order-sm-2 {
        order: 2
    }

    .order-sm-3 {
        order: 3
    }

    .order-sm-4 {
        order: 4
    }

    .order-sm-5 {
        order: 5
    }

    .order-sm-6 {
        order: 6
    }

    .order-sm-7 {
        order: 7
    }

    .order-sm-8 {
        order: 8
    }

    .order-sm-9 {
        order: 9
    }

    .order-sm-10 {
        order: 10
    }

    .order-sm-11 {
        order: 11
    }

    .order-sm-12 {
        order: 12
    }

    .offset-sm-0 {
        margin-left: 0
    }

    .offset-sm-1 {
        margin-left: 8.33333%
    }

    .offset-sm-2 {
        margin-left: 16.66667%
    }

    .offset-sm-3 {
        margin-left: 25%
    }

    .offset-sm-4 {
        margin-left: 33.33333%
    }

    .offset-sm-5 {
        margin-left: 41.66667%
    }

    .offset-sm-6 {
        margin-left: 50%
    }

    .offset-sm-7 {
        margin-left: 58.33333%
    }

    .offset-sm-8 {
        margin-left: 66.66667%
    }

    .offset-sm-9 {
        margin-left: 75%
    }

    .offset-sm-10 {
        margin-left: 83.33333%
    }

    .offset-sm-11 {
        margin-left: 91.66667%
    }
}

@media (min-width:768px) {
    .col-md {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-md-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-md-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-md-3>* {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .row-cols-md-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-md-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-md-6>* {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-md-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-md-1 {
        flex: 0 0 8.33333%;
        max-width: 8.33333%
    }

    .col-md-2 {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-md-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-md-4 {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .col-md-5 {
        flex: 0 0 41.66667%;
        max-width: 41.66667%
    }

    .col-md-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-md-7 {
        flex: 0 0 58.33333%;
        max-width: 58.33333%
    }

    .col-md-8 {
        flex: 0 0 66.66667%;
        max-width: 66.66667%
    }

    .col-md-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-md-10 {
        flex: 0 0 83.33333%;
        max-width: 83.33333%
    }

    .col-md-11 {
        flex: 0 0 91.66667%;
        max-width: 91.66667%
    }

    .col-md-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-md-first {
        order: -1
    }

    .order-md-last {
        order: 13
    }

    .order-md-0 {
        order: 0
    }

    .order-md-1 {
        order: 1
    }

    .order-md-2 {
        order: 2
    }

    .order-md-3 {
        order: 3
    }

    .order-md-4 {
        order: 4
    }

    .order-md-5 {
        order: 5
    }

    .order-md-6 {
        order: 6
    }

    .order-md-7 {
        order: 7
    }

    .order-md-8 {
        order: 8
    }

    .order-md-9 {
        order: 9
    }

    .order-md-10 {
        order: 10
    }

    .order-md-11 {
        order: 11
    }

    .order-md-12 {
        order: 12
    }

    .offset-md-0 {
        margin-left: 0
    }

    .offset-md-1 {
        margin-left: 8.33333%
    }

    .offset-md-2 {
        margin-left: 16.66667%
    }

    .offset-md-3 {
        margin-left: 25%
    }

    .offset-md-4 {
        margin-left: 33.33333%
    }

    .offset-md-5 {
        margin-left: 41.66667%
    }

    .offset-md-6 {
        margin-left: 50%
    }

    .offset-md-7 {
        margin-left: 58.33333%
    }

    .offset-md-8 {
        margin-left: 66.66667%
    }

    .offset-md-9 {
        margin-left: 75%
    }

    .offset-md-10 {
        margin-left: 83.33333%
    }

    .offset-md-11 {
        margin-left: 91.66667%
    }
}

@media (min-width:992px) {
    .col-lg {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-lg-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-lg-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-lg-3>* {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .row-cols-lg-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-lg-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-lg-6>* {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-lg-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-lg-1 {
        flex: 0 0 8.33333%;
        max-width: 8.33333%
    }

    .col-lg-2 {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-lg-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-lg-4 {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .col-lg-5 {
        flex: 0 0 41.66667%;
        max-width: 41.66667%
    }

    .col-lg-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-lg-7 {
        flex: 0 0 58.33333%;
        max-width: 58.33333%
    }

    .col-lg-8 {
        flex: 0 0 66.66667%;
        max-width: 66.66667%
    }

    .col-lg-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-lg-10 {
        flex: 0 0 83.33333%;
        max-width: 83.33333%
    }

    .col-lg-11 {
        flex: 0 0 91.66667%;
        max-width: 91.66667%
    }

    .col-lg-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-lg-first {
        order: -1
    }

    .order-lg-last {
        order: 13
    }

    .order-lg-0 {
        order: 0
    }

    .order-lg-1 {
        order: 1
    }

    .order-lg-2 {
        order: 2
    }

    .order-lg-3 {
        order: 3
    }

    .order-lg-4 {
        order: 4
    }

    .order-lg-5 {
        order: 5
    }

    .order-lg-6 {
        order: 6
    }

    .order-lg-7 {
        order: 7
    }

    .order-lg-8 {
        order: 8
    }

    .order-lg-9 {
        order: 9
    }

    .order-lg-10 {
        order: 10
    }

    .order-lg-11 {
        order: 11
    }

    .order-lg-12 {
        order: 12
    }

    .offset-lg-0 {
        margin-left: 0
    }

    .offset-lg-1 {
        margin-left: 8.33333%
    }

    .offset-lg-2 {
        margin-left: 16.66667%
    }

    .offset-lg-3 {
        margin-left: 25%
    }

    .offset-lg-4 {
        margin-left: 33.33333%
    }

    .offset-lg-5 {
        margin-left: 41.66667%
    }

    .offset-lg-6 {
        margin-left: 50%
    }

    .offset-lg-7 {
        margin-left: 58.33333%
    }

    .offset-lg-8 {
        margin-left: 66.66667%
    }

    .offset-lg-9 {
        margin-left: 75%
    }

    .offset-lg-10 {
        margin-left: 83.33333%
    }

    .offset-lg-11 {
        margin-left: 91.66667%
    }
}

@media (min-width:1200px) {
    .col-xl {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-xl-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-xl-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-xl-3>* {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .row-cols-xl-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-xl-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-xl-6>* {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-xl-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-xl-1 {
        flex: 0 0 8.33333%;
        max-width: 8.33333%
    }

    .col-xl-2 {
        flex: 0 0 16.66667%;
        max-width: 16.66667%
    }

    .col-xl-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-xl-4 {
        flex: 0 0 33.33333%;
        max-width: 33.33333%
    }

    .col-xl-5 {
        flex: 0 0 41.66667%;
        max-width: 41.66667%
    }

    .col-xl-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-xl-7 {
        flex: 0 0 58.33333%;
        max-width: 58.33333%
    }

    .col-xl-8 {
        flex: 0 0 66.66667%;
        max-width: 66.66667%
    }

    .col-xl-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-xl-10 {
        flex: 0 0 83.33333%;
        max-width: 83.33333%
    }

    .col-xl-11 {
        flex: 0 0 91.66667%;
        max-width: 91.66667%
    }

    .col-xl-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-xl-first {
        order: -1
    }

    .order-xl-last {
        order: 13
    }

    .order-xl-0 {
        order: 0
    }

    .order-xl-1 {
        order: 1
    }

    .order-xl-2 {
        order: 2
    }

    .order-xl-3 {
        order: 3
    }

    .order-xl-4 {
        order: 4
    }

    .order-xl-5 {
        order: 5
    }

    .order-xl-6 {
        order: 6
    }

    .order-xl-7 {
        order: 7
    }

    .order-xl-8 {
        order: 8
    }

    .order-xl-9 {
        order: 9
    }

    .order-xl-10 {
        order: 10
    }

    .order-xl-11 {
        order: 11
    }

    .order-xl-12 {
        order: 12
    }

    .offset-xl-0 {
        margin-left: 0
    }

    .offset-xl-1 {
        margin-left: 8.33333%
    }

    .offset-xl-2 {
        margin-left: 16.66667%
    }

    .offset-xl-3 {
        margin-left: 25%
    }

    .offset-xl-4 {
        margin-left: 33.33333%
    }

    .offset-xl-5 {
        margin-left: 41.66667%
    }

    .offset-xl-6 {
        margin-left: 50%
    }

    .offset-xl-7 {
        margin-left: 58.33333%
    }

    .offset-xl-8 {
        margin-left: 66.66667%
    }

    .offset-xl-9 {
        margin-left: 75%
    }

    .offset-xl-10 {
        margin-left: 83.33333%
    }

    .offset-xl-11 {
        margin-left: 91.66667%
    }
}

.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #858796
}

.table td,
.table th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #e3e6f0
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #e3e6f0
}

.table tbody+tbody {
    border-top: 2px solid #e3e6f0
}

.table-sm td,
.table-sm th {
    padding: .3rem
}

.table-bordered {
    border: 1px solid #e3e6f0
}

.table-bordered td,
.table-bordered th {
    border: 1px solid #e3e6f0
}

.table-bordered thead td,
.table-bordered thead th {
    border-bottom-width: 2px
}

.table-borderless tbody+tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th {
    border: 0
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05)
}

.table-hover tbody tr:hover {
    color: #858796;
    background-color: rgba(0, 0, 0, .075)
}

.table-primary,
.table-primary>td,
.table-primary>th {
    background-color: #cdd8f6
}

.table-primary tbody+tbody,
.table-primary td,
.table-primary th,
.table-primary thead th {
    border-color: #a3b6ee
}

.table-hover .table-primary:hover {
    background-color: #b7c7f2
}

.table-hover .table-primary:hover>td,
.table-hover .table-primary:hover>th {
    background-color: #b7c7f2
}

.table-secondary,
.table-secondary>td,
.table-secondary>th {
    background-color: #dddde2
}

.table-secondary tbody+tbody,
.table-secondary td,
.table-secondary th,
.table-secondary thead th {
    border-color: #c0c1c8
}

.table-hover .table-secondary:hover {
    background-color: #cfcfd6
}

.table-hover .table-secondary:hover>td,
.table-hover .table-secondary:hover>th {
    background-color: #cfcfd6
}

.table-success,
.table-success>td,
.table-success>th {
    background-color: #bff0de
}

.table-success tbody+tbody,
.table-success td,
.table-success th,
.table-success thead th {
    border-color: #89e2c2
}

.table-hover .table-success:hover {
    background-color: #aaebd3
}

.table-hover .table-success:hover>td,
.table-hover .table-success:hover>th {
    background-color: #aaebd3
}

.table-info,
.table-info>td,
.table-info>th {
    background-color: #c7ebf1
}

.table-info tbody+tbody,
.table-info td,
.table-info th,
.table-info thead th {
    border-color: #96dbe4
}

.table-hover .table-info:hover {
    background-color: #b3e4ec
}

.table-hover .table-info:hover>td,
.table-hover .table-info:hover>th {
    background-color: #b3e4ec
}

.table-warning,
.table-warning>td,
.table-warning>th {
    background-color: #fceec9
}

.table-warning tbody+tbody,
.table-warning td,
.table-warning th,
.table-warning thead th {
    border-color: #fadf9b
}

.table-hover .table-warning:hover {
    background-color: #fbe6b1
}

.table-hover .table-warning:hover>td,
.table-hover .table-warning:hover>th {
    background-color: #fbe6b1
}

.table-danger,
.table-danger>td,
.table-danger>th {
    background-color: #f8ccc8
}

.table-danger tbody+tbody,
.table-danger td,
.table-danger th,
.table-danger thead th {
    border-color: #f3a199
}

.table-hover .table-danger:hover {
    background-color: #f5b7b1
}

.table-hover .table-danger:hover>td,
.table-hover .table-danger:hover>th {
    background-color: #f5b7b1
}

.table-light,
.table-light>td,
.table-light>th {
    background-color: #fdfdfe
}

.table-light tbody+tbody,
.table-light td,
.table-light th,
.table-light thead th {
    border-color: #fbfcfd
}

.table-hover .table-light:hover {
    background-color: #ececf6
}

.table-hover .table-light:hover>td,
.table-hover .table-light:hover>th {
    background-color: #ececf6
}

.table-dark,
.table-dark>td,
.table-dark>th {
    background-color: #d1d1d5
}

.table-dark tbody+tbody,
.table-dark td,
.table-dark th,
.table-dark thead th {
    border-color: #a9aab1
}

.table-hover .table-dark:hover {
    background-color: #c4c4c9
}

.table-hover .table-dark:hover>td,
.table-hover .table-dark:hover>th {
    background-color: #c4c4c9
}

.table-active,
.table-active>td,
.table-active>th {
    background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover {
    background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover>td,
.table-hover .table-active:hover>th {
    background-color: rgba(0, 0, 0, .075)
}

.table .thead-dark th {
    color: #fff;
    background-color: #5a5c69;
    border-color: #6c6e7e
}

.table .thead-light th {
    color: #6e707e;
    background-color: #eaecf4;
    border-color: #e3e6f0
}

.table-dark {
    color: #fff;
    background-color: #5a5c69
}

.table-dark td,
.table-dark th,
.table-dark thead th {
    border-color: #6c6e7e
}

.table-dark.table-bordered {
    border: 0
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, .05)
}

.table-dark.table-hover tbody tr:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .075)
}

@media (max-width:575.98px) {
    .table-responsive-sm {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-sm>.table-bordered {
        border: 0
    }
}

@media (max-width:767.98px) {
    .table-responsive-md {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-md>.table-bordered {
        border: 0
    }
}

@media (max-width:991.98px) {
    .table-responsive-lg {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-lg>.table-bordered {
        border: 0
    }
}

@media (max-width:1199.98px) {
    .table-responsive-xl {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-xl>.table-bordered {
        border: 0
    }
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch
}

.table-responsive>.table-bordered {
    border: 0
}

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6e707e;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d1d3e2;
    border-radius: .35rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .form-control {
        transition: none
    }
}

.form-control::-ms-expand {
    background-color: transparent;
    border: 0
}

.form-control:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #6e707e
}

.form-control:focus {
    color: #6e707e;
    background-color: #fff;
    border-color: #bac8f3;
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.form-control::placeholder {
    color: #858796;
    opacity: 1
}

.form-control:disabled,
.form-control[readonly] {
    background-color: #eaecf4;
    opacity: 1
}

input[type=date].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control,
input[type=time].form-control {
    appearance: none
}

select.form-control:focus::-ms-value {
    color: #6e707e;
    background-color: #fff
}

.form-control-file,
.form-control-range {
    display: block;
    width: 100%
}

.col-form-label {
    padding-top: calc(.375rem + 1px);
    padding-bottom: calc(.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5
}

.col-form-label-lg {
    padding-top: calc(.5rem + 1px);
    padding-bottom: calc(.5rem + 1px);
    font-size: 1.25rem;
    line-height: 1.5
}

.col-form-label-sm {
    padding-top: calc(.25rem + 1px);
    padding-bottom: calc(.25rem + 1px);
    font-size: .875rem;
    line-height: 1.5
}

.form-control-plaintext {
    display: block;
    width: 100%;
    padding: .375rem 0;
    margin-bottom: 0;
    font-size: 1rem;
    line-height: 1.5;
    color: #858796;
    background-color: transparent;
    border: solid transparent;
    border-width: 1px 0
}

.form-control-plaintext.form-control-lg,
.form-control-plaintext.form-control-sm {
    padding-right: 0;
    padding-left: 0
}

.form-control-sm {
    height: calc(1.5em + .5rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .2rem
}

.form-control-lg {
    height: calc(1.5em + 1rem + 2px);
    padding: .5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: .3rem
}

select.form-control[multiple],
select.form-control[size] {
    height: auto
}

textarea.form-control {
    height: auto
}

.form-group {
    margin-bottom: 1rem
}

.form-text {
    display: block;
    margin-top: .25rem
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px
}

.form-row>.col,
.form-row>[class*=col-] {
    padding-right: 5px;
    padding-left: 5px
}

.form-check {
    position: relative;
    display: block;
    padding-left: 1.25rem
}

.form-check-input {
    position: absolute;
    margin-top: .3rem;
    margin-left: -1.25rem
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    color: #858796
}

.form-check-label {
    margin-bottom: 0
}

.form-check-inline {
    display: inline-flex;
    align-items: center;
    padding-left: 0;
    margin-right: .75rem
}

.form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: .3125rem;
    margin-left: 0
}

.valid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #1cc88a
}

.valid-tooltip {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .25rem .5rem;
    margin-top: .1rem;
    font-size: .875rem;
    line-height: 1.5;
    color: #fff;
    background-color: rgba(28, 200, 138, .9);
    border-radius: .35rem
}

.form-row>.col>.valid-tooltip,
.form-row>[class*=col-]>.valid-tooltip {
    left: 5px
}

.is-valid~.valid-feedback,
.is-valid~.valid-tooltip,
.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip {
    display: block
}

.form-control.is-valid,
.was-validated .form-control:valid {
    border-color: #1cc88a;
    padding-right: calc(1.5em + .75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right calc(.375em + .1875rem) center;
    background-size: calc(.75em + .375rem) calc(.75em + .375rem)
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
    border-color: #1cc88a;
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
    padding-right: calc(1.5em + .75rem);
    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)
}

.custom-select.is-valid,
.was-validated .custom-select:valid {
    border-color: #1cc88a;
    padding-right: calc(.75em + 2.3125rem);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right .75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat
}

.custom-select.is-valid:focus,
.was-validated .custom-select:valid:focus {
    border-color: #1cc88a;
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)
}

.form-check-input.is-valid~.form-check-label,
.was-validated .form-check-input:valid~.form-check-label {
    color: #1cc88a
}

.form-check-input.is-valid~.valid-feedback,
.form-check-input.is-valid~.valid-tooltip,
.was-validated .form-check-input:valid~.valid-feedback,
.was-validated .form-check-input:valid~.valid-tooltip {
    display: block
}

.custom-control-input.is-valid~.custom-control-label,
.was-validated .custom-control-input:valid~.custom-control-label {
    color: #1cc88a
}

.custom-control-input.is-valid~.custom-control-label::before,
.was-validated .custom-control-input:valid~.custom-control-label::before {
    border-color: #1cc88a
}

.custom-control-input.is-valid:checked~.custom-control-label::before,
.was-validated .custom-control-input:valid:checked~.custom-control-label::before {
    border-color: #34e3a4;
    background-color: #34e3a4
}

.custom-control-input.is-valid:focus~.custom-control-label::before,
.was-validated .custom-control-input:valid:focus~.custom-control-label::before {
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)
}

.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,
.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before {
    border-color: #1cc88a
}

.custom-file-input.is-valid~.custom-file-label,
.was-validated .custom-file-input:valid~.custom-file-label {
    border-color: #1cc88a
}

.custom-file-input.is-valid:focus~.custom-file-label,
.was-validated .custom-file-input:valid:focus~.custom-file-label {
    border-color: #1cc88a;
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #e74a3b
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .25rem .5rem;
    margin-top: .1rem;
    font-size: .875rem;
    line-height: 1.5;
    color: #fff;
    background-color: rgba(231, 74, 59, .9);
    border-radius: .35rem
}

.form-row>.col>.invalid-tooltip,
.form-row>[class*=col-]>.invalid-tooltip {
    left: 5px
}

.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip,
.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip {
    display: block
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
    border-color: #e74a3b;
    padding-right: calc(1.5em + .75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right calc(.375em + .1875rem) center;
    background-size: calc(.75em + .375rem) calc(.75em + .375rem)
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
    border-color: #e74a3b;
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
    padding-right: calc(1.5em + .75rem);
    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)
}

.custom-select.is-invalid,
.was-validated .custom-select:invalid {
    border-color: #e74a3b;
    padding-right: calc(.75em + 2.3125rem);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right .75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat
}

.custom-select.is-invalid:focus,
.was-validated .custom-select:invalid:focus {
    border-color: #e74a3b;
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)
}

.form-check-input.is-invalid~.form-check-label,
.was-validated .form-check-input:invalid~.form-check-label {
    color: #e74a3b
}

.form-check-input.is-invalid~.invalid-feedback,
.form-check-input.is-invalid~.invalid-tooltip,
.was-validated .form-check-input:invalid~.invalid-feedback,
.was-validated .form-check-input:invalid~.invalid-tooltip {
    display: block
}

.custom-control-input.is-invalid~.custom-control-label,
.was-validated .custom-control-input:invalid~.custom-control-label {
    color: #e74a3b
}

.custom-control-input.is-invalid~.custom-control-label::before,
.was-validated .custom-control-input:invalid~.custom-control-label::before {
    border-color: #e74a3b
}

.custom-control-input.is-invalid:checked~.custom-control-label::before,
.was-validated .custom-control-input:invalid:checked~.custom-control-label::before {
    border-color: #ed7468;
    background-color: #ed7468
}

.custom-control-input.is-invalid:focus~.custom-control-label::before,
.was-validated .custom-control-input:invalid:focus~.custom-control-label::before {
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)
}

.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,
.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before {
    border-color: #e74a3b
}

.custom-file-input.is-invalid~.custom-file-label,
.was-validated .custom-file-input:invalid~.custom-file-label {
    border-color: #e74a3b
}

.custom-file-input.is-invalid:focus~.custom-file-label,
.was-validated .custom-file-input:invalid:focus~.custom-file-label {
    border-color: #e74a3b;
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)
}

.form-inline {
    display: flex;
    flex-flow: row wrap;
    align-items: center
}

.form-inline .form-check {
    width: 100%
}

@media (min-width:576px) {
    .form-inline label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0
    }

    .form-inline .form-group {
        display: flex;
        flex: 0 0 auto;
        flex-flow: row wrap;
        align-items: center;
        margin-bottom: 0
    }

    .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle
    }

    .form-inline .form-control-plaintext {
        display: inline-block
    }

    .form-inline .custom-select,
    .form-inline .input-group {
        width: auto
    }

    .form-inline .form-check {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        padding-left: 0
    }

    .form-inline .form-check-input {
        position: relative;
        flex-shrink: 0;
        margin-top: 0;
        margin-right: .25rem;
        margin-left: 0
    }

    .form-inline .custom-control {
        align-items: center;
        justify-content: center
    }

    .form-inline .custom-control-label {
        margin-bottom: 0
    }
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #858796;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .35rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .btn {
        transition: none
    }
}

.btn:hover {
    color: #858796;
    text-decoration: none
}

.btn.focus,
.btn:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.btn.disabled,
.btn:disabled {
    opacity: .65
}

.btn:not(:disabled):not(.disabled) {
    cursor: pointer
}

a.btn.disabled,
fieldset:disabled a.btn {
    pointer-events: none
}

.btn-primary {
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.btn-Excel {
    color: #f5f5f5;
    background-color: #38c61c;
    border-color: #38c61c;
}

.btn-primary:hover {
    color: #fff;
    background-color: #2e59d9;
    border-color: #2653d4
}

.btn-primary.focus,
.btn-primary:focus {
    color: #fff;
    background-color: #2e59d9;
    border-color: #2653d4;
    box-shadow: 0 0 0 .2rem rgba(105, 136, 228, .5)
}

.btn-primary.disabled,
.btn-primary:disabled {
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #2653d4;
    border-color: #244ec9
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(105, 136, 228, .5)
}

.btn-secondary {
    color: #fff;
    background-color: #858796;
    border-color: #858796
}

.btn-secondary:hover {
    color: #fff;
    background-color: #717384;
    border-color: #6b6d7d
}

.btn-secondary.focus,
.btn-secondary:focus {
    color: #fff;
    background-color: #717384;
    border-color: #6b6d7d;
    box-shadow: 0 0 0 .2rem rgba(151, 153, 166, .5)
}

.btn-secondary.disabled,
.btn-secondary:disabled {
    color: #fff;
    background-color: #858796;
    border-color: #858796
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show>.btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6b6d7d;
    border-color: #656776
}

.btn-secondary:not(:disabled):not(.disabled).active:focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(151, 153, 166, .5)
}

.btn-success {
    color: #fff;
    background-color: #1cc88a;
    border-color: #1cc88a
}

.btn-success:hover {
    color: #fff;
    background-color: #17a673;
    border-color: #169b6b
}

.btn-success.focus,
.btn-success:focus {
    color: #fff;
    background-color: #17a673;
    border-color: #169b6b;
    box-shadow: 0 0 0 .2rem rgba(62, 208, 156, .5)
}

.btn-success.disabled,
.btn-success:disabled {
    color: #fff;
    background-color: #1cc88a;
    border-color: #1cc88a
}

.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show>.btn-success.dropdown-toggle {
    color: #fff;
    background-color: #169b6b;
    border-color: #149063
}

.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-success.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(62, 208, 156, .5)
}

.btn-info {
    color: #fff;
    background-color: #36b9cc;
    border-color: #36b9cc
}

.btn-info:hover {
    color: #fff;
    background-color: #2c9faf;
    border-color: #2a96a5
}

.btn-info.focus,
.btn-info:focus {
    color: #fff;
    background-color: #2c9faf;
    border-color: #2a96a5;
    box-shadow: 0 0 0 .2rem rgba(84, 196, 212, .5)
}

.btn-info.disabled,
.btn-info:disabled {
    color: #fff;
    background-color: #36b9cc;
    border-color: #36b9cc
}

.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active,
.show>.btn-info.dropdown-toggle {
    color: #fff;
    background-color: #2a96a5;
    border-color: #278c9b
}

.btn-info:not(:disabled):not(.disabled).active:focus,
.btn-info:not(:disabled):not(.disabled):active:focus,
.show>.btn-info.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(84, 196, 212, .5)
}

.btn-warning {
    color: #fff;
    background-color: #f6c23e;
    border-color: #f6c23e
}

.btn-warning:hover {
    color: #fff;
    background-color: #f4b619;
    border-color: #f4b30d
}

.btn-warning.focus,
.btn-warning:focus {
    color: #fff;
    background-color: #f4b619;
    border-color: #f4b30d;
    box-shadow: 0 0 0 .2rem rgba(247, 203, 91, .5)
}

.btn-warning.disabled,
.btn-warning:disabled {
    color: #fff;
    background-color: #f6c23e;
    border-color: #f6c23e
}

.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active,
.show>.btn-warning.dropdown-toggle {
    color: #fff;
    background-color: #f4b30d;
    border-color: #e9aa0b
}

.btn-warning:not(:disabled):not(.disabled).active:focus,
.btn-warning:not(:disabled):not(.disabled):active:focus,
.show>.btn-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(247, 203, 91, .5)
}

.btn-danger {
    color: #fff;
    background-color: #e74a3b;
    border-color: #e74a3b
}

.btn-danger:hover {
    color: #fff;
    background-color: #e02d1b;
    border-color: #d52a1a
}

.btn-danger.focus,
.btn-danger:focus {
    color: #fff;
    background-color: #e02d1b;
    border-color: #d52a1a;
    box-shadow: 0 0 0 .2rem rgba(235, 101, 88, .5)
}

.btn-danger.disabled,
.btn-danger:disabled {
    color: #fff;
    background-color: #e74a3b;
    border-color: #e74a3b
}

.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active,
.show>.btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #d52a1a;
    border-color: #ca2819
}

.btn-danger:not(:disabled):not(.disabled).active:focus,
.btn-danger:not(:disabled):not(.disabled):active:focus,
.show>.btn-danger.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(235, 101, 88, .5)
}

.btn-light {
    color: #3a3b45;
    background-color: #f8f9fc;
    border-color: #f8f9fc
}

.btn-light:hover {
    color: #3a3b45;
    background-color: #dde2f1;
    border-color: #d4daed
}

.btn-light.focus,
.btn-light:focus {
    color: #3a3b45;
    background-color: #dde2f1;
    border-color: #d4daed;
    box-shadow: 0 0 0 .2rem rgba(220, 221, 225, .5)
}

.btn-light.disabled,
.btn-light:disabled {
    color: #3a3b45;
    background-color: #f8f9fc;
    border-color: #f8f9fc
}

.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):active,
.show>.btn-light.dropdown-toggle {
    color: #3a3b45;
    background-color: #d4daed;
    border-color: #cbd3e9
}

.btn-light:not(:disabled):not(.disabled).active:focus,
.btn-light:not(:disabled):not(.disabled):active:focus,
.show>.btn-light.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(220, 221, 225, .5)
}

.btn-dark {
    color: #fff;
    background-color: #5a5c69;
    border-color: #5a5c69
}

.btn-dark:hover {
    color: #fff;
    background-color: #484a54;
    border-color: #42444e
}

.btn-dark.focus,
.btn-dark:focus {
    color: #fff;
    background-color: #484a54;
    border-color: #42444e;
    box-shadow: 0 0 0 .2rem rgba(115, 116, 128, .5)
}

.btn-dark.disabled,
.btn-dark:disabled {
    color: #fff;
    background-color: #5a5c69;
    border-color: #5a5c69
}

.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active,
.show>.btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #42444e;
    border-color: #3d3e47
}

.btn-dark:not(:disabled):not(.disabled).active:focus,
.btn-dark:not(:disabled):not(.disabled):active:focus,
.show>.btn-dark.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(115, 116, 128, .5)
}

.btn-outline-primary {
    color: #4e73df;
    border-color: #4e73df
}

.btn-outline-primary:hover {
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
    color: #4e73df;
    background-color: transparent
}

.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,
.show>.btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)
}

.btn-outline-secondary {
    color: #858796;
    border-color: #858796
}

.btn-outline-secondary:hover {
    color: #fff;
    background-color: #858796;
    border-color: #858796
}

.btn-outline-secondary.focus,
.btn-outline-secondary:focus {
    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
    color: #858796;
    background-color: transparent
}

.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.show>.btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #858796;
    border-color: #858796
}

.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)
}

.btn-outline-success {
    color: #1cc88a;
    border-color: #1cc88a
}

.btn-outline-success:hover {
    color: #fff;
    background-color: #1cc88a;
    border-color: #1cc88a
}

.btn-outline-success.focus,
.btn-outline-success:focus {
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
    color: #1cc88a;
    background-color: transparent
}

.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active,
.show>.btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #1cc88a;
    border-color: #1cc88a
}

.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-success.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)
}

.btn-outline-info {
    color: #36b9cc;
    border-color: #36b9cc
}

.btn-outline-info:hover {
    color: #fff;
    background-color: #36b9cc;
    border-color: #36b9cc
}

.btn-outline-info.focus,
.btn-outline-info:focus {
    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
    color: #36b9cc;
    background-color: transparent
}

.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active,
.show>.btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #36b9cc;
    border-color: #36b9cc
}

.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-info.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)
}

.btn-outline-warning {
    color: #f6c23e;
    border-color: #f6c23e
}

.btn-outline-warning:hover {
    color: #fff;
    background-color: #f6c23e;
    border-color: #f6c23e
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
    color: #f6c23e;
    background-color: transparent
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active,
.show>.btn-outline-warning.dropdown-toggle {
    color: #fff;
    background-color: #f6c23e;
    border-color: #f6c23e
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)
}

.btn-outline-danger {
    color: #e74a3b;
    border-color: #e74a3b
}

.btn-outline-danger:hover {
    color: #fff;
    background-color: #e74a3b;
    border-color: #e74a3b
}

.btn-outline-danger.focus,
.btn-outline-danger:focus {
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
    color: #e74a3b;
    background-color: transparent
}

.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active,
.show>.btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #e74a3b;
    border-color: #e74a3b
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-danger.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)
}

.btn-outline-light {
    color: #f8f9fc;
    border-color: #f8f9fc
}

.btn-outline-light:hover {
    color: #3a3b45;
    background-color: #f8f9fc;
    border-color: #f8f9fc
}

.btn-outline-light.focus,
.btn-outline-light:focus {
    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
    color: #f8f9fc;
    background-color: transparent
}

.btn-outline-light:not(:disabled):not(.disabled).active,
.btn-outline-light:not(:disabled):not(.disabled):active,
.show>.btn-outline-light.dropdown-toggle {
    color: #3a3b45;
    background-color: #f8f9fc;
    border-color: #f8f9fc
}

.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-light.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)
}

.btn-outline-dark {
    color: #5a5c69;
    border-color: #5a5c69
}

.btn-outline-dark:hover {
    color: #fff;
    background-color: #5a5c69;
    border-color: #5a5c69
}

.btn-outline-dark.focus,
.btn-outline-dark:focus {
    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
    color: #5a5c69;
    background-color: transparent
}

.btn-outline-dark:not(:disabled):not(.disabled).active,
.btn-outline-dark:not(:disabled):not(.disabled):active,
.show>.btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #5a5c69;
    border-color: #5a5c69
}

.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-dark.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)
}

.btn-link {
    font-weight: 400;
    color: #4e73df;
    text-decoration: none
}

.btn-link:hover {
    color: #224abe;
    text-decoration: underline
}

.btn-link.focus,
.btn-link:focus {
    text-decoration: underline
}

.btn-link.disabled,
.btn-link:disabled {
    color: #858796;
    pointer-events: none
}

.btn-group-lg>.btn,
.btn-lg {
    padding: .5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: .3rem
}

.btn-group-sm>.btn,
.btn-sm {
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .2rem
}

.btn-block {
    display: block;
    width: 100%
}

.btn-block+.btn-block {
    margin-top: .5rem
}

input[type=button].btn-block,
input[type=reset].btn-block,
input[type=submit].btn-block {
    width: 100%
}

.fade {
    transition: opacity .15s linear
}

@media (prefers-reduced-motion:reduce) {
    .fade {
        transition: none
    }
}

.fade:not(.show) {
    opacity: 0
}

.collapse:not(.show) {
    display: none
}

.collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition: height .15s ease
}

@media (prefers-reduced-motion:reduce) {
    .collapsing {
        transition: none
    }
}

.dropdown,
.dropleft,
.dropright,
.dropup {
    position: relative
}

.dropdown-toggle {
    white-space: nowrap
}

.dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent
}

.dropdown-toggle:empty::after {
    margin-left: 0
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: .5rem 0;
    margin: .125rem 0 0;
    font-size: .85rem;
    color: #858796;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e3e6f0;
    border-radius: .35rem
}

.dropdown-menu-left {
    right: auto;
    left: 0
}

.dropdown-menu-right {
    right: 0;
    left: auto
}

@media (min-width:576px) {
    .dropdown-menu-sm-left {
        right: auto;
        left: 0
    }

    .dropdown-menu-sm-right {
        right: 0;
        left: auto
    }
}

@media (min-width:768px) {
    .dropdown-menu-md-left {
        right: auto;
        left: 0
    }

    .dropdown-menu-md-right {
        right: 0;
        left: auto
    }
}

@media (min-width:992px) {
    .dropdown-menu-lg-left {
        right: auto;
        left: 0
    }

    .dropdown-menu-lg-right {
        right: 0;
        left: auto
    }
}

@media (min-width:1200px) {
    .dropdown-menu-xl-left {
        right: auto;
        left: 0
    }

    .dropdown-menu-xl-right {
        right: 0;
        left: auto
    }
}

.dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: .125rem
}

.dropup .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: 0;
    border-right: .3em solid transparent;
    border-bottom: .3em solid;
    border-left: .3em solid transparent
}

.dropup .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropright .dropdown-menu {
    top: 0;
    right: auto;
    left: 100%;
    margin-top: 0;
    margin-left: .125rem
}

.dropright .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid transparent;
    border-right: 0;
    border-bottom: .3em solid transparent;
    border-left: .3em solid
}

.dropright .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropright .dropdown-toggle::after {
    vertical-align: 0
}

.dropleft .dropdown-menu {
    top: 0;
    right: 100%;
    left: auto;
    margin-top: 0;
    margin-right: .125rem
}

.dropleft .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: ""
}

.dropleft .dropdown-toggle::after {
    display: none
}

.dropleft .dropdown-toggle::before {
    display: inline-block;
    margin-right: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid transparent;
    border-right: .3em solid;
    border-bottom: .3em solid transparent
}

.dropleft .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropleft .dropdown-toggle::before {
    vertical-align: 0
}

.dropdown-menu[x-placement^=bottom],
.dropdown-menu[x-placement^=left],
.dropdown-menu[x-placement^=right],
.dropdown-menu[x-placement^=top] {
    right: auto;
    bottom: auto
}

.dropdown-divider {
    height: 0;
    margin: .5rem 0;
    overflow: hidden;
    border-top: 1px solid #eaecf4
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: .25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #3a3b45;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0
}

.dropdown-item:focus,
.dropdown-item:hover {
    color: #2e2f37;
    text-decoration: none;
    background-color: #eaecf4
}

.dropdown-item.active,
.dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #4e73df
}

.dropdown-item.disabled,
.dropdown-item:disabled {
    color: #b7b9cc;
    pointer-events: none;
    background-color: transparent
}

.dropdown-menu.show {
    display: block
}

.dropdown-header {
    display: block;
    padding: .5rem 1.5rem;
    margin-bottom: 0;
    font-size: .875rem;
    color: #858796;
    white-space: nowrap
}

.dropdown-item-text {
    display: block;
    padding: .25rem 1.5rem;
    color: #3a3b45
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle
}

.btn-group-vertical>.btn,
.btn-group>.btn {
    position: relative;
    flex: 1 1 auto
}

.btn-group-vertical>.btn:hover,
.btn-group>.btn:hover {
    z-index: 1
}

.btn-group-vertical>.btn.active,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn:focus,
.btn-group>.btn.active,
.btn-group>.btn:active,
.btn-group>.btn:focus {
    z-index: 1
}

.btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start
}

.btn-toolbar .input-group {
    width: auto
}

.btn-group>.btn-group:not(:first-child),
.btn-group>.btn:not(:first-child) {
    margin-left: -1px
}

.btn-group>.btn-group:not(:last-child)>.btn,
.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.btn-group>.btn-group:not(:first-child)>.btn,
.btn-group>.btn:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.dropdown-toggle-split {
    padding-right: .5625rem;
    padding-left: .5625rem
}

.dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
    margin-left: 0
}

.dropleft .dropdown-toggle-split::before {
    margin-right: 0
}

.btn-group-sm>.btn+.dropdown-toggle-split,
.btn-sm+.dropdown-toggle-split {
    padding-right: .375rem;
    padding-left: .375rem
}

.btn-group-lg>.btn+.dropdown-toggle-split,
.btn-lg+.dropdown-toggle-split {
    padding-right: .75rem;
    padding-left: .75rem
}

.btn-group-vertical {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
    width: 100%
}

.btn-group-vertical>.btn-group:not(:first-child),
.btn-group-vertical>.btn:not(:first-child) {
    margin-top: -1px
}

.btn-group-vertical>.btn-group:not(:last-child)>.btn,
.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.btn-group-vertical>.btn-group:not(:first-child)>.btn,
.btn-group-vertical>.btn:not(:first-child) {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.btn-group-toggle>.btn,
.btn-group-toggle>.btn-group>.btn {
    margin-bottom: 0
}

.btn-group-toggle>.btn input[type=checkbox],
.btn-group-toggle>.btn input[type=radio],
.btn-group-toggle>.btn-group>.btn input[type=checkbox],
.btn-group-toggle>.btn-group>.btn input[type=radio] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control,
.input-group>.form-control-plaintext {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0
}

.input-group>.custom-file+.custom-file,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.form-control,
.input-group>.custom-select+.custom-file,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.form-control,
.input-group>.form-control+.custom-file,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.form-control,
.input-group>.form-control-plaintext+.custom-file,
.input-group>.form-control-plaintext+.custom-select,
.input-group>.form-control-plaintext+.form-control {
    margin-left: -1px
}

.input-group>.custom-file .custom-file-input:focus~.custom-file-label,
.input-group>.custom-select:focus,
.input-group>.form-control:focus {
    z-index: 3
}

.input-group>.custom-file .custom-file-input:focus {
    z-index: 4
}

.input-group>.custom-select:not(:first-child),
.input-group>.form-control:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.input-group>.custom-file {
    display: flex;
    align-items: center
}

.input-group>.custom-file:not(:first-child) .custom-file-label,
.input-group>.custom-file:not(:last-child) .custom-file-label {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after,
.input-group:not(.has-validation)>.custom-select:not(:last-child),
.input-group:not(.has-validation)>.form-control:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label::after,
.input-group.has-validation>.custom-select:nth-last-child(n+3),
.input-group.has-validation>.form-control:nth-last-child(n+3) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group-append,
.input-group-prepend {
    display: flex
}

.input-group-append .btn,
.input-group-prepend .btn {
    position: relative;
    z-index: 2
}

.input-group-append .btn:focus,
.input-group-prepend .btn:focus {
    z-index: 3
}

.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.btn,
.input-group-append .input-group-text+.input-group-text,
.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-prepend .input-group-text+.input-group-text {
    margin-left: -1px
}

.input-group-prepend {
    margin-right: -1px
}

.input-group-append {
    margin-left: -1px
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6e707e;
    text-align: center;
    white-space: nowrap;
    background-color: #eaecf4;
    border: 1px solid #d1d3e2;
    border-radius: .35rem
}

.input-group-text input[type=checkbox],
.input-group-text input[type=radio] {
    margin-top: 0
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control:not(textarea) {
    height: calc(1.5em + 1rem + 2px)
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control,
.input-group-lg>.input-group-append>.btn,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-prepend>.input-group-text {
    padding: .5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: .3rem
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control:not(textarea) {
    height: calc(1.5em + .5rem + 2px)
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control,
.input-group-sm>.input-group-append>.btn,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-prepend>.input-group-text {
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .2rem
}

.input-group-lg>.custom-select,
.input-group-sm>.custom-select {
    padding-right: 1.75rem
}

.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,
.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,
.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,
.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.custom-control {
    position: relative;
    z-index: 1;
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
    color-adjust: exact
}

.custom-control-inline {
    display: inline-flex;
    margin-right: 1rem
}

.custom-control-input {
    position: absolute;
    left: 0;
    z-index: -1;
    width: 1rem;
    height: 1.25rem;
    opacity: 0
}

.custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    border-color: #4e73df;
    background-color: #4e73df
}

.custom-control-input:focus~.custom-control-label::before {
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-control-input:focus:not(:checked)~.custom-control-label::before {
    border-color: #bac8f3
}

.custom-control-input:not(:disabled):active~.custom-control-label::before {
    color: #fff;
    background-color: #e5ebfa;
    border-color: #e5ebfa
}

.custom-control-input:disabled~.custom-control-label,
.custom-control-input[disabled]~.custom-control-label {
    color: #858796
}

.custom-control-input:disabled~.custom-control-label::before,
.custom-control-input[disabled]~.custom-control-label::before {
    background-color: #eaecf4
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    vertical-align: top
}

.custom-control-label::before {
    position: absolute;
    top: .25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #b7b9cc solid 1px
}

.custom-control-label::after {
    position: absolute;
    top: .25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background: 50%/50% 50% no-repeat
}

.custom-checkbox .custom-control-label::before {
    border-radius: .35rem
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
    border-color: #4e73df;
    background-color: #4e73df
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
    background-color: rgba(78, 115, 223, .5)
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
    background-color: rgba(78, 115, 223, .5)
}

.custom-radio .custom-control-label::before {
    border-radius: 50%
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
    background-color: rgba(78, 115, 223, .5)
}

.custom-switch {
    padding-left: 2.25rem
}

.custom-switch .custom-control-label::before {
    left: -2.25rem;
    width: 1.75rem;
    pointer-events: all;
    border-radius: .5rem
}

.custom-switch .custom-control-label::after {
    top: calc(.25rem + 2px);
    left: calc(-2.25rem + 2px);
    width: calc(1rem - 4px);
    height: calc(1rem - 4px);
    background-color: #b7b9cc;
    border-radius: .5rem;
    transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .custom-switch .custom-control-label::after {
        transition: none
    }
}

.custom-switch .custom-control-input:checked~.custom-control-label::after {
    background-color: #fff;
    transform: translateX(.75rem)
}

.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {
    background-color: rgba(78, 115, 223, .5)
}

.custom-select {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem 1.75rem .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6e707e;
    vertical-align: middle;
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right .75rem center/8px 10px no-repeat;
    border: 1px solid #d1d3e2;
    border-radius: .35rem;
    appearance: none
}

.custom-select:focus {
    border-color: #bac8f3;
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-select:focus::-ms-value {
    color: #6e707e;
    background-color: #fff
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none
}

.custom-select:disabled {
    color: #858796;
    background-color: #eaecf4
}

.custom-select::-ms-expand {
    display: none
}

.custom-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #6e707e
}

.custom-select-sm {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem
}

.custom-select-lg {
    height: calc(1.5em + 1rem + 2px);
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: 1rem;
    font-size: 1.25rem
}

.custom-file {
    position: relative;
    display: inline-block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    margin-bottom: 0
}

.custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    margin: 0;
    overflow: hidden;
    opacity: 0
}

.custom-file-input:focus~.custom-file-label {
    border-color: #bac8f3;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-file-input:disabled~.custom-file-label,
.custom-file-input[disabled]~.custom-file-label {
    background-color: #eaecf4
}

.custom-file-input:lang(en)~.custom-file-label::after {
    content: "Browse"
}

.custom-file-input~.custom-file-label[data-browse]::after {
    content: attr(data-browse)
}

.custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    overflow: hidden;
    font-weight: 400;
    line-height: 1.5;
    color: #6e707e;
    background-color: #fff;
    border: 1px solid #d1d3e2;
    border-radius: .35rem
}

.custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1.5em + .75rem);
    padding: .375rem .75rem;
    line-height: 1.5;
    color: #6e707e;
    content: "Browse";
    background-color: #eaecf4;
    border-left: inherit;
    border-radius: 0 .35rem .35rem 0
}

.custom-range {
    width: 100%;
    height: 1.4rem;
    padding: 0;
    background-color: transparent;
    appearance: none
}

.custom-range:focus {
    outline: 0
}

.custom-range:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-range:focus::-moz-range-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-range:focus::-ms-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.custom-range::-moz-focus-outer {
    border: 0
}

.custom-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -.25rem;
    background-color: #4e73df;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media (prefers-reduced-motion:reduce) {
    .custom-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none
    }
}

.custom-range::-webkit-slider-thumb:active {
    background-color: #e5ebfa
}

.custom-range::-webkit-slider-runnable-track {
    width: 100%;
    height: .5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dddfeb;
    border-color: transparent;
    border-radius: 1rem
}

.custom-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #4e73df;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media (prefers-reduced-motion:reduce) {
    .custom-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none
    }
}

.custom-range::-moz-range-thumb:active {
    background-color: #e5ebfa
}

.custom-range::-moz-range-track {
    width: 100%;
    height: .5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dddfeb;
    border-color: transparent;
    border-radius: 1rem
}

.custom-range::-ms-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: 0;
    margin-right: .2rem;
    margin-left: .2rem;
    background-color: #4e73df;
    border: 0;
    border-radius: 1rem;
    -ms-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media (prefers-reduced-motion:reduce) {
    .custom-range::-ms-thumb {
        -ms-transition: none;
        transition: none
    }
}

.custom-range::-ms-thumb:active {
    background-color: #e5ebfa
}

.custom-range::-ms-track {
    width: 100%;
    height: .5rem;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: .5rem
}

.custom-range::-ms-fill-lower {
    background-color: #dddfeb;
    border-radius: 1rem
}

.custom-range::-ms-fill-upper {
    margin-right: 15px;
    background-color: #dddfeb;
    border-radius: 1rem
}

.custom-range:disabled::-webkit-slider-thumb {
    background-color: #b7b9cc
}

.custom-range:disabled::-webkit-slider-runnable-track {
    cursor: default
}

.custom-range:disabled::-moz-range-thumb {
    background-color: #b7b9cc
}

.custom-range:disabled::-moz-range-track {
    cursor: default
}

.custom-range:disabled::-ms-thumb {
    background-color: #b7b9cc
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {

    .custom-control-label::before,
    .custom-file-label,
    .custom-select {
        transition: none
    }
}

.nav {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.nav-link {
    display: block;
    padding: .5rem 1rem
}

.nav-link:focus,
.nav-link:hover {
    text-decoration: none
}

.nav-link.disabled {
    color: #858796;
    pointer-events: none;
    cursor: default
}

.nav-tabs {
    border-bottom: 1px solid #dddfeb
}

.nav-tabs .nav-link {
    margin-bottom: -1px;
    border: 1px solid transparent;
    border-top-left-radius: .35rem;
    border-top-right-radius: .35rem
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
    border-color: #eaecf4 #eaecf4 #dddfeb
}

.nav-tabs .nav-link.disabled {
    color: #858796;
    background-color: transparent;
    border-color: transparent
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #6e707e;
    background-color: #fff;
    border-color: #dddfeb #dddfeb #fff
}

.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav-pills .nav-link {
    border-radius: .35rem
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff;
    background-color: #4e73df
}

.nav-fill .nav-item,
.nav-fill>.nav-link {
    flex: 1 1 auto;
    text-align: center
}

.nav-justified .nav-item,
.nav-justified>.nav-link {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center
}

.tab-content>.tab-pane {
    display: none
}

.tab-content>.active {
    display: block
}

.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: .5rem 1rem
}

.navbar .container,
.navbar .container-fluid,
.navbar .container-lg,
.navbar .container-md,
.navbar .container-sm,
.navbar .container-xl {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between
}

.navbar-brand {
    display: inline-block;
    padding-top: .3125rem;
    padding-bottom: .3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap
}

.navbar-brand:focus,
.navbar-brand:hover {
    text-decoration: none
}

.navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0
}

.navbar-nav .dropdown-menu {
    position: static;
    float: none
}

.navbar-text {
    display: inline-block;
    padding-top: .5rem;
    padding-bottom: .5rem
}

.navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center
}

.navbar-toggler {
    padding: .25rem .75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: .35rem
}

.navbar-toggler:focus,
.navbar-toggler:hover {
    text-decoration: none
}

.navbar-toggler-icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    content: "";
    background: 50%/100% 100% no-repeat
}

.navbar-nav-scroll {
    max-height: 75vh;
    overflow-y: auto
}

@media (max-width:575.98px) {

    .navbar-expand-sm>.container,
    .navbar-expand-sm>.container-fluid,
    .navbar-expand-sm>.container-lg,
    .navbar-expand-sm>.container-md,
    .navbar-expand-sm>.container-sm,
    .navbar-expand-sm>.container-xl {
        padding-right: 0;
        padding-left: 0
    }
}

@media (min-width:576px) {
    .navbar-expand-sm {
        flex-flow: row nowrap;
        justify-content: flex-start
    }

    .navbar-expand-sm .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: .5rem;
        padding-left: .5rem
    }

    .navbar-expand-sm>.container,
    .navbar-expand-sm>.container-fluid,
    .navbar-expand-sm>.container-lg,
    .navbar-expand-sm>.container-md,
    .navbar-expand-sm>.container-sm,
    .navbar-expand-sm>.container-xl {
        flex-wrap: nowrap
    }

    .navbar-expand-sm .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-sm .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-sm .navbar-toggler {
        display: none
    }
}

@media (max-width:767.98px) {

    .navbar-expand-md>.container,
    .navbar-expand-md>.container-fluid,
    .navbar-expand-md>.container-lg,
    .navbar-expand-md>.container-md,
    .navbar-expand-md>.container-sm,
    .navbar-expand-md>.container-xl {
        padding-right: 0;
        padding-left: 0
    }
}

@media (min-width:768px) {
    .navbar-expand-md {
        flex-flow: row nowrap;
        justify-content: flex-start
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-md .navbar-nav .nav-link {
        padding-right: .5rem;
        padding-left: .5rem
    }

    .navbar-expand-md>.container,
    .navbar-expand-md>.container-fluid,
    .navbar-expand-md>.container-lg,
    .navbar-expand-md>.container-md,
    .navbar-expand-md>.container-sm,
    .navbar-expand-md>.container-xl {
        flex-wrap: nowrap
    }

    .navbar-expand-md .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-md .navbar-toggler {
        display: none
    }
}

@media (max-width:991.98px) {

    .navbar-expand-lg>.container,
    .navbar-expand-lg>.container-fluid,
    .navbar-expand-lg>.container-lg,
    .navbar-expand-lg>.container-md,
    .navbar-expand-lg>.container-sm,
    .navbar-expand-lg>.container-xl {
        padding-right: 0;
        padding-left: 0
    }
}

@media (min-width:992px) {
    .navbar-expand-lg {
        flex-flow: row nowrap;
        justify-content: flex-start
    }

    .navbar-expand-lg .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: .5rem;
        padding-left: .5rem
    }

    .navbar-expand-lg>.container,
    .navbar-expand-lg>.container-fluid,
    .navbar-expand-lg>.container-lg,
    .navbar-expand-lg>.container-md,
    .navbar-expand-lg>.container-sm,
    .navbar-expand-lg>.container-xl {
        flex-wrap: nowrap
    }

    .navbar-expand-lg .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-lg .navbar-toggler {
        display: none
    }
}

@media (max-width:1199.98px) {

    .navbar-expand-xl>.container,
    .navbar-expand-xl>.container-fluid,
    .navbar-expand-xl>.container-lg,
    .navbar-expand-xl>.container-md,
    .navbar-expand-xl>.container-sm,
    .navbar-expand-xl>.container-xl {
        padding-right: 0;
        padding-left: 0
    }
}

@media (min-width:1200px) {
    .navbar-expand-xl {
        flex-flow: row nowrap;
        justify-content: flex-start
    }

    .navbar-expand-xl .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: .5rem;
        padding-left: .5rem
    }

    .navbar-expand-xl>.container,
    .navbar-expand-xl>.container-fluid,
    .navbar-expand-xl>.container-lg,
    .navbar-expand-xl>.container-md,
    .navbar-expand-xl>.container-sm,
    .navbar-expand-xl>.container-xl {
        flex-wrap: nowrap
    }

    .navbar-expand-xl .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-xl .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-xl .navbar-toggler {
        display: none
    }
}

.navbar-expand {
    flex-flow: row nowrap;
    justify-content: flex-start
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-lg,
.navbar-expand>.container-md,
.navbar-expand>.container-sm,
.navbar-expand>.container-xl {
    padding-right: 0;
    padding-left: 0
}

.navbar-expand .navbar-nav {
    flex-direction: row
}

.navbar-expand .navbar-nav .dropdown-menu {
    position: absolute
}

.navbar-expand .navbar-nav .nav-link {
    padding-right: .5rem;
    padding-left: .5rem
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-lg,
.navbar-expand>.container-md,
.navbar-expand>.container-sm,
.navbar-expand>.container-xl {
    flex-wrap: nowrap
}

.navbar-expand .navbar-nav-scroll {
    overflow: visible
}

.navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto
}

.navbar-expand .navbar-toggler {
    display: none
}

.navbar-light .navbar-brand {
    color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-brand:focus,
.navbar-light .navbar-brand:hover {
    color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, .5)
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
    color: rgba(0, 0, 0, .7)
}

.navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, .3)
}

.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show>.nav-link {
    color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-toggler {
    color: rgba(0, 0, 0, .5);
    border-color: rgba(0, 0, 0, .1)
}

.navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
}

.navbar-light .navbar-text {
    color: rgba(0, 0, 0, .5)
}

.navbar-light .navbar-text a {
    color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-text a:focus,
.navbar-light .navbar-text a:hover {
    color: rgba(0, 0, 0, .9)
}

.navbar-dark .navbar-brand {
    color: #fff
}

.navbar-dark .navbar-brand:focus,
.navbar-dark .navbar-brand:hover {
    color: #fff
}

.navbar-dark .navbar-nav .nav-link {
    color: rgba(255, 255, 255, .5)
}

.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, .75)
}

.navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, .25)
}

.navbar-dark .navbar-nav .active>.nav-link,
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .show>.nav-link {
    color: #fff
}

.navbar-dark .navbar-toggler {
    color: rgba(255, 255, 255, .5);
    border-color: rgba(255, 255, 255, .1)
}

.navbar-dark .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
}

.navbar-dark .navbar-text {
    color: rgba(255, 255, 255, .5)
}

.navbar-dark .navbar-text a {
    color: #fff
}

.navbar-dark .navbar-text a:focus,
.navbar-dark .navbar-text a:hover {
    color: #fff
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #e3e6f0;
    border-radius: .35rem
}

.card>hr {
    margin-right: 0;
    margin-left: 0
}

.card>.list-group {
    border-top: inherit;
    border-bottom: inherit
}

.card>.list-group:first-child {
    border-top-width: 0;
    border-top-left-radius: calc(.35rem - 1px);
    border-top-right-radius: calc(.35rem - 1px)
}

.card>.list-group:last-child {
    border-bottom-width: 0;
    border-bottom-right-radius: calc(.35rem - 1px);
    border-bottom-left-radius: calc(.35rem - 1px)
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
    border-top: 0
}

.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem
}

.card-title {
    margin-bottom: .75rem
}

.card-subtitle {
    margin-top: -.375rem;
    margin-bottom: 0
}

.card-text:last-child {
    margin-bottom: 0
}

.card-link:hover {
    text-decoration: none
}

.card-link+.card-link {
    margin-left: 1.25rem
}

.card-header {
    padding: .75rem 1.25rem;
    margin-bottom: 0;
    background-color: #f8f9fc;
    border-bottom: 1px solid #e3e6f0
}

.card-header:first-child {
    border-radius: calc(.35rem - 1px) calc(.35rem - 1px) 0 0
}

.card-footer {
    padding: .75rem 1.25rem;
    background-color: #f8f9fc;
    border-top: 1px solid #e3e6f0
}

.card-footer:last-child {
    border-radius: 0 0 calc(.35rem - 1px) calc(.35rem - 1px)
}

.card-header-tabs {
    margin-right: -.625rem;
    margin-bottom: -.75rem;
    margin-left: -.625rem;
    border-bottom: 0
}

.card-header-pills {
    margin-right: -.625rem;
    margin-left: -.625rem
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.25rem;
    border-radius: calc(.35rem - 1px)
}

.card-img,
.card-img-bottom,
.card-img-top {
    flex-shrink: 0;
    width: 100%
}

.card-img,
.card-img-top {
    border-top-left-radius: calc(.35rem - 1px);
    border-top-right-radius: calc(.35rem - 1px)
}

.card-img,
.card-img-bottom {
    border-bottom-right-radius: calc(.35rem - 1px);
    border-bottom-left-radius: calc(.35rem - 1px)
}

.card-deck .card {
    margin-bottom: .75rem
}

@media (min-width:576px) {
    .card-deck {
        display: flex;
        flex-flow: row wrap;
        margin-right: -.75rem;
        margin-left: -.75rem
    }

    .card-deck .card {
        flex: 1 0;
        margin-right: .75rem;
        margin-bottom: 0;
        margin-left: .75rem
    }
}

.card-group>.card {
    margin-bottom: .75rem
}

@media (min-width:576px) {
    .card-group {
        display: flex;
        flex-flow: row wrap
    }

    .card-group>.card {
        flex: 1 0;
        margin-bottom: 0
    }

    .card-group>.card+.card {
        margin-left: 0;
        border-left: 0
    }

    .card-group>.card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-header,
    .card-group>.card:not(:last-child) .card-img-top {
        border-top-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-footer,
    .card-group>.card:not(:last-child) .card-img-bottom {
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-header,
    .card-group>.card:not(:first-child) .card-img-top {
        border-top-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-footer,
    .card-group>.card:not(:first-child) .card-img-bottom {
        border-bottom-left-radius: 0
    }
}

.card-columns .card {
    margin-bottom: .75rem
}

@media (min-width:576px) {
    .card-columns {
        column-count: 3;
        column-gap: 1.25rem;
        orphans: 1;
        widows: 1
    }

    .card-columns .card {
        display: inline-block;
        width: 100%
    }
}

.accordion {
    overflow-anchor: none
}

.accordion>.card {
    overflow: hidden
}

.accordion>.card:not(:last-of-type) {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.accordion>.card:not(:first-of-type) {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.accordion>.card>.card-header {
    border-radius: 0;
    margin-bottom: -1px
}

.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: .75rem 1rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: #eaecf4;
    border-radius: .35rem
}

.breadcrumb-item+.breadcrumb-item {
    padding-left: .5rem
}

.breadcrumb-item+.breadcrumb-item::before {
    float: left;
    padding-right: .5rem;
    color: #858796;
    content: "/"
}

.breadcrumb-item+.breadcrumb-item:hover::before {
    text-decoration: underline
}

.breadcrumb-item+.breadcrumb-item:hover::before {
    text-decoration: none
}

.breadcrumb-item.active {
    color: #858796
}

.pagination {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: .35rem
}

.page-link {
    position: relative;
    display: block;
    padding: .5rem .75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #4e73df;
    background-color: #fff;
    border: 1px solid #dddfeb
}

.page-link:hover {
    z-index: 2;
    color: #224abe;
    text-decoration: none;
    background-color: #eaecf4;
    border-color: #dddfeb
}

.page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)
}

.page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: .35rem;
    border-bottom-left-radius: .35rem
}

.page-item:last-child .page-link {
    border-top-right-radius: .35rem;
    border-bottom-right-radius: .35rem
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.page-item.disabled .page-link {
    color: #858796;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dddfeb
}

.pagination-lg .page-link {
    padding: .75rem 1.5rem;
    font-size: 1.25rem;
    line-height: 1.5
}

.pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: .3rem;
    border-bottom-left-radius: .3rem
}

.pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem
}

.pagination-sm .page-link {
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5
}

.pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: .2rem;
    border-bottom-left-radius: .2rem
}

.pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: .2rem;
    border-bottom-right-radius: .2rem
}

.badge {
    display: inline-block;
    padding: .25em .4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .35rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .badge {
        transition: none
    }
}

a.badge:focus,
a.badge:hover {
    text-decoration: none
}

.badge:empty {
    display: none
}

.btn .badge {
    position: relative;
    top: -1px
}

.badge-pill {
    padding-right: .6em;
    padding-left: .6em;
    border-radius: 10rem
}

.badge-primary {
    color: #fff;
    background-color: #4e73df
}

a.badge-primary:focus,
a.badge-primary:hover {
    color: #fff;
    background-color: #2653d4
}

a.badge-primary.focus,
a.badge-primary:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)
}

.badge-secondary {
    color: #fff;
    background-color: #858796
}

a.badge-secondary:focus,
a.badge-secondary:hover {
    color: #fff;
    background-color: #6b6d7d
}

a.badge-secondary.focus,
a.badge-secondary:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)
}

.badge-success {
    color: #fff;
    background-color: #1cc88a
}

a.badge-success:focus,
a.badge-success:hover {
    color: #fff;
    background-color: #169b6b
}

a.badge-success.focus,
a.badge-success:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)
}

.badge-info {
    color: #fff;
    background-color: #36b9cc
}

a.badge-info:focus,
a.badge-info:hover {
    color: #fff;
    background-color: #2a96a5
}

a.badge-info.focus,
a.badge-info:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)
}

.badge-warning {
    color: #fff;
    background-color: #f6c23e
}

a.badge-warning:focus,
a.badge-warning:hover {
    color: #fff;
    background-color: #f4b30d
}

a.badge-warning.focus,
a.badge-warning:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)
}

.badge-danger {
    color: #fff;
    background-color: #e74a3b
}

a.badge-danger:focus,
a.badge-danger:hover {
    color: #fff;
    background-color: #d52a1a
}

a.badge-danger.focus,
a.badge-danger:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)
}

.badge-light {
    color: #3a3b45;
    background-color: #f8f9fc
}

a.badge-light:focus,
a.badge-light:hover {
    color: #3a3b45;
    background-color: #d4daed
}

a.badge-light.focus,
a.badge-light:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)
}

.badge-dark {
    color: #fff;
    background-color: #5a5c69
}

a.badge-dark:focus,
a.badge-dark:hover {
    color: #fff;
    background-color: #42444e
}

a.badge-dark.focus,
a.badge-dark:focus {
    outline: 0;
    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)
}

.jumbotron {
    padding: 2rem 1rem;
    margin-bottom: 2rem;
    background-color: #eaecf4;
    border-radius: .3rem
}

@media (min-width:576px) {
    .jumbotron {
        padding: 4rem 2rem
    }
}

.jumbotron-fluid {
    padding-right: 0;
    padding-left: 0;
    border-radius: 0
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .35rem
}

.alert-heading {
    color: inherit
}

.alert-link {
    font-weight: 700
}

.alert-dismissible {
    padding-right: 4rem
}

.alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: .75rem 1.25rem;
    color: inherit
}

.alert-primary {
    color: #293c74;
    background-color: #dce3f9;
    border-color: #cdd8f6
}

.alert-primary hr {
    border-top-color: #b7c7f2
}

.alert-primary .alert-link {
    color: #1c294e
}

.alert-secondary {
    color: #45464e;
    background-color: #e7e7ea;
    border-color: #dddde2
}

.alert-secondary hr {
    border-top-color: #cfcfd6
}

.alert-secondary .alert-link {
    color: #2d2e33
}

.alert-success {
    color: #0f6848;
    background-color: #d2f4e8;
    border-color: #bff0de
}

.alert-success hr {
    border-top-color: #aaebd3
}

.alert-success .alert-link {
    color: #093b29
}

.alert-info {
    color: #1c606a;
    background-color: #d7f1f5;
    border-color: #c7ebf1
}

.alert-info hr {
    border-top-color: #b3e4ec
}

.alert-info .alert-link {
    color: #113b42
}

.alert-warning {
    color: #806520;
    background-color: #fdf3d8;
    border-color: #fceec9
}

.alert-warning hr {
    border-top-color: #fbe6b1
}

.alert-warning .alert-link {
    color: #574516
}

.alert-danger {
    color: #78261f;
    background-color: #fadbd8;
    border-color: #f8ccc8
}

.alert-danger hr {
    border-top-color: #f5b7b1
}

.alert-danger .alert-link {
    color: #4f1915
}

.alert-light {
    color: #818183;
    background-color: #fefefe;
    border-color: #fdfdfe
}

.alert-light hr {
    border-top-color: #ececf6
}

.alert-light .alert-link {
    color: #686869
}

.alert-dark {
    color: #2f3037;
    background-color: #dedee1;
    border-color: #d1d1d5
}

.alert-dark hr {
    border-top-color: #c4c4c9
}

.alert-dark .alert-link {
    color: #18181c
}

@keyframes progress-bar-stripes {
    from {
        background-position: 1rem 0
    }

    to {
        background-position: 0 0
    }
}

.progress {
    display: flex;
    height: 1rem;
    overflow: hidden;
    line-height: 0;
    font-size: .75rem;
    background-color: #eaecf4;
    border-radius: .35rem
}

.progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #4e73df;
    transition: width .6s ease
}

@media (prefers-reduced-motion:reduce) {
    .progress-bar {
        transition: none
    }
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem
}

.progress-bar-animated {
    animation: 1s linear infinite progress-bar-stripes
}

@media (prefers-reduced-motion:reduce) {
    .progress-bar-animated {
        animation: none
    }
}

.media {
    display: flex;
    align-items: flex-start
}

.media-body {
    flex: 1 1
}

.list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: .35rem
}

.list-group-item-action {
    width: 100%;
    color: #6e707e;
    text-align: inherit
}

.list-group-item-action:focus,
.list-group-item-action:hover {
    z-index: 1;
    color: #6e707e;
    text-decoration: none;
    background-color: #f8f9fc
}

.list-group-item-action:active {
    color: #858796;
    background-color: #eaecf4
}

.list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .125)
}

.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit
}

.list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit
}

.list-group-item.disabled,
.list-group-item:disabled {
    color: #858796;
    pointer-events: none;
    background-color: #fff
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #4e73df;
    border-color: #4e73df
}

.list-group-item+.list-group-item {
    border-top-width: 0
}

.list-group-item+.list-group-item.active {
    margin-top: -1px;
    border-top-width: 1px
}

.list-group-horizontal {
    flex-direction: row
}

.list-group-horizontal>.list-group-item:first-child {
    border-bottom-left-radius: .35rem;
    border-top-right-radius: 0
}

.list-group-horizontal>.list-group-item:last-child {
    border-top-right-radius: .35rem;
    border-bottom-left-radius: 0
}

.list-group-horizontal>.list-group-item.active {
    margin-top: 0
}

.list-group-horizontal>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px
}

@media (min-width:576px) {
    .list-group-horizontal-sm {
        flex-direction: row
    }

    .list-group-horizontal-sm>.list-group-item:first-child {
        border-bottom-left-radius: .35rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-sm>.list-group-item:last-child {
        border-top-right-radius: .35rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-sm>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width:768px) {
    .list-group-horizontal-md {
        flex-direction: row
    }

    .list-group-horizontal-md>.list-group-item:first-child {
        border-bottom-left-radius: .35rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-md>.list-group-item:last-child {
        border-top-right-radius: .35rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-md>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width:992px) {
    .list-group-horizontal-lg {
        flex-direction: row
    }

    .list-group-horizontal-lg>.list-group-item:first-child {
        border-bottom-left-radius: .35rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-lg>.list-group-item:last-child {
        border-top-right-radius: .35rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-lg>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width:1200px) {
    .list-group-horizontal-xl {
        flex-direction: row
    }

    .list-group-horizontal-xl>.list-group-item:first-child {
        border-bottom-left-radius: .35rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-xl>.list-group-item:last-child {
        border-top-right-radius: .35rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xl>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

.list-group-flush {
    border-radius: 0
}

.list-group-flush>.list-group-item {
    border-width: 0 0 1px
}

.list-group-flush>.list-group-item:last-child {
    border-bottom-width: 0
}

.list-group-item-primary {
    color: #293c74;
    background-color: #cdd8f6
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
    color: #293c74;
    background-color: #b7c7f2
}

.list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #293c74;
    border-color: #293c74
}

.list-group-item-secondary {
    color: #45464e;
    background-color: #dddde2
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
    color: #45464e;
    background-color: #cfcfd6
}

.list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #45464e;
    border-color: #45464e
}

.list-group-item-success {
    color: #0f6848;
    background-color: #bff0de
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
    color: #0f6848;
    background-color: #aaebd3
}

.list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #0f6848;
    border-color: #0f6848
}

.list-group-item-info {
    color: #1c606a;
    background-color: #c7ebf1
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
    color: #1c606a;
    background-color: #b3e4ec
}

.list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #1c606a;
    border-color: #1c606a
}

.list-group-item-warning {
    color: #806520;
    background-color: #fceec9
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
    color: #806520;
    background-color: #fbe6b1
}

.list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #806520;
    border-color: #806520
}

.list-group-item-danger {
    color: #78261f;
    background-color: #f8ccc8
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
    color: #78261f;
    background-color: #f5b7b1
}

.list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #78261f;
    border-color: #78261f
}

.list-group-item-light {
    color: #818183;
    background-color: #fdfdfe
}

.list-group-item-light.list-group-item-action:focus,
.list-group-item-light.list-group-item-action:hover {
    color: #818183;
    background-color: #ececf6
}

.list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #818183;
    border-color: #818183
}

.list-group-item-dark {
    color: #2f3037;
    background-color: #d1d1d5
}

.list-group-item-dark.list-group-item-action:focus,
.list-group-item-dark.list-group-item-action:hover {
    color: #2f3037;
    background-color: #c4c4c9
}

.list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #2f3037;
    border-color: #2f3037
}

.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5
}

.close:hover {
    color: #000;
    text-decoration: none
}

.close:not(:disabled):not(.disabled):focus,
.close:not(:disabled):not(.disabled):hover {
    opacity: .75
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0
}

a.close.disabled {
    pointer-events: none
}

.toast {
    flex-basis: 350px;
    max-width: 350px;
    font-size: .875rem;
    background-color: rgba(255, 255, 255, .85);
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .1);
    opacity: 0;
    border-radius: .25rem
}

.toast:not(:last-child) {
    margin-bottom: .75rem
}

.toast.showing {
    opacity: 1
}

.toast.show {
    display: block;
    opacity: 1
}

.toast.hide {
    display: none
}

.toast-header {
    display: flex;
    align-items: center;
    padding: .25rem .75rem;
    color: #858796;
    background-color: rgba(255, 255, 255, .85);
    background-clip: padding-box;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
    border-top-left-radius: calc(.25rem - 1px);
    border-top-right-radius: calc(.25rem - 1px)
}

.toast-body {
    padding: .75rem
}

.modal-open {
    overflow: hidden
}

.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -50px)
}

@media (prefers-reduced-motion:reduce) {
    .modal.fade .modal-dialog {
        transition: none
    }
}

.modal.show .modal-dialog {
    transform: none
}

.modal.modal-static .modal-dialog {
    transform: scale(1.02)
}

.modal-dialog-scrollable {
    display: flex;
    max-height: calc(100% - 1rem)
}

.modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
    overflow: hidden
}

.modal-dialog-scrollable .modal-footer,
.modal-dialog-scrollable .modal-header {
    flex-shrink: 0
}

.modal-dialog-scrollable .modal-body {
    overflow-y: auto
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 1rem)
}

.modal-dialog-centered::before {
    display: block;
    height: calc(100vh - 1rem);
    height: min-content;
    content: ""
}

.modal-dialog-centered.modal-dialog-scrollable {
    flex-direction: column;
    justify-content: center;
    height: 100%
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
    max-height: none
}

.modal-dialog-centered.modal-dialog-scrollable::before {
    content: none
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem;
    outline: 0
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000
}

.modal-backdrop.fade {
    opacity: 0
}

.modal-backdrop.show {
    opacity: .5
}

.modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #e3e6f0;
    border-top-left-radius: calc(.3rem - 1px);
    border-top-right-radius: calc(.3rem - 1px)
}

.modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem
}

.modal-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: .75rem;
    border-top: 1px solid #e3e6f0;
    border-bottom-right-radius: calc(.3rem - 1px);
    border-bottom-left-radius: calc(.3rem - 1px)
}

.modal-footer>* {
    margin: .25rem
}

.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll
}

@media (min-width:576px) {
    .modal-dialog {
        max-width: 500px;
        margin: 1.75rem auto
    }

    .modal-dialog-scrollable {
        max-height: calc(100% - 3.5rem)
    }

    .modal-dialog-scrollable .modal-content {
        max-height: calc(100vh - 3.5rem)
    }

    .modal-dialog-centered {
        min-height: calc(100% - 3.5rem)
    }

    .modal-dialog-centered::before {
        height: calc(100vh - 3.5rem);
        height: min-content
    }

    .modal-sm {
        max-width: 300px
    }
}

@media (min-width:992px) {

    .modal-lg,
    .modal-xl {
        max-width: 800px
    }
}

@media (min-width:1200px) {
    .modal-xl {
        max-width: 1140px
    }
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: .875rem;
    word-wrap: break-word;
    opacity: 0
}

.tooltip.show {
    opacity: .9
}

.tooltip .arrow {
    position: absolute;
    display: block;
    width: .8rem;
    height: .4rem
}

.tooltip .arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid
}

.bs-tooltip-auto[x-placement^=top],
.bs-tooltip-top {
    padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=top] .arrow,
.bs-tooltip-top .arrow {
    bottom: 0
}

.bs-tooltip-auto[x-placement^=top] .arrow::before,
.bs-tooltip-top .arrow::before {
    top: 0;
    border-width: .4rem .4rem 0;
    border-top-color: #000
}

.bs-tooltip-auto[x-placement^=right],
.bs-tooltip-right {
    padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=right] .arrow,
.bs-tooltip-right .arrow {
    left: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[x-placement^=right] .arrow::before,
.bs-tooltip-right .arrow::before {
    right: 0;
    border-width: .4rem .4rem .4rem 0;
    border-right-color: #000
}

.bs-tooltip-auto[x-placement^=bottom],
.bs-tooltip-bottom {
    padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow,
.bs-tooltip-bottom .arrow {
    top: 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before,
.bs-tooltip-bottom .arrow::before {
    bottom: 0;
    border-width: 0 .4rem .4rem;
    border-bottom-color: #000
}

.bs-tooltip-auto[x-placement^=left],
.bs-tooltip-left {
    padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=left] .arrow,
.bs-tooltip-left .arrow {
    right: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[x-placement^=left] .arrow::before,
.bs-tooltip-left .arrow::before {
    left: 0;
    border-width: .4rem 0 .4rem .4rem;
    border-left-color: #000
}

.tooltip-inner {
    max-width: 200px;
    padding: .25rem .5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: .35rem
}

.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: block;
    max-width: 276px;
    font-family: Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: .875rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem
}

.popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: .5rem;
    margin: 0 .3rem
}

.popover .arrow::after,
.popover .arrow::before {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid
}

.bs-popover-auto[x-placement^=top],
.bs-popover-top {
    margin-bottom: .5rem
}

.bs-popover-auto[x-placement^=top]>.arrow,
.bs-popover-top>.arrow {
    bottom: calc(-.5rem - 1px)
}

.bs-popover-auto[x-placement^=top]>.arrow::before,
.bs-popover-top>.arrow::before {
    bottom: 0;
    border-width: .5rem .5rem 0;
    border-top-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=top]>.arrow::after,
.bs-popover-top>.arrow::after {
    bottom: 1px;
    border-width: .5rem .5rem 0;
    border-top-color: #fff
}

.bs-popover-auto[x-placement^=right],
.bs-popover-right {
    margin-left: .5rem
}

.bs-popover-auto[x-placement^=right]>.arrow,
.bs-popover-right>.arrow {
    left: calc(-.5rem - 1px);
    width: .5rem;
    height: 1rem;
    margin: .3rem 0
}

.bs-popover-auto[x-placement^=right]>.arrow::before,
.bs-popover-right>.arrow::before {
    left: 0;
    border-width: .5rem .5rem .5rem 0;
    border-right-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=right]>.arrow::after,
.bs-popover-right>.arrow::after {
    left: 1px;
    border-width: .5rem .5rem .5rem 0;
    border-right-color: #fff
}

.bs-popover-auto[x-placement^=bottom],
.bs-popover-bottom {
    margin-top: .5rem
}

.bs-popover-auto[x-placement^=bottom]>.arrow,
.bs-popover-bottom>.arrow {
    top: calc(-.5rem - 1px)
}

.bs-popover-auto[x-placement^=bottom]>.arrow::before,
.bs-popover-bottom>.arrow::before {
    top: 0;
    border-width: 0 .5rem .5rem .5rem;
    border-bottom-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=bottom]>.arrow::after,
.bs-popover-bottom>.arrow::after {
    top: 1px;
    border-width: 0 .5rem .5rem .5rem;
    border-bottom-color: #fff
}

.bs-popover-auto[x-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7
}

.bs-popover-auto[x-placement^=left],
.bs-popover-left {
    margin-right: .5rem
}

.bs-popover-auto[x-placement^=left]>.arrow,
.bs-popover-left>.arrow {
    right: calc(-.5rem - 1px);
    width: .5rem;
    height: 1rem;
    margin: .3rem 0
}

.bs-popover-auto[x-placement^=left]>.arrow::before,
.bs-popover-left>.arrow::before {
    right: 0;
    border-width: .5rem 0 .5rem .5rem;
    border-left-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=left]>.arrow::after,
.bs-popover-left>.arrow::after {
    right: 1px;
    border-width: .5rem 0 .5rem .5rem;
    border-left-color: #fff
}

.popover-header {
    padding: .5rem .75rem;
    margin-bottom: 0;
    font-size: 1rem;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: calc(.3rem - 1px);
    border-top-right-radius: calc(.3rem - 1px)
}

.popover-header:empty {
    display: none
}

.popover-body {
    padding: .5rem .75rem;
    color: #858796
}

.carousel {
    position: relative
}

.carousel.pointer-event {
    touch-action: pan-y
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden
}

.carousel-inner::after {
    display: block;
    clear: both;
    content: ""
}

.carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform .6s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .carousel-item {
        transition: none
    }
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
    display: block
}

.active.carousel-item-right,
.carousel-item-next:not(.carousel-item-left) {
    transform: translateX(100%)
}

.active.carousel-item-left,
.carousel-item-prev:not(.carousel-item-right) {
    transform: translateX(-100%)
}

.carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    transform: none
}

.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
    z-index: 1;
    opacity: 1
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
    z-index: 0;
    opacity: 0;
    transition: opacity 0s .6s
}

@media (prefers-reduced-motion:reduce) {

    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
        transition: none
    }
}

.carousel-control-next,
.carousel-control-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    color: #fff;
    text-align: center;
    opacity: .5;
    transition: opacity .15s ease
}

@media (prefers-reduced-motion:reduce) {

    .carousel-control-next,
    .carousel-control-prev {
        transition: none
    }
}

.carousel-control-next:focus,
.carousel-control-next:hover,
.carousel-control-prev:focus,
.carousel-control-prev:hover {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9
}

.carousel-control-prev {
    left: 0
}

.carousel-control-next {
    right: 0
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: 50%/100% 100% no-repeat
}

.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: flex;
    justify-content: center;
    padding-left: 0;
    margin-right: 15%;
    margin-left: 15%;
    list-style: none
}

.carousel-indicators li {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity .6s ease
}

@media (prefers-reduced-motion:reduce) {
    .carousel-indicators li {
        transition: none
    }
}

.carousel-indicators .active {
    opacity: 1
}

.carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 20px;
    left: 15%;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg)
    }
}

.spinner-border {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: text-bottom;
    border: .25em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: .75s linear infinite spinner-border
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: .2em
}

@keyframes spinner-grow {
    0% {
        transform: scale(0)
    }

    50% {
        opacity: 1;
        transform: none
    }
}

.spinner-grow {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: text-bottom;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    animation: .75s linear infinite spinner-grow
}

.spinner-grow-sm {
    width: 1rem;
    height: 1rem
}

@media (prefers-reduced-motion:reduce) {

    .spinner-border,
    .spinner-grow {
        animation-duration: 1.5s
    }
}

.align-baseline {
    vertical-align: baseline !important
}

.align-top {
    vertical-align: top !important
}

.align-middle {
    vertical-align: middle !important
}

.align-bottom {
    vertical-align: bottom !important
}

.align-text-bottom {
    vertical-align: text-bottom !important
}

.align-text-top {
    vertical-align: text-top !important
}

.bg-primary {
    background-color: #4e73df !important
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
    background-color: #2653d4 !important
}

.bg-secondary {
    background-color: #858796 !important
}

a.bg-secondary:focus,
a.bg-secondary:hover,
button.bg-secondary:focus,
button.bg-secondary:hover {
    background-color: #6b6d7d !important
}

.bg-success {
    background-color: #1cc88a !important
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
    background-color: #169b6b !important
}

.bg-info {
    background-color: #36b9cc !important
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
    background-color: #2a96a5 !important
}

.bg-warning {
    background-color: #f6c23e !important
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
    background-color: #f4b30d !important
}

.bg-danger {
    background-color: #e74a3b !important
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
    background-color: #d52a1a !important
}

.bg-light {
    background-color: #f8f9fc !important
}

a.bg-light:focus,
a.bg-light:hover,
button.bg-light:focus,
button.bg-light:hover {
    background-color: #d4daed !important
}

.bg-dark {
    background-color: #5a5c69 !important
}

a.bg-dark:focus,
a.bg-dark:hover,
button.bg-dark:focus,
button.bg-dark:hover {
    background-color: #42444e !important
}

.bg-white {
    background-color: #fff !important
}

.bg-transparent {
    background-color: transparent !important
}

.border {
    border: 1px solid #e3e6f0 !important
}

.border-top {
    border-top: 1px solid #e3e6f0 !important
}

.border-right {
    border-right: 1px solid #e3e6f0 !important
}

.border-bottom {
    border-bottom: 1px solid #e3e6f0 !important
}

.border-left {
    border-left: 1px solid #e3e6f0 !important
}

.border-0 {
    border: 0 !important
}

.border-top-0 {
    border-top: 0 !important
}

.border-right-0 {
    border-right: 0 !important
}

.border-bottom-0 {
    border-bottom: 0 !important
}

.border-left-0 {
    border-left: 0 !important
}

.border-primary {
    border-color: #4e73df !important
}

.border-secondary {
    border-color: #858796 !important
}

.border-success {
    border-color: #1cc88a !important
}

.border-info {
    border-color: #36b9cc !important
}

.border-warning {
    border-color: #f6c23e !important
}

.border-danger {
    border-color: #e74a3b !important
}

.border-light {
    border-color: #f8f9fc !important
}

.border-dark {
    border-color: #5a5c69 !important
}

.border-white {
    border-color: #fff !important
}

.rounded-sm {
    border-radius: .2rem !important
}

.rounded {
    border-radius: .35rem !important
}

.rounded-top {
    border-top-left-radius: .35rem !important;
    border-top-right-radius: .35rem !important
}

.rounded-right {
    border-top-right-radius: .35rem !important;
    border-bottom-right-radius: .35rem !important
}

.rounded-bottom {
    border-bottom-right-radius: .35rem !important;
    border-bottom-left-radius: .35rem !important
}

.rounded-left {
    border-top-left-radius: .35rem !important;
    border-bottom-left-radius: .35rem !important
}

.rounded-lg {
    border-radius: .3rem !important
}

.rounded-circle {
    border-radius: 50% !important
}

.rounded-pill {
    border-radius: 50rem !important
}

.rounded-0 {
    border-radius: 0 !important
}

.clearfix::after {
    display: block;
    clear: both;
    content: ""
}

.d-none {
    display: none !important
}

.d-inline {
    display: inline !important
}

.d-inline-block {
    display: inline-block !important
}

.d-block {
    display: block !important
}

.d-table {
    display: table !important
}

.d-table-row {
    display: table-row !important
}

.d-table-cell {
    display: table-cell !important
}

.d-flex {
    display: flex !important
}

.d-inline-flex {
    display: inline-flex !important
}

@media (min-width:576px) {
    .d-sm-none {
        display: none !important
    }

    .d-sm-inline {
        display: inline !important
    }

    .d-sm-inline-block {
        display: inline-block !important
    }

    .d-sm-block {
        display: block !important
    }

    .d-sm-table {
        display: table !important
    }

    .d-sm-table-row {
        display: table-row !important
    }

    .d-sm-table-cell {
        display: table-cell !important
    }

    .d-sm-flex {
        display: flex !important
    }

    .d-sm-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width:768px) {
    .d-md-none {
        display: none !important
    }

    .d-md-inline {
        display: inline !important
    }

    .d-md-inline-block {
        display: inline-block !important
    }

    .d-md-block {
        display: block !important
    }

    .d-md-table {
        display: table !important
    }

    .d-md-table-row {
        display: table-row !important
    }

    .d-md-table-cell {
        display: table-cell !important
    }

    .d-md-flex {
        display: flex !important
    }

    .d-md-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width:992px) {
    .d-lg-none {
        display: none !important
    }

    .d-lg-inline {
        display: inline !important
    }

    .d-lg-inline-block {
        display: inline-block !important
    }

    .d-lg-block {
        display: block !important
    }

    .d-lg-table {
        display: table !important
    }

    .d-lg-table-row {
        display: table-row !important
    }

    .d-lg-table-cell {
        display: table-cell !important
    }

    .d-lg-flex {
        display: flex !important
    }

    .d-lg-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width:1200px) {
    .d-xl-none {
        display: none !important
    }

    .d-xl-inline {
        display: inline !important
    }

    .d-xl-inline-block {
        display: inline-block !important
    }

    .d-xl-block {
        display: block !important
    }

    .d-xl-table {
        display: table !important
    }

    .d-xl-table-row {
        display: table-row !important
    }

    .d-xl-table-cell {
        display: table-cell !important
    }

    .d-xl-flex {
        display: flex !important
    }

    .d-xl-inline-flex {
        display: inline-flex !important
    }
}

@media print {
    .d-print-none {
        display: none !important
    }

    .d-print-inline {
        display: inline !important
    }

    .d-print-inline-block {
        display: inline-block !important
    }

    .d-print-block {
        display: block !important
    }

    .d-print-table {
        display: table !important
    }

    .d-print-table-row {
        display: table-row !important
    }

    .d-print-table-cell {
        display: table-cell !important
    }

    .d-print-flex {
        display: flex !important
    }

    .d-print-inline-flex {
        display: inline-flex !important
    }
}

.embed-responsive {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden
}

.embed-responsive::before {
    display: block;
    content: ""
}

.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0
}

.embed-responsive-21by9::before {
    padding-top: 42.85714%
}

.embed-responsive-16by9::before {
    padding-top: 56.25%
}

.embed-responsive-4by3::before {
    padding-top: 75%
}

.embed-responsive-1by1::before {
    padding-top: 100%
}

.flex-row {
    flex-direction: row !important
}

.flex-column {
    flex-direction: column !important
}

.flex-row-reverse {
    flex-direction: row-reverse !important
}

.flex-column-reverse {
    flex-direction: column-reverse !important
}

.flex-wrap {
    flex-wrap: wrap !important
}

.flex-nowrap {
    flex-wrap: nowrap !important
}

.flex-wrap-reverse {
    flex-wrap: wrap-reverse !important
}

.flex-fill {
    flex: 1 1 auto !important
}

.flex-grow-0 {
    flex-grow: 0 !important
}

.flex-grow-1 {
    flex-grow: 1 !important
}

.flex-shrink-0 {
    flex-shrink: 0 !important
}

.flex-shrink-1 {
    flex-shrink: 1 !important
}

.justify-content-start {
    justify-content: flex-start !important
}

.justify-content-end {
    justify-content: flex-end !important
}

.justify-content-center {
    justify-content: center !important
}

.justify-content-between {
    justify-content: space-between !important
}

.justify-content-around {
    justify-content: space-around !important
}

.align-items-start {
    align-items: flex-start !important
}

.align-items-end {
    align-items: flex-end !important
}

.align-items-center {
    align-items: center !important
}

.align-items-baseline {
    align-items: baseline !important
}

.align-items-stretch {
    align-items: stretch !important
}

.align-content-start {
    align-content: flex-start !important
}

.align-content-end {
    align-content: flex-end !important
}

.align-content-center {
    align-content: center !important
}

.align-content-between {
    align-content: space-between !important
}

.align-content-around {
    align-content: space-around !important
}

.align-content-stretch {
    align-content: stretch !important
}

.align-self-auto {
    align-self: auto !important
}

.align-self-start {
    align-self: flex-start !important
}

.align-self-end {
    align-self: flex-end !important
}

.align-self-center {
    align-self: center !important
}

.align-self-baseline {
    align-self: baseline !important
}

.align-self-stretch {
    align-self: stretch !important
}

@media (min-width:576px) {
    .flex-sm-row {
        flex-direction: row !important
    }

    .flex-sm-column {
        flex-direction: column !important
    }

    .flex-sm-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-sm-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-sm-wrap {
        flex-wrap: wrap !important
    }

    .flex-sm-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-sm-fill {
        flex: 1 1 auto !important
    }

    .flex-sm-grow-0 {
        flex-grow: 0 !important
    }

    .flex-sm-grow-1 {
        flex-grow: 1 !important
    }

    .flex-sm-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-sm-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-sm-start {
        justify-content: flex-start !important
    }

    .justify-content-sm-end {
        justify-content: flex-end !important
    }

    .justify-content-sm-center {
        justify-content: center !important
    }

    .justify-content-sm-between {
        justify-content: space-between !important
    }

    .justify-content-sm-around {
        justify-content: space-around !important
    }

    .align-items-sm-start {
        align-items: flex-start !important
    }

    .align-items-sm-end {
        align-items: flex-end !important
    }

    .align-items-sm-center {
        align-items: center !important
    }

    .align-items-sm-baseline {
        align-items: baseline !important
    }

    .align-items-sm-stretch {
        align-items: stretch !important
    }

    .align-content-sm-start {
        align-content: flex-start !important
    }

    .align-content-sm-end {
        align-content: flex-end !important
    }

    .align-content-sm-center {
        align-content: center !important
    }

    .align-content-sm-between {
        align-content: space-between !important
    }

    .align-content-sm-around {
        align-content: space-around !important
    }

    .align-content-sm-stretch {
        align-content: stretch !important
    }

    .align-self-sm-auto {
        align-self: auto !important
    }

    .align-self-sm-start {
        align-self: flex-start !important
    }

    .align-self-sm-end {
        align-self: flex-end !important
    }

    .align-self-sm-center {
        align-self: center !important
    }

    .align-self-sm-baseline {
        align-self: baseline !important
    }

    .align-self-sm-stretch {
        align-self: stretch !important
    }
}

@media (min-width:768px) {
    .flex-md-row {
        flex-direction: row !important
    }

    .flex-md-column {
        flex-direction: column !important
    }

    .flex-md-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-md-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-md-wrap {
        flex-wrap: wrap !important
    }

    .flex-md-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-md-fill {
        flex: 1 1 auto !important
    }

    .flex-md-grow-0 {
        flex-grow: 0 !important
    }

    .flex-md-grow-1 {
        flex-grow: 1 !important
    }

    .flex-md-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-md-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-md-start {
        justify-content: flex-start !important
    }

    .justify-content-md-end {
        justify-content: flex-end !important
    }

    .justify-content-md-center {
        justify-content: center !important
    }

    .justify-content-md-between {
        justify-content: space-between !important
    }

    .justify-content-md-around {
        justify-content: space-around !important
    }

    .align-items-md-start {
        align-items: flex-start !important
    }

    .align-items-md-end {
        align-items: flex-end !important
    }

    .align-items-md-center {
        align-items: center !important
    }

    .align-items-md-baseline {
        align-items: baseline !important
    }

    .align-items-md-stretch {
        align-items: stretch !important
    }

    .align-content-md-start {
        align-content: flex-start !important
    }

    .align-content-md-end {
        align-content: flex-end !important
    }

    .align-content-md-center {
        align-content: center !important
    }

    .align-content-md-between {
        align-content: space-between !important
    }

    .align-content-md-around {
        align-content: space-around !important
    }

    .align-content-md-stretch {
        align-content: stretch !important
    }

    .align-self-md-auto {
        align-self: auto !important
    }

    .align-self-md-start {
        align-self: flex-start !important
    }

    .align-self-md-end {
        align-self: flex-end !important
    }

    .align-self-md-center {
        align-self: center !important
    }

    .align-self-md-baseline {
        align-self: baseline !important
    }

    .align-self-md-stretch {
        align-self: stretch !important
    }
}

@media (min-width:992px) {
    .flex-lg-row {
        flex-direction: row !important
    }

    .flex-lg-column {
        flex-direction: column !important
    }

    .flex-lg-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-lg-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-lg-wrap {
        flex-wrap: wrap !important
    }

    .flex-lg-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-lg-fill {
        flex: 1 1 auto !important
    }

    .flex-lg-grow-0 {
        flex-grow: 0 !important
    }

    .flex-lg-grow-1 {
        flex-grow: 1 !important
    }

    .flex-lg-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-lg-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-lg-start {
        justify-content: flex-start !important
    }

    .justify-content-lg-end {
        justify-content: flex-end !important
    }

    .justify-content-lg-center {
        justify-content: center !important
    }

    .justify-content-lg-between {
        justify-content: space-between !important
    }

    .justify-content-lg-around {
        justify-content: space-around !important
    }

    .align-items-lg-start {
        align-items: flex-start !important
    }

    .align-items-lg-end {
        align-items: flex-end !important
    }

    .align-items-lg-center {
        align-items: center !important
    }

    .align-items-lg-baseline {
        align-items: baseline !important
    }

    .align-items-lg-stretch {
        align-items: stretch !important
    }

    .align-content-lg-start {
        align-content: flex-start !important
    }

    .align-content-lg-end {
        align-content: flex-end !important
    }

    .align-content-lg-center {
        align-content: center !important
    }

    .align-content-lg-between {
        align-content: space-between !important
    }

    .align-content-lg-around {
        align-content: space-around !important
    }

    .align-content-lg-stretch {
        align-content: stretch !important
    }

    .align-self-lg-auto {
        align-self: auto !important
    }

    .align-self-lg-start {
        align-self: flex-start !important
    }

    .align-self-lg-end {
        align-self: flex-end !important
    }

    .align-self-lg-center {
        align-self: center !important
    }

    .align-self-lg-baseline {
        align-self: baseline !important
    }

    .align-self-lg-stretch {
        align-self: stretch !important
    }
}

@media (min-width:1200px) {
    .flex-xl-row {
        flex-direction: row !important
    }

    .flex-xl-column {
        flex-direction: column !important
    }

    .flex-xl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-xl-fill {
        flex: 1 1 auto !important
    }

    .flex-xl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xl-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-xl-start {
        justify-content: flex-start !important
    }

    .justify-content-xl-end {
        justify-content: flex-end !important
    }

    .justify-content-xl-center {
        justify-content: center !important
    }

    .justify-content-xl-between {
        justify-content: space-between !important
    }

    .justify-content-xl-around {
        justify-content: space-around !important
    }

    .align-items-xl-start {
        align-items: flex-start !important
    }

    .align-items-xl-end {
        align-items: flex-end !important
    }

    .align-items-xl-center {
        align-items: center !important
    }

    .align-items-xl-baseline {
        align-items: baseline !important
    }

    .align-items-xl-stretch {
        align-items: stretch !important
    }

    .align-content-xl-start {
        align-content: flex-start !important
    }

    .align-content-xl-end {
        align-content: flex-end !important
    }

    .align-content-xl-center {
        align-content: center !important
    }

    .align-content-xl-between {
        align-content: space-between !important
    }

    .align-content-xl-around {
        align-content: space-around !important
    }

    .align-content-xl-stretch {
        align-content: stretch !important
    }

    .align-self-xl-auto {
        align-self: auto !important
    }

    .align-self-xl-start {
        align-self: flex-start !important
    }

    .align-self-xl-end {
        align-self: flex-end !important
    }

    .align-self-xl-center {
        align-self: center !important
    }

    .align-self-xl-baseline {
        align-self: baseline !important
    }

    .align-self-xl-stretch {
        align-self: stretch !important
    }
}

.float-left {
    float: left !important
}

.float-right {
    float: right !important
}

.float-none {
    float: none !important
}

@media (min-width:576px) {
    .float-sm-left {
        float: left !important
    }

    .float-sm-right {
        float: right !important
    }

    .float-sm-none {
        float: none !important
    }
}

@media (min-width:768px) {
    .float-md-left {
        float: left !important
    }

    .float-md-right {
        float: right !important
    }

    .float-md-none {
        float: none !important
    }
}

@media (min-width:992px) {
    .float-lg-left {
        float: left !important
    }

    .float-lg-right {
        float: right !important
    }

    .float-lg-none {
        float: none !important
    }
}

@media (min-width:1200px) {
    .float-xl-left {
        float: left !important
    }

    .float-xl-right {
        float: right !important
    }

    .float-xl-none {
        float: none !important
    }
}

.user-select-all {
    -webkit-user-select: all !important;
    user-select: all !important
}

.user-select-auto {
    -webkit-user-select: auto !important;
    user-select: auto !important
}

.user-select-none {
    -webkit-user-select: none !important;
    user-select: none !important
}

.overflow-auto {
    overflow: auto !important
}

.overflow-hidden {
    overflow: hidden !important
}

.position-static {
    position: static !important
}

.position-relative {
    position: relative !important
}

.position-absolute {
    position: absolute !important
}

.position-fixed {
    position: fixed !important
}

.position-sticky {
    position: sticky !important
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030
}

@supports (position:sticky) {
    .sticky-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal
}

.shadow-sm {
    box-shadow: 0 .125rem .25rem 0 rgba(58, 59, 69, .2) !important
}

.shadow {
    box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important
}

.shadow-none {
    box-shadow: none !important
}

.w-25 {
    width: 25% !important
}

.w-50 {
    width: 50% !important
}

.w-75 {
    width: 75% !important
}

.w-100 {
    width: 100% !important
}

.w-auto {
    width: auto !important
}

.h-25 {
    height: 25% !important
}

.h-50 {
    height: 50% !important
}

.h-75 {
    height: 75% !important
}

.h-100 {
    height: 100% !important
}

.h-auto {
    height: auto !important
}

.mw-100 {
    max-width: 100% !important
}

.mh-100 {
    max-height: 100% !important
}

.min-vw-100 {
    min-width: 100vw !important
}

.min-vh-100 {
    min-height: 100vh !important
}

.vw-100 {
    width: 100vw !important
}

.vh-100 {
    height: 100vh !important
}

.m-0 {
    margin: 0 !important
}

.mt-0,
.my-0 {
    margin-top: 0 !important
}

.mr-0,
.mx-0 {
    margin-right: 0 !important
}

.mb-0,
.my-0 {
    margin-bottom: 0 !important
}

.ml-0,
.mx-0 {
    margin-left: 0 !important
}

.m-1 {
    margin: .25rem !important
}

.mt-1,
.my-1 {
    margin-top: .25rem !important
}

.mr-1,
.mx-1 {
    margin-right: .25rem !important
}

.mb-1,
.my-1 {
    margin-bottom: .25rem !important
}

.ml-1,
.mx-1 {
    margin-left: .25rem !important
}

.m-2 {
    margin: .5rem !important
}

.mt-2,
.my-2 {
    margin-top: .5rem !important
}

.mr-2,
.mx-2 {
    margin-right: .5rem !important
}

.mb-2,
.my-2 {
    margin-bottom: .5rem !important
}

.ml-2,
.mx-2 {
    margin-left: .5rem !important
}

.m-3 {
    margin: 1rem !important
}

.mt-3,
.my-3 {
    margin-top: 1rem !important
}

.mr-3,
.mx-3 {
    margin-right: 1rem !important
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important
}

.ml-3,
.mx-3 {
    margin-left: 1rem !important
}

.m-4 {
    margin: 1.5rem !important
}

.mt-4,
.my-4 {
    margin-top: 1.5rem !important
}

.mr-4,
.mx-4 {
    margin-right: 1.5rem !important
}

.mb-4,
.my-4 {
    margin-bottom: 1.5rem !important
}

.ml-4,
.mx-4 {
    margin-left: 1.5rem !important
}

.m-5 {
    margin: 3rem !important
}

.mt-5,
.my-5 {
    margin-top: 3rem !important
}

.mr-5,
.mx-5 {
    margin-right: 3rem !important
}

.mb-5,
.my-5 {
    margin-bottom: 3rem !important
}

.ml-5,
.mx-5 {
    margin-left: 3rem !important
}

.p-0 {
    padding: 0 !important
}

.pt-0,
.py-0 {
    padding-top: 0 !important
}

.pr-0,
.px-0 {
    padding-right: 0 !important
}

.pb-0,
.py-0 {
    padding-bottom: 0 !important
}

.pl-0,
.px-0 {
    padding-left: 0 !important
}

.p-1 {
    padding: .25rem !important
}

.pt-1,
.py-1 {
    padding-top: .25rem !important
}

.pr-1,
.px-1 {
    padding-right: .25rem !important
}

.pb-1,
.py-1 {
    padding-bottom: .25rem !important
}

.pl-1,
.px-1 {
    padding-left: .25rem !important
}

.p-2 {
    padding: .5rem !important
}

.pt-2,
.py-2 {
    padding-top: .5rem !important
}

.pr-2,
.px-2 {
    padding-right: .5rem !important
}

.pb-2,
.py-2 {
    padding-bottom: .5rem !important
}

.pl-2,
.px-2 {
    padding-left: .5rem !important
}

.p-3 {
    padding: 1rem !important
}

.pt-3,
.py-3 {
    padding-top: 1rem !important
}

.pr-3,
.px-3 {
    padding-right: 1rem !important
}

.pb-3,
.py-3 {
    padding-bottom: 1rem !important
}

.pl-3,
.px-3 {
    padding-left: 1rem !important
}

.p-4 {
    padding: 1.5rem !important
}

.pt-4,
.py-4 {
    padding-top: 1.5rem !important
}

.pr-4,
.px-4 {
    padding-right: 1.5rem !important
}

.pb-4,
.py-4 {
    padding-bottom: 1.5rem !important
}

.pl-4,
.px-4 {
    padding-left: 1.5rem !important
}

.p-5 {
    padding: 3rem !important
}

.pt-5,
.py-5 {
    padding-top: 3rem !important
}

.pr-5,
.px-5 {
    padding-right: 3rem !important
}

.pb-5,
.py-5 {
    padding-bottom: 3rem !important
}

.pl-5,
.px-5 {
    padding-left: 3rem !important
}

.m-n1 {
    margin: -.25rem !important
}

.mt-n1,
.my-n1 {
    margin-top: -.25rem !important
}

.mr-n1,
.mx-n1 {
    margin-right: -.25rem !important
}

.mb-n1,
.my-n1 {
    margin-bottom: -.25rem !important
}

.ml-n1,
.mx-n1 {
    margin-left: -.25rem !important
}

.m-n2 {
    margin: -.5rem !important
}

.mt-n2,
.my-n2 {
    margin-top: -.5rem !important
}

.mr-n2,
.mx-n2 {
    margin-right: -.5rem !important
}

.mb-n2,
.my-n2 {
    margin-bottom: -.5rem !important
}

.ml-n2,
.mx-n2 {
    margin-left: -.5rem !important
}

.m-n3 {
    margin: -1rem !important
}

.mt-n3,
.my-n3 {
    margin-top: -1rem !important
}

.mr-n3,
.mx-n3 {
    margin-right: -1rem !important
}

.mb-n3,
.my-n3 {
    margin-bottom: -1rem !important
}

.ml-n3,
.mx-n3 {
    margin-left: -1rem !important
}

.m-n4 {
    margin: -1.5rem !important
}

.mt-n4,
.my-n4 {
    margin-top: -1.5rem !important
}

.mr-n4,
.mx-n4 {
    margin-right: -1.5rem !important
}

.mb-n4,
.my-n4 {
    margin-bottom: -1.5rem !important
}

.ml-n4,
.mx-n4 {
    margin-left: -1.5rem !important
}

.m-n5 {
    margin: -3rem !important
}

.mt-n5,
.my-n5 {
    margin-top: -3rem !important
}

.mr-n5,
.mx-n5 {
    margin-right: -3rem !important
}

.mb-n5,
.my-n5 {
    margin-bottom: -3rem !important
}

.ml-n5,
.mx-n5 {
    margin-left: -3rem !important
}

.m-auto {
    margin: auto !important
}

.mt-auto,
.my-auto {
    margin-top: auto !important
}

.mr-auto,
.mx-auto {
    margin-right: auto !important
}

.mb-auto,
.my-auto {
    margin-bottom: auto !important
}

.ml-auto,
.mx-auto {
    margin-left: auto !important
}

@media (min-width:576px) {
    .m-sm-0 {
        margin: 0 !important
    }

    .mt-sm-0,
    .my-sm-0 {
        margin-top: 0 !important
    }

    .mr-sm-0,
    .mx-sm-0 {
        margin-right: 0 !important
    }

    .mb-sm-0,
    .my-sm-0 {
        margin-bottom: 0 !important
    }

    .ml-sm-0,
    .mx-sm-0 {
        margin-left: 0 !important
    }

    .m-sm-1 {
        margin: .25rem !important
    }

    .mt-sm-1,
    .my-sm-1 {
        margin-top: .25rem !important
    }

    .mr-sm-1,
    .mx-sm-1 {
        margin-right: .25rem !important
    }

    .mb-sm-1,
    .my-sm-1 {
        margin-bottom: .25rem !important
    }

    .ml-sm-1,
    .mx-sm-1 {
        margin-left: .25rem !important
    }

    .m-sm-2 {
        margin: .5rem !important
    }

    .mt-sm-2,
    .my-sm-2 {
        margin-top: .5rem !important
    }

    .mr-sm-2,
    .mx-sm-2 {
        margin-right: .5rem !important
    }

    .mb-sm-2,
    .my-sm-2 {
        margin-bottom: .5rem !important
    }

    .ml-sm-2,
    .mx-sm-2 {
        margin-left: .5rem !important
    }

    .m-sm-3 {
        margin: 1rem !important
    }

    .mt-sm-3,
    .my-sm-3 {
        margin-top: 1rem !important
    }

    .mr-sm-3,
    .mx-sm-3 {
        margin-right: 1rem !important
    }

    .mb-sm-3,
    .my-sm-3 {
        margin-bottom: 1rem !important
    }

    .ml-sm-3,
    .mx-sm-3 {
        margin-left: 1rem !important
    }

    .m-sm-4 {
        margin: 1.5rem !important
    }

    .mt-sm-4,
    .my-sm-4 {
        margin-top: 1.5rem !important
    }

    .mr-sm-4,
    .mx-sm-4 {
        margin-right: 1.5rem !important
    }

    .mb-sm-4,
    .my-sm-4 {
        margin-bottom: 1.5rem !important
    }

    .ml-sm-4,
    .mx-sm-4 {
        margin-left: 1.5rem !important
    }

    .m-sm-5 {
        margin: 3rem !important
    }

    .mt-sm-5,
    .my-sm-5 {
        margin-top: 3rem !important
    }

    .mr-sm-5,
    .mx-sm-5 {
        margin-right: 3rem !important
    }

    .mb-sm-5,
    .my-sm-5 {
        margin-bottom: 3rem !important
    }

    .ml-sm-5,
    .mx-sm-5 {
        margin-left: 3rem !important
    }

    .p-sm-0 {
        padding: 0 !important
    }

    .pt-sm-0,
    .py-sm-0 {
        padding-top: 0 !important
    }

    .pr-sm-0,
    .px-sm-0 {
        padding-right: 0 !important
    }

    .pb-sm-0,
    .py-sm-0 {
        padding-bottom: 0 !important
    }

    .pl-sm-0,
    .px-sm-0 {
        padding-left: 0 !important
    }

    .p-sm-1 {
        padding: .25rem !important
    }

    .pt-sm-1,
    .py-sm-1 {
        padding-top: .25rem !important
    }

    .pr-sm-1,
    .px-sm-1 {
        padding-right: .25rem !important
    }

    .pb-sm-1,
    .py-sm-1 {
        padding-bottom: .25rem !important
    }

    .pl-sm-1,
    .px-sm-1 {
        padding-left: .25rem !important
    }

    .p-sm-2 {
        padding: .5rem !important
    }

    .pt-sm-2,
    .py-sm-2 {
        padding-top: .5rem !important
    }

    .pr-sm-2,
    .px-sm-2 {
        padding-right: .5rem !important
    }

    .pb-sm-2,
    .py-sm-2 {
        padding-bottom: .5rem !important
    }

    .pl-sm-2,
    .px-sm-2 {
        padding-left: .5rem !important
    }

    .p-sm-3 {
        padding: 1rem !important
    }

    .pt-sm-3,
    .py-sm-3 {
        padding-top: 1rem !important
    }

    .pr-sm-3,
    .px-sm-3 {
        padding-right: 1rem !important
    }

    .pb-sm-3,
    .py-sm-3 {
        padding-bottom: 1rem !important
    }

    .pl-sm-3,
    .px-sm-3 {
        padding-left: 1rem !important
    }

    .p-sm-4 {
        padding: 1.5rem !important
    }

    .pt-sm-4,
    .py-sm-4 {
        padding-top: 1.5rem !important
    }

    .pr-sm-4,
    .px-sm-4 {
        padding-right: 1.5rem !important
    }

    .pb-sm-4,
    .py-sm-4 {
        padding-bottom: 1.5rem !important
    }

    .pl-sm-4,
    .px-sm-4 {
        padding-left: 1.5rem !important
    }

    .p-sm-5 {
        padding: 3rem !important
    }

    .pt-sm-5,
    .py-sm-5 {
        padding-top: 3rem !important
    }

    .pr-sm-5,
    .px-sm-5 {
        padding-right: 3rem !important
    }

    .pb-sm-5,
    .py-sm-5 {
        padding-bottom: 3rem !important
    }

    .pl-sm-5,
    .px-sm-5 {
        padding-left: 3rem !important
    }

    .m-sm-n1 {
        margin: -.25rem !important
    }

    .mt-sm-n1,
    .my-sm-n1 {
        margin-top: -.25rem !important
    }

    .mr-sm-n1,
    .mx-sm-n1 {
        margin-right: -.25rem !important
    }

    .mb-sm-n1,
    .my-sm-n1 {
        margin-bottom: -.25rem !important
    }

    .ml-sm-n1,
    .mx-sm-n1 {
        margin-left: -.25rem !important
    }

    .m-sm-n2 {
        margin: -.5rem !important
    }

    .mt-sm-n2,
    .my-sm-n2 {
        margin-top: -.5rem !important
    }

    .mr-sm-n2,
    .mx-sm-n2 {
        margin-right: -.5rem !important
    }

    .mb-sm-n2,
    .my-sm-n2 {
        margin-bottom: -.5rem !important
    }

    .ml-sm-n2,
    .mx-sm-n2 {
        margin-left: -.5rem !important
    }

    .m-sm-n3 {
        margin: -1rem !important
    }

    .mt-sm-n3,
    .my-sm-n3 {
        margin-top: -1rem !important
    }

    .mr-sm-n3,
    .mx-sm-n3 {
        margin-right: -1rem !important
    }

    .mb-sm-n3,
    .my-sm-n3 {
        margin-bottom: -1rem !important
    }

    .ml-sm-n3,
    .mx-sm-n3 {
        margin-left: -1rem !important
    }

    .m-sm-n4 {
        margin: -1.5rem !important
    }

    .mt-sm-n4,
    .my-sm-n4 {
        margin-top: -1.5rem !important
    }

    .mr-sm-n4,
    .mx-sm-n4 {
        margin-right: -1.5rem !important
    }

    .mb-sm-n4,
    .my-sm-n4 {
        margin-bottom: -1.5rem !important
    }

    .ml-sm-n4,
    .mx-sm-n4 {
        margin-left: -1.5rem !important
    }

    .m-sm-n5 {
        margin: -3rem !important
    }

    .mt-sm-n5,
    .my-sm-n5 {
        margin-top: -3rem !important
    }

    .mr-sm-n5,
    .mx-sm-n5 {
        margin-right: -3rem !important
    }

    .mb-sm-n5,
    .my-sm-n5 {
        margin-bottom: -3rem !important
    }

    .ml-sm-n5,
    .mx-sm-n5 {
        margin-left: -3rem !important
    }

    .m-sm-auto {
        margin: auto !important
    }

    .mt-sm-auto,
    .my-sm-auto {
        margin-top: auto !important
    }

    .mr-sm-auto,
    .mx-sm-auto {
        margin-right: auto !important
    }

    .mb-sm-auto,
    .my-sm-auto {
        margin-bottom: auto !important
    }

    .ml-sm-auto,
    .mx-sm-auto {
        margin-left: auto !important
    }
}

@media (min-width:768px) {
    .m-md-0 {
        margin: 0 !important
    }

    .mt-md-0,
    .my-md-0 {
        margin-top: 0 !important
    }

    .mr-md-0,
    .mx-md-0 {
        margin-right: 0 !important
    }

    .mb-md-0,
    .my-md-0 {
        margin-bottom: 0 !important
    }

    .ml-md-0,
    .mx-md-0 {
        margin-left: 0 !important
    }

    .m-md-1 {
        margin: .25rem !important
    }

    .mt-md-1,
    .my-md-1 {
        margin-top: .25rem !important
    }

    .mr-md-1,
    .mx-md-1 {
        margin-right: .25rem !important
    }

    .mb-md-1,
    .my-md-1 {
        margin-bottom: .25rem !important
    }

    .ml-md-1,
    .mx-md-1 {
        margin-left: .25rem !important
    }

    .m-md-2 {
        margin: .5rem !important
    }

    .mt-md-2,
    .my-md-2 {
        margin-top: .5rem !important
    }

    .mr-md-2,
    .mx-md-2 {
        margin-right: .5rem !important
    }

    .mb-md-2,
    .my-md-2 {
        margin-bottom: .5rem !important
    }

    .ml-md-2,
    .mx-md-2 {
        margin-left: .5rem !important
    }

    .m-md-3 {
        margin: 1rem !important
    }

    .mt-md-3,
    .my-md-3 {
        margin-top: 1rem !important
    }

    .mr-md-3,
    .mx-md-3 {
        margin-right: 1rem !important
    }

    .mb-md-3,
    .my-md-3 {
        margin-bottom: 1rem !important
    }

    .ml-md-3,
    .mx-md-3 {
        margin-left: 1rem !important
    }

    .m-md-4 {
        margin: 1.5rem !important
    }

    .mt-md-4,
    .my-md-4 {
        margin-top: 1.5rem !important
    }

    .mr-md-4,
    .mx-md-4 {
        margin-right: 1.5rem !important
    }

    .mb-md-4,
    .my-md-4 {
        margin-bottom: 1.5rem !important
    }

    .ml-md-4,
    .mx-md-4 {
        margin-left: 1.5rem !important
    }

    .m-md-5 {
        margin: 3rem !important
    }

    .mt-md-5,
    .my-md-5 {
        margin-top: 3rem !important
    }

    .mr-md-5,
    .mx-md-5 {
        margin-right: 3rem !important
    }

    .mb-md-5,
    .my-md-5 {
        margin-bottom: 3rem !important
    }

    .ml-md-5,
    .mx-md-5 {
        margin-left: 3rem !important
    }

    .p-md-0 {
        padding: 0 !important
    }

    .pt-md-0,
    .py-md-0 {
        padding-top: 0 !important
    }

    .pr-md-0,
    .px-md-0 {
        padding-right: 0 !important
    }

    .pb-md-0,
    .py-md-0 {
        padding-bottom: 0 !important
    }

    .pl-md-0,
    .px-md-0 {
        padding-left: 0 !important
    }

    .p-md-1 {
        padding: .25rem !important
    }

    .pt-md-1,
    .py-md-1 {
        padding-top: .25rem !important
    }

    .pr-md-1,
    .px-md-1 {
        padding-right: .25rem !important
    }

    .pb-md-1,
    .py-md-1 {
        padding-bottom: .25rem !important
    }

    .pl-md-1,
    .px-md-1 {
        padding-left: .25rem !important
    }

    .p-md-2 {
        padding: .5rem !important
    }

    .pt-md-2,
    .py-md-2 {
        padding-top: .5rem !important
    }

    .pr-md-2,
    .px-md-2 {
        padding-right: .5rem !important
    }

    .pb-md-2,
    .py-md-2 {
        padding-bottom: .5rem !important
    }

    .pl-md-2,
    .px-md-2 {
        padding-left: .5rem !important
    }

    .p-md-3 {
        padding: 1rem !important
    }

    .pt-md-3,
    .py-md-3 {
        padding-top: 1rem !important
    }

    .pr-md-3,
    .px-md-3 {
        padding-right: 1rem !important
    }

    .pb-md-3,
    .py-md-3 {
        padding-bottom: 1rem !important
    }

    .pl-md-3,
    .px-md-3 {
        padding-left: 1rem !important
    }

    .p-md-4 {
        padding: 1.5rem !important
    }

    .pt-md-4,
    .py-md-4 {
        padding-top: 1.5rem !important
    }

    .pr-md-4,
    .px-md-4 {
        padding-right: 1.5rem !important
    }

    .pb-md-4,
    .py-md-4 {
        padding-bottom: 1.5rem !important
    }

    .pl-md-4,
    .px-md-4 {
        padding-left: 1.5rem !important
    }

    .p-md-5 {
        padding: 3rem !important
    }

    .pt-md-5,
    .py-md-5 {
        padding-top: 3rem !important
    }

    .pr-md-5,
    .px-md-5 {
        padding-right: 3rem !important
    }

    .pb-md-5,
    .py-md-5 {
        padding-bottom: 3rem !important
    }

    .pl-md-5,
    .px-md-5 {
        padding-left: 3rem !important
    }

    .m-md-n1 {
        margin: -.25rem !important
    }

    .mt-md-n1,
    .my-md-n1 {
        margin-top: -.25rem !important
    }

    .mr-md-n1,
    .mx-md-n1 {
        margin-right: -.25rem !important
    }

    .mb-md-n1,
    .my-md-n1 {
        margin-bottom: -.25rem !important
    }

    .ml-md-n1,
    .mx-md-n1 {
        margin-left: -.25rem !important
    }

    .m-md-n2 {
        margin: -.5rem !important
    }

    .mt-md-n2,
    .my-md-n2 {
        margin-top: -.5rem !important
    }

    .mr-md-n2,
    .mx-md-n2 {
        margin-right: -.5rem !important
    }

    .mb-md-n2,
    .my-md-n2 {
        margin-bottom: -.5rem !important
    }

    .ml-md-n2,
    .mx-md-n2 {
        margin-left: -.5rem !important
    }

    .m-md-n3 {
        margin: -1rem !important
    }

    .mt-md-n3,
    .my-md-n3 {
        margin-top: -1rem !important
    }

    .mr-md-n3,
    .mx-md-n3 {
        margin-right: -1rem !important
    }

    .mb-md-n3,
    .my-md-n3 {
        margin-bottom: -1rem !important
    }

    .ml-md-n3,
    .mx-md-n3 {
        margin-left: -1rem !important
    }

    .m-md-n4 {
        margin: -1.5rem !important
    }

    .mt-md-n4,
    .my-md-n4 {
        margin-top: -1.5rem !important
    }

    .mr-md-n4,
    .mx-md-n4 {
        margin-right: -1.5rem !important
    }

    .mb-md-n4,
    .my-md-n4 {
        margin-bottom: -1.5rem !important
    }

    .ml-md-n4,
    .mx-md-n4 {
        margin-left: -1.5rem !important
    }

    .m-md-n5 {
        margin: -3rem !important
    }

    .mt-md-n5,
    .my-md-n5 {
        margin-top: -3rem !important
    }

    .mr-md-n5,
    .mx-md-n5 {
        margin-right: -3rem !important
    }

    .mb-md-n5,
    .my-md-n5 {
        margin-bottom: -3rem !important
    }

    .ml-md-n5,
    .mx-md-n5 {
        margin-left: -3rem !important
    }

    .m-md-auto {
        margin: auto !important
    }

    .mt-md-auto,
    .my-md-auto {
        margin-top: auto !important
    }

    .mr-md-auto,
    .mx-md-auto {
        margin-right: auto !important
    }

    .mb-md-auto,
    .my-md-auto {
        margin-bottom: auto !important
    }

    .ml-md-auto,
    .mx-md-auto {
        margin-left: auto !important
    }
}

@media (min-width:992px) {
    .m-lg-0 {
        margin: 0 !important
    }

    .mt-lg-0,
    .my-lg-0 {
        margin-top: 0 !important
    }

    .mr-lg-0,
    .mx-lg-0 {
        margin-right: 0 !important
    }

    .mb-lg-0,
    .my-lg-0 {
        margin-bottom: 0 !important
    }

    .ml-lg-0,
    .mx-lg-0 {
        margin-left: 0 !important
    }

    .m-lg-1 {
        margin: .25rem !important
    }

    .mt-lg-1,
    .my-lg-1 {
        margin-top: .25rem !important
    }

    .mr-lg-1,
    .mx-lg-1 {
        margin-right: .25rem !important
    }

    .mb-lg-1,
    .my-lg-1 {
        margin-bottom: .25rem !important
    }

    .ml-lg-1,
    .mx-lg-1 {
        margin-left: .25rem !important
    }

    .m-lg-2 {
        margin: .5rem !important
    }

    .mt-lg-2,
    .my-lg-2 {
        margin-top: .5rem !important
    }

    .mr-lg-2,
    .mx-lg-2 {
        margin-right: .5rem !important
    }

    .mb-lg-2,
    .my-lg-2 {
        margin-bottom: .5rem !important
    }

    .ml-lg-2,
    .mx-lg-2 {
        margin-left: .5rem !important
    }

    .m-lg-3 {
        margin: 1rem !important
    }

    .mt-lg-3,
    .my-lg-3 {
        margin-top: 1rem !important
    }

    .mr-lg-3,
    .mx-lg-3 {
        margin-right: 1rem !important
    }

    .mb-lg-3,
    .my-lg-3 {
        margin-bottom: 1rem !important
    }

    .ml-lg-3,
    .mx-lg-3 {
        margin-left: 1rem !important
    }

    .m-lg-4 {
        margin: 1.5rem !important
    }

    .mt-lg-4,
    .my-lg-4 {
        margin-top: 1.5rem !important
    }

    .mr-lg-4,
    .mx-lg-4 {
        margin-right: 1.5rem !important
    }

    .mb-lg-4,
    .my-lg-4 {
        margin-bottom: 1.5rem !important
    }

    .ml-lg-4,
    .mx-lg-4 {
        margin-left: 1.5rem !important
    }

    .m-lg-5 {
        margin: 3rem !important
    }

    .mt-lg-5,
    .my-lg-5 {
        margin-top: 3rem !important
    }

    .mr-lg-5,
    .mx-lg-5 {
        margin-right: 3rem !important
    }

    .mb-lg-5,
    .my-lg-5 {
        margin-bottom: 3rem !important
    }

    .ml-lg-5,
    .mx-lg-5 {
        margin-left: 3rem !important
    }

    .p-lg-0 {
        padding: 0 !important
    }

    .pt-lg-0,
    .py-lg-0 {
        padding-top: 0 !important
    }

    .pr-lg-0,
    .px-lg-0 {
        padding-right: 0 !important
    }

    .pb-lg-0,
    .py-lg-0 {
        padding-bottom: 0 !important
    }

    .pl-lg-0,
    .px-lg-0 {
        padding-left: 0 !important
    }

    .p-lg-1 {
        padding: .25rem !important
    }

    .pt-lg-1,
    .py-lg-1 {
        padding-top: .25rem !important
    }

    .pr-lg-1,
    .px-lg-1 {
        padding-right: .25rem !important
    }

    .pb-lg-1,
    .py-lg-1 {
        padding-bottom: .25rem !important
    }

    .pl-lg-1,
    .px-lg-1 {
        padding-left: .25rem !important
    }

    .p-lg-2 {
        padding: .5rem !important
    }

    .pt-lg-2,
    .py-lg-2 {
        padding-top: .5rem !important
    }

    .pr-lg-2,
    .px-lg-2 {
        padding-right: .5rem !important
    }

    .pb-lg-2,
    .py-lg-2 {
        padding-bottom: .5rem !important
    }

    .pl-lg-2,
    .px-lg-2 {
        padding-left: .5rem !important
    }

    .p-lg-3 {
        padding: 1rem !important
    }

    .pt-lg-3,
    .py-lg-3 {
        padding-top: 1rem !important
    }

    .pr-lg-3,
    .px-lg-3 {
        padding-right: 1rem !important
    }

    .pb-lg-3,
    .py-lg-3 {
        padding-bottom: 1rem !important
    }

    .pl-lg-3,
    .px-lg-3 {
        padding-left: 1rem !important
    }

    .p-lg-4 {
        padding: 1.5rem !important
    }

    .pt-lg-4,
    .py-lg-4 {
        padding-top: 1.5rem !important
    }

    .pr-lg-4,
    .px-lg-4 {
        padding-right: 1.5rem !important
    }

    .pb-lg-4,
    .py-lg-4 {
        padding-bottom: 1.5rem !important
    }

    .pl-lg-4,
    .px-lg-4 {
        padding-left: 1.5rem !important
    }

    .p-lg-5 {
        padding: 3rem !important
    }

    .pt-lg-5,
    .py-lg-5 {
        padding-top: 3rem !important
    }

    .pr-lg-5,
    .px-lg-5 {
        padding-right: 3rem !important
    }

    .pb-lg-5,
    .py-lg-5 {
        padding-bottom: 3rem !important
    }

    .pl-lg-5,
    .px-lg-5 {
        padding-left: 3rem !important
    }

    .m-lg-n1 {
        margin: -.25rem !important
    }

    .mt-lg-n1,
    .my-lg-n1 {
        margin-top: -.25rem !important
    }

    .mr-lg-n1,
    .mx-lg-n1 {
        margin-right: -.25rem !important
    }

    .mb-lg-n1,
    .my-lg-n1 {
        margin-bottom: -.25rem !important
    }

    .ml-lg-n1,
    .mx-lg-n1 {
        margin-left: -.25rem !important
    }

    .m-lg-n2 {
        margin: -.5rem !important
    }

    .mt-lg-n2,
    .my-lg-n2 {
        margin-top: -.5rem !important
    }

    .mr-lg-n2,
    .mx-lg-n2 {
        margin-right: -.5rem !important
    }

    .mb-lg-n2,
    .my-lg-n2 {
        margin-bottom: -.5rem !important
    }

    .ml-lg-n2,
    .mx-lg-n2 {
        margin-left: -.5rem !important
    }

    .m-lg-n3 {
        margin: -1rem !important
    }

    .mt-lg-n3,
    .my-lg-n3 {
        margin-top: -1rem !important
    }

    .mr-lg-n3,
    .mx-lg-n3 {
        margin-right: -1rem !important
    }

    .mb-lg-n3,
    .my-lg-n3 {
        margin-bottom: -1rem !important
    }

    .ml-lg-n3,
    .mx-lg-n3 {
        margin-left: -1rem !important
    }

    .m-lg-n4 {
        margin: -1.5rem !important
    }

    .mt-lg-n4,
    .my-lg-n4 {
        margin-top: -1.5rem !important
    }

    .mr-lg-n4,
    .mx-lg-n4 {
        margin-right: -1.5rem !important
    }

    .mb-lg-n4,
    .my-lg-n4 {
        margin-bottom: -1.5rem !important
    }

    .ml-lg-n4,
    .mx-lg-n4 {
        margin-left: -1.5rem !important
    }

    .m-lg-n5 {
        margin: -3rem !important
    }

    .mt-lg-n5,
    .my-lg-n5 {
        margin-top: -3rem !important
    }

    .mr-lg-n5,
    .mx-lg-n5 {
        margin-right: -3rem !important
    }

    .mb-lg-n5,
    .my-lg-n5 {
        margin-bottom: -3rem !important
    }

    .ml-lg-n5,
    .mx-lg-n5 {
        margin-left: -3rem !important
    }

    .m-lg-auto {
        margin: auto !important
    }

    .mt-lg-auto,
    .my-lg-auto {
        margin-top: auto !important
    }

    .mr-lg-auto,
    .mx-lg-auto {
        margin-right: auto !important
    }

    .mb-lg-auto,
    .my-lg-auto {
        margin-bottom: auto !important
    }

    .ml-lg-auto,
    .mx-lg-auto {
        margin-left: auto !important
    }
}

@media (min-width:1200px) {
    .m-xl-0 {
        margin: 0 !important
    }

    .mt-xl-0,
    .my-xl-0 {
        margin-top: 0 !important
    }

    .mr-xl-0,
    .mx-xl-0 {
        margin-right: 0 !important
    }

    .mb-xl-0,
    .my-xl-0 {
        margin-bottom: 0 !important
    }

    .ml-xl-0,
    .mx-xl-0 {
        margin-left: 0 !important
    }

    .m-xl-1 {
        margin: .25rem !important
    }

    .mt-xl-1,
    .my-xl-1 {
        margin-top: .25rem !important
    }

    .mr-xl-1,
    .mx-xl-1 {
        margin-right: .25rem !important
    }

    .mb-xl-1,
    .my-xl-1 {
        margin-bottom: .25rem !important
    }

    .ml-xl-1,
    .mx-xl-1 {
        margin-left: .25rem !important
    }

    .m-xl-2 {
        margin: .5rem !important
    }

    .mt-xl-2,
    .my-xl-2 {
        margin-top: .5rem !important
    }

    .mr-xl-2,
    .mx-xl-2 {
        margin-right: .5rem !important
    }

    .mb-xl-2,
    .my-xl-2 {
        margin-bottom: .5rem !important
    }

    .ml-xl-2,
    .mx-xl-2 {
        margin-left: .5rem !important
    }

    .m-xl-3 {
        margin: 1rem !important
    }

    .mt-xl-3,
    .my-xl-3 {
        margin-top: 1rem !important
    }

    .mr-xl-3,
    .mx-xl-3 {
        margin-right: 1rem !important
    }

    .mb-xl-3,
    .my-xl-3 {
        margin-bottom: 1rem !important
    }

    .ml-xl-3,
    .mx-xl-3 {
        margin-left: 1rem !important
    }

    .m-xl-4 {
        margin: 1.5rem !important
    }

    .mt-xl-4,
    .my-xl-4 {
        margin-top: 1.5rem !important
    }

    .mr-xl-4,
    .mx-xl-4 {
        margin-right: 1.5rem !important
    }

    .mb-xl-4,
    .my-xl-4 {
        margin-bottom: 1.5rem !important
    }

    .ml-xl-4,
    .mx-xl-4 {
        margin-left: 1.5rem !important
    }

    .m-xl-5 {
        margin: 3rem !important
    }

    .mt-xl-5,
    .my-xl-5 {
        margin-top: 3rem !important
    }

    .mr-xl-5,
    .mx-xl-5 {
        margin-right: 3rem !important
    }

    .mb-xl-5,
    .my-xl-5 {
        margin-bottom: 3rem !important
    }

    .ml-xl-5,
    .mx-xl-5 {
        margin-left: 3rem !important
    }

    .p-xl-0 {
        padding: 0 !important
    }

    .pt-xl-0,
    .py-xl-0 {
        padding-top: 0 !important
    }

    .pr-xl-0,
    .px-xl-0 {
        padding-right: 0 !important
    }

    .pb-xl-0,
    .py-xl-0 {
        padding-bottom: 0 !important
    }

    .pl-xl-0,
    .px-xl-0 {
        padding-left: 0 !important
    }

    .p-xl-1 {
        padding: .25rem !important
    }

    .pt-xl-1,
    .py-xl-1 {
        padding-top: .25rem !important
    }

    .pr-xl-1,
    .px-xl-1 {
        padding-right: .25rem !important
    }

    .pb-xl-1,
    .py-xl-1 {
        padding-bottom: .25rem !important
    }

    .pl-xl-1,
    .px-xl-1 {
        padding-left: .25rem !important
    }

    .p-xl-2 {
        padding: .5rem !important
    }

    .pt-xl-2,
    .py-xl-2 {
        padding-top: .5rem !important
    }

    .pr-xl-2,
    .px-xl-2 {
        padding-right: .5rem !important
    }

    .pb-xl-2,
    .py-xl-2 {
        padding-bottom: .5rem !important
    }

    .pl-xl-2,
    .px-xl-2 {
        padding-left: .5rem !important
    }

    .p-xl-3 {
        padding: 1rem !important
    }

    .pt-xl-3,
    .py-xl-3 {
        padding-top: 1rem !important
    }

    .pr-xl-3,
    .px-xl-3 {
        padding-right: 1rem !important
    }

    .pb-xl-3,
    .py-xl-3 {
        padding-bottom: 1rem !important
    }

    .pl-xl-3,
    .px-xl-3 {
        padding-left: 1rem !important
    }

    .p-xl-4 {
        padding: 1.5rem !important
    }

    .pt-xl-4,
    .py-xl-4 {
        padding-top: 1.5rem !important
    }

    .pr-xl-4,
    .px-xl-4 {
        padding-right: 1.5rem !important
    }

    .pb-xl-4,
    .py-xl-4 {
        padding-bottom: 1.5rem !important
    }

    .pl-xl-4,
    .px-xl-4 {
        padding-left: 1.5rem !important
    }

    .p-xl-5 {
        padding: 3rem !important
    }

    .pt-xl-5,
    .py-xl-5 {
        padding-top: 3rem !important
    }

    .pr-xl-5,
    .px-xl-5 {
        padding-right: 3rem !important
    }

    .pb-xl-5,
    .py-xl-5 {
        padding-bottom: 3rem !important
    }

    .pl-xl-5,
    .px-xl-5 {
        padding-left: 3rem !important
    }

    .m-xl-n1 {
        margin: -.25rem !important
    }

    .mt-xl-n1,
    .my-xl-n1 {
        margin-top: -.25rem !important
    }

    .mr-xl-n1,
    .mx-xl-n1 {
        margin-right: -.25rem !important
    }

    .mb-xl-n1,
    .my-xl-n1 {
        margin-bottom: -.25rem !important
    }

    .ml-xl-n1,
    .mx-xl-n1 {
        margin-left: -.25rem !important
    }

    .m-xl-n2 {
        margin: -.5rem !important
    }

    .mt-xl-n2,
    .my-xl-n2 {
        margin-top: -.5rem !important
    }

    .mr-xl-n2,
    .mx-xl-n2 {
        margin-right: -.5rem !important
    }

    .mb-xl-n2,
    .my-xl-n2 {
        margin-bottom: -.5rem !important
    }

    .ml-xl-n2,
    .mx-xl-n2 {
        margin-left: -.5rem !important
    }

    .m-xl-n3 {
        margin: -1rem !important
    }

    .mt-xl-n3,
    .my-xl-n3 {
        margin-top: -1rem !important
    }

    .mr-xl-n3,
    .mx-xl-n3 {
        margin-right: -1rem !important
    }

    .mb-xl-n3,
    .my-xl-n3 {
        margin-bottom: -1rem !important
    }

    .ml-xl-n3,
    .mx-xl-n3 {
        margin-left: -1rem !important
    }

    .m-xl-n4 {
        margin: -1.5rem !important
    }

    .mt-xl-n4,
    .my-xl-n4 {
        margin-top: -1.5rem !important
    }

    .mr-xl-n4,
    .mx-xl-n4 {
        margin-right: -1.5rem !important
    }

    .mb-xl-n4,
    .my-xl-n4 {
        margin-bottom: -1.5rem !important
    }

    .ml-xl-n4,
    .mx-xl-n4 {
        margin-left: -1.5rem !important
    }

    .m-xl-n5 {
        margin: -3rem !important
    }

    .mt-xl-n5,
    .my-xl-n5 {
        margin-top: -3rem !important
    }

    .mr-xl-n5,
    .mx-xl-n5 {
        margin-right: -3rem !important
    }

    .mb-xl-n5,
    .my-xl-n5 {
        margin-bottom: -3rem !important
    }

    .ml-xl-n5,
    .mx-xl-n5 {
        margin-left: -3rem !important
    }

    .m-xl-auto {
        margin: auto !important
    }

    .mt-xl-auto,
    .my-xl-auto {
        margin-top: auto !important
    }

    .mr-xl-auto,
    .mx-xl-auto {
        margin-right: auto !important
    }

    .mb-xl-auto,
    .my-xl-auto {
        margin-bottom: auto !important
    }

    .ml-xl-auto,
    .mx-xl-auto {
        margin-left: auto !important
    }
}

.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    pointer-events: auto;
    content: "";
    background-color: rgba(0, 0, 0, 0)
}

.text-monospace {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important
}

.text-justify {
    text-align: justify !important
}

.text-wrap {
    white-space: normal !important
}

.text-nowrap {
    white-space: nowrap !important
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.text-left {
    text-align: left !important
}

.text-right {
    text-align: right !important
}

.text-center {
    text-align: center !important
}

@media (min-width:576px) {
    .text-sm-left {
        text-align: left !important
    }

    .text-sm-right {
        text-align: right !important
    }

    .text-sm-center {
        text-align: center !important
    }
}

@media (min-width:768px) {
    .text-md-left {
        text-align: left !important
    }

    .text-md-right {
        text-align: right !important
    }

    .text-md-center {
        text-align: center !important
    }
}

@media (min-width:992px) {
    .text-lg-left {
        text-align: left !important
    }

    .text-lg-right {
        text-align: right !important
    }

    .text-lg-center {
        text-align: center !important
    }
}

@media (min-width:1200px) {
    .text-xl-left {
        text-align: left !important
    }

    .text-xl-right {
        text-align: right !important
    }

    .text-xl-center {
        text-align: center !important
    }
}

.text-lowercase {
    text-transform: lowercase !important
}

.dropdown .dropdown-menu .dropdown-header,
.sidebar .sidebar-heading,
.text-uppercase {
    text-transform: uppercase !important
}

.text-capitalize {
    text-transform: capitalize !important
}

.font-weight-light {
    font-weight: 300 !important
}

.font-weight-lighter {
    font-weight: lighter !important
}

.font-weight-normal {
    font-weight: 400 !important
}

.font-weight-bold {
    font-weight: 700 !important
}

.font-weight-bolder {
    font-weight: bolder !important
}

.font-italic {
    font-style: italic !important
}

.text-white {
    color: #fff !important
}

.text-primary {
    color: #4e73df !important
}

a.text-primary:focus,
a.text-primary:hover {
    color: #224abe !important
}

.text-secondary {
    color: #858796 !important
}

a.text-secondary:focus,
a.text-secondary:hover {
    color: #60616f !important
}

.text-success {
    color: #1cc88a !important
}

a.text-success:focus,
a.text-success:hover {
    color: #13855c !important
}

.text-info {
    color: #36b9cc !important
}

a.text-info:focus,
a.text-info:hover {
    color: #258391 !important
}

.text-warning {
    color: #f6c23e !important
}

a.text-warning:focus,
a.text-warning:hover {
    color: #dda20a !important
}

.text-danger {
    color: #e74a3b !important
}

a.text-danger:focus,
a.text-danger:hover {
    color: #be2617 !important
}

.text-light {
    color: #f8f9fc !important
}

a.text-light:focus,
a.text-light:hover {
    color: #c2cbe5 !important
}

.text-dark {
    color: #5a5c69 !important
}

a.text-dark:focus,
a.text-dark:hover {
    color: #373840 !important
}

.text-body {
    color: #858796 !important
}

.text-muted {
    color: #858796 !important
}

.text-black-50 {
    color: rgba(0, 0, 0, .5) !important
}

.text-white-50 {
    color: rgba(255, 255, 255, .5) !important
}

.text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0
}

.text-decoration-none {
    text-decoration: none !important
}

.text-break {
    word-break: break-word !important;
    word-wrap: break-word !important
}

.text-reset {
    color: inherit !important
}

.visible {
    visibility: visible !important
}

.invisible {
    visibility: hidden !important
}

@media print {

    *,
    ::after,
    ::before {
        text-shadow: none !important;
        box-shadow: none !important
    }

    a:not(.btn) {
        text-decoration: underline
    }

    abbr[title]::after {
        content: " (" attr(title) ")"
    }

    pre {
        white-space: pre-wrap !important
    }

    blockquote,
    pre {
        border: 1px solid #b7b9cc;
        page-break-inside: avoid
    }

    thead {
        display: table-header-group
    }

    img,
    tr {
        page-break-inside: avoid
    }

    h2,
    h3,
    p {
        orphans: 3;
        widows: 3
    }

    h2,
    h3 {
        page-break-after: avoid
    }

    @page {
        size: a3
    }

    body {
        min-width: 992px !important
    }

    .container {
        min-width: 992px !important
    }

    .navbar {
        display: none
    }

    .badge {
        border: 1px solid #000
    }

    .table {
        border-collapse: collapse !important
    }

    .table td,
    .table th {
        background-color: #fff !important
    }

    .table-bordered td,
    .table-bordered th {
        border: 1px solid #dddfeb !important
    }

    .table-dark {
        color: inherit
    }

    .table-dark tbody+tbody,
    .table-dark td,
    .table-dark th,
    .table-dark thead th {
        border-color: #e3e6f0
    }

    .table .thead-dark th {
        color: inherit;
        border-color: #e3e6f0
    }
}

html {
    position: relative;
    min-height: 100%
}

body {
    height: 100%
}

a:focus {
    outline: 0
}

#wrapper {
    display: flex
}

#wrapper #content-wrapper {
    background-color: #f8f9fc;
    width: 100%;
    overflow-x: hidden
}

#wrapper #content-wrapper #content {
    flex: 1 0 auto
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}

.scroll-to-top {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    display: none;
    width: 2.75rem;
    height: 2.75rem;
    text-align: center;
    color: #fff;
    background: rgba(90, 92, 105, .5);
    line-height: 46px
}

.scroll-to-top:focus,
.scroll-to-top:hover {
    color: #fff
}

.scroll-to-top:hover {
    background: #5a5c69
}

.scroll-to-top i {
    font-weight: 800
}

@keyframes growIn {
    0% {
        transform: scale(.9);
        opacity: 0
    }

    100% {
        transform: scale(1);
        opacity: 1
    }
}

.animated--grow-in,
.sidebar .nav-item .collapse {
    animation-name: growIn;
    animation-duration: .2s;
    animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1)
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
}

.animated--fade-in {
    animation-name: fadeIn;
    animation-duration: .2s;
    animation-timing-function: opacity cubic-bezier(0, 1, .4, 1)
}

.bg-gradient-primary {
    background-color: #4e73df;
    background-image: linear-gradient(180deg, #4e73df 10%, #224abe 100%);
    background-size: cover
}

.bg-gradient-secondary {
    background-color: #858796;
    background-image: linear-gradient(180deg, #858796 10%, #60616f 100%);
    background-size: cover
}

.bg-gradient-success {
    background-color: #1cc88a;
    background-image: linear-gradient(180deg, #1cc88a 10%, #13855c 100%);
    background-size: cover
}

.bg-gradient-info {
    background-color: #36b9cc;
    background-image: linear-gradient(180deg, #36b9cc 10%, #258391 100%);
    background-size: cover
}

.bg-gradient-warning {
    background-color: #f6c23e;
    background-image: linear-gradient(180deg, #f6c23e 10%, #dda20a 100%);
    background-size: cover
}

.bg-gradient-danger {
    background-color: #e74a3b;
    background-image: linear-gradient(180deg, #e74a3b 10%, #be2617 100%);
    background-size: cover
}

.bg-gradient-light {
    background-color: #f8f9fc;
    background-image: linear-gradient(180deg, #f8f9fc 10%, #c2cbe5 100%);
    background-size: cover
}

.bg-gradient-dark {
    background-color: #5a5c69;
    background-image: linear-gradient(180deg, #5a5c69 10%, #373840 100%);
    background-size: cover
}

.bg-gray-100 {
    background-color: #f8f9fc !important
}

.bg-gray-200 {
    background-color: #eaecf4 !important
}

.bg-gray-300 {
    background-color: #dddfeb !important
}

.bg-gray-400 {
    background-color: #d1d3e2 !important
}

.bg-gray-500 {
    background-color: #b7b9cc !important
}

.bg-gray-600 {
    background-color: #858796 !important
}

.bg-gray-700 {
    background-color: #6e707e !important
}

.bg-gray-800 {
    background-color: #5a5c69 !important
}

.bg-gray-900 {
    background-color: #3a3b45 !important
}

.o-hidden {
    overflow: hidden !important
}

.text-xs {
    font-size: .7rem
}

.text-lg {
    font-size: 1.2rem
}

.text-gray-100 {
    color: #f8f9fc !important
}

.text-gray-200 {
    color: #eaecf4 !important
}

.text-gray-300 {
    color: #dddfeb !important
}

.text-gray-400 {
    color: #d1d3e2 !important
}

.text-gray-500 {
    color: #b7b9cc !important
}

.text-gray-600 {
    color: #858796 !important
}

.text-gray-700 {
    color: #6e707e !important
}

.text-gray-800 {
    color: #5a5c69 !important
}

.text-gray-900 {
    color: #3a3b45 !important
}

.icon-circle {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center
}

.border-left-primary {
    border-left: .25rem solid #4e73df !important
}

.border-bottom-primary {
    border-bottom: .25rem solid #4e73df !important
}

.border-left-secondary {
    border-left: .25rem solid #858796 !important
}

.border-bottom-secondary {
    border-bottom: .25rem solid #858796 !important
}

.border-left-success {
    border-left: .25rem solid #1cc88a !important
}

.border-bottom-success {
    border-bottom: .25rem solid #1cc88a !important
}

.border-left-info {
    border-left: .25rem solid #36b9cc !important
}

.border-bottom-info {
    border-bottom: .25rem solid #36b9cc !important
}

.border-left-warning {
    border-left: .25rem solid #f6c23e !important
}

.border-bottom-warning {
    border-bottom: .25rem solid #f6c23e !important
}

.border-left-danger {
    border-left: .25rem solid #e74a3b !important
}

.border-bottom-danger {
    border-bottom: .25rem solid #e74a3b !important
}

.border-left-light {
    border-left: .25rem solid #f8f9fc !important
}

.border-bottom-light {
    border-bottom: .25rem solid #f8f9fc !important
}

.border-left-dark {
    border-left: .25rem solid #5a5c69 !important
}

.border-bottom-dark {
    border-bottom: .25rem solid #5a5c69 !important
}

.progress-sm {
    height: .5rem
}

.rotate-15 {
    transform: rotate(15deg)
}

.rotate-n-15 {
    transform: rotate(-15deg)
}

.dropdown .dropdown-menu {
    font-size: .85rem
}

.dropdown .dropdown-menu .dropdown-header {
    font-weight: 800;
    font-size: .65rem;
    color: #b7b9cc
}

.dropdown.no-arrow .dropdown-toggle::after {
    display: none
}

.sidebar .nav-item.dropdown .dropdown-toggle::after,
.topbar .nav-item.dropdown .dropdown-toggle::after {
    width: 1rem;
    text-align: center;
    float: right;
    vertical-align: 0;
    border: 0;
    font-weight: 900;
    content: '\\f105';
    font-family: 'Font Awesome 5 Free'
}

.sidebar .nav-item.dropdown.show .dropdown-toggle::after,
.topbar .nav-item.dropdown.show .dropdown-toggle::after {
    content: '\\f107'
}

.sidebar .nav-item .nav-link,
.topbar .nav-item .nav-link {
    position: relative
}

.sidebar .nav-item .nav-link .badge-counter,
.topbar .nav-item .nav-link .badge-counter {
    position: absolute;
    transform: scale(.7);
    transform-origin: top right;
    right: .25rem;
    margin-top: -.25rem
}

.sidebar .nav-item .nav-link .img-profile,
.topbar .nav-item .nav-link .img-profile {
    height: 2rem;
    width: 2rem
}

.topbar {
    height: 4.375rem
}

.topbar #sidebarToggleTop {
    height: 2.5rem;
    width: 2.5rem
}

.topbar #sidebarToggleTop:hover {
    background-color: #eaecf4
}

.topbar #sidebarToggleTop:active {
    background-color: #dddfeb
}

.topbar .navbar-search {
    width: 25rem
}

.topbar .navbar-search input {
    font-size: .85rem;
    height: auto
}

.topbar .topbar-divider {
    width: 0;
    border-right: 1px solid #e3e6f0;
    height: calc(4.375rem - 2rem);
    margin: auto 1rem
}

.topbar .nav-item .nav-link {
    height: 4.375rem;
    display: flex;
    align-items: center;
    padding: 0 .75rem
}

.topbar .nav-item .nav-link:focus {
    outline: 0
}

.topbar .nav-item:focus {
    outline: 0
}

.topbar .dropdown {
    position: static
}

.topbar .dropdown .dropdown-menu {
    width: calc(100% - 1.5rem);
    right: .75rem
}

.topbar .dropdown-list {
    padding: 0;
    border: none;
    overflow: hidden
}

.topbar .dropdown-list .dropdown-header {
    background-color: #4e73df;
    border: 1px solid #4e73df;
    padding-top: .75rem;
    padding-bottom: .75rem;
    color: #fff
}

.topbar .dropdown-list .dropdown-item {
    white-space: normal;
    padding-top: .5rem;
    padding-bottom: .5rem;
    border-left: 1px solid #e3e6f0;
    border-right: 1px solid #e3e6f0;
    border-bottom: 1px solid #e3e6f0;
    line-height: 1.3rem
}

.topbar .dropdown-list .dropdown-item .dropdown-list-image {
    position: relative;
    height: 2.5rem;
    width: 2.5rem
}

.topbar .dropdown-list .dropdown-item .dropdown-list-image img {
    height: 2.5rem;
    width: 2.5rem
}

.topbar .dropdown-list .dropdown-item .dropdown-list-image .status-indicator {
    background-color: #eaecf4;
    height: .75rem;
    width: .75rem;
    border-radius: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    border: .125rem solid #fff
}

.topbar .dropdown-list .dropdown-item .text-truncate {
    max-width: 10rem
}

.topbar .dropdown-list .dropdown-item:active {
    background-color: #eaecf4;
    color: #3a3b45
}

@media (min-width:576px) {
    .topbar .dropdown {
        position: relative
    }

    .topbar .dropdown .dropdown-menu {
        width: auto;
        right: 0
    }

    .topbar .dropdown-list {
        width: 20rem !important
    }

    .topbar .dropdown-list .dropdown-item .text-truncate {
        max-width: 13.375rem
    }
}

.topbar.navbar-dark .navbar-nav .nav-item .nav-link {
    color: rgba(255, 255, 255, .8)
}

.topbar.navbar-dark .navbar-nav .nav-item .nav-link:hover {
    color: #fff
}

.topbar.navbar-dark .navbar-nav .nav-item .nav-link:active {
    color: #fff
}

.topbar.navbar-light .navbar-nav .nav-item .nav-link {
    color: #d1d3e2
}

.topbar.navbar-light .navbar-nav .nav-item .nav-link:hover {
    color: #b7b9cc
}

.topbar.navbar-light .navbar-nav .nav-item .nav-link:active {
    color: #858796
}

.sidebar {
    width: 6.5rem;
    min-height: 100vh
}

.sidebar .nav-item {
    position: relative
}

.sidebar .nav-item:last-child {
    margin-bottom: 1rem
}

.sidebar .nav-item .nav-link {
    text-align: center;
    padding: .75rem 1rem;
    width: 6.5rem
}

.sidebar .nav-item .nav-link span {
    font-size: .65rem;
    display: block
}

.sidebar .nav-item.active .nav-link {
    font-weight: 700
}

.sidebar .nav-item .collapse {
    position: absolute;
    left: calc(6.5rem + 1.5rem / 2);
    z-index: 1;
    top: 2px
}

.sidebar .nav-item .collapse .collapse-inner {
    border-radius: .35rem;
    box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15)
}

.sidebar .nav-item .collapsing {
    display: none;
    transition: none
}

.sidebar .nav-item .collapse .collapse-inner,
.sidebar .nav-item .collapsing .collapse-inner {
    padding: .5rem 0;
    min-width: 10rem;
    font-size: .85rem;
    margin: 0 0 1rem 0
}

.sidebar .nav-item .collapse .collapse-inner .collapse-header,
.sidebar .nav-item .collapsing .collapse-inner .collapse-header {
    margin: 0;
    white-space: nowrap;
    padding: .5rem 1.5rem;
    text-transform: uppercase;
    font-weight: 800;
    font-size: .65rem;
    color: #b7b9cc
}

.sidebar .nav-item .collapse .collapse-inner .collapse-item,
.sidebar .nav-item .collapsing .collapse-inner .collapse-item {
    padding: .5rem 1rem;
    margin: 0 .5rem;
    display: block;
    color: #3a3b45;
    text-decoration: none;
    border-radius: .35rem;
    white-space: nowrap
}

.sidebar .nav-item .collapse .collapse-inner .collapse-item:hover,
.sidebar .nav-item .collapsing .collapse-inner .collapse-item:hover {
    background-color: #eaecf4
}

.sidebar .nav-item .collapse .collapse-inner .collapse-item:active,
.sidebar .nav-item .collapsing .collapse-inner .collapse-item:active {
    background-color: #dddfeb
}

.sidebar .nav-item .collapse .collapse-inner .collapse-item.active,
.sidebar .nav-item .collapsing .collapse-inner .collapse-item.active {
    color: #4e73df;
    font-weight: 700
}

.sidebar #sidebarToggle {
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    margin-bottom: 1rem;
    cursor: pointer
}

.sidebar #sidebarToggle::after {
    font-weight: 900;
    content: '\\f104';
    font-family: 'Font Awesome 5 Free';
    margin-right: .1rem
}

.sidebar #sidebarToggle:hover {
    text-decoration: none
}

.sidebar #sidebarToggle:focus {
    outline: 0
}

.sidebar.toggled {
    width: 0 !important;
    overflow: hidden
}

.sidebar.toggled #sidebarToggle::after {
    content: '\\f105';
    font-family: 'Font Awesome 5 Free';
    margin-left: .25rem
}

.sidebar.toggled .sidebar-card {
    display: none
}

.sidebar .sidebar-brand {
    height: 4.375rem;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 800;
    padding: 1.5rem 1rem;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: .05rem;
    z-index: 1
}

.sidebar .sidebar-brand .sidebar-brand-icon i {
    font-size: 2rem
}

.sidebar .sidebar-brand .sidebar-brand-text {
    display: none
}

.sidebar hr.sidebar-divider {
    margin: 0 1rem 1rem
}

.sidebar .sidebar-heading {
    text-align: center;
    padding: 0 1rem;
    font-weight: 800;
    font-size: .65rem
}

.sidebar .sidebar-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: .875rem;
    border-radius: .35rem;
    color: rgba(255, 255, 255, .8);
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: rgba(0, 0, 0, .1)
}

.sidebar .sidebar-card .sidebar-card-illustration {
    height: 3rem;
    display: block
}

.sidebar .sidebar-card .sidebar-card-title {
    font-weight: 700
}

.sidebar .sidebar-card p {
    font-size: .75rem;
    color: rgba(255, 255, 255, .5)
}

@media (min-width:768px) {
    .sidebar {
        width: 14rem !important
    }

    .sidebar .nav-item .collapse {
        position: relative;
        left: 0;
        z-index: 1;
        top: 0;
        animation: none
    }

    .sidebar .nav-item .collapse .collapse-inner {
        border-radius: 0;
        box-shadow: none
    }

    .sidebar .nav-item .collapsing {
        display: block;
        transition: height .15s ease
    }

    .sidebar .nav-item .collapse,
    .sidebar .nav-item .collapsing {
        margin: 0 1rem
    }

    .sidebar .nav-item .nav-link {
        display: block;
        width: 100%;
        text-align: left;
        padding: 1rem;
        width: 14rem
    }

    .sidebar .nav-item .nav-link i {
        font-size: .85rem;
        margin-right: .25rem
    }

    .sidebar .nav-item .nav-link span {
        font-size: .85rem;
        display: inline
    }

    .sidebar .nav-item .nav-link[data-toggle=collapse]::after {
        width: 1rem;
        text-align: center;
        float: right;
        vertical-align: 0;
        border: 0;
        font-weight: 900;
        content: '\\f107';
        font-family: 'Font Awesome 5 Free'
    }

    .sidebar .nav-item .nav-link[data-toggle=collapse].collapsed::after {
        content: '\\f105'
    }

    .sidebar .sidebar-brand .sidebar-brand-icon i {
        font-size: 2rem
    }

    .sidebar .sidebar-brand .sidebar-brand-text {
        display: inline
    }

    .sidebar .sidebar-heading {
        text-align: left
    }

    .sidebar.toggled {
        overflow: visible;
        width: 6.5rem !important
    }

    .sidebar.toggled .nav-item .collapse {
        position: absolute;
        left: calc(6.5rem + 1.5rem / 2);
        z-index: 1;
        top: 2px;
        animation-name: growIn;
        animation-duration: .2s;
        animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1)
    }

    .sidebar.toggled .nav-item .collapse .collapse-inner {
        box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15);
        border-radius: .35rem
    }

    .sidebar.toggled .nav-item .collapsing {
        display: none;
        transition: none
    }

    .sidebar.toggled .nav-item .collapse,
    .sidebar.toggled .nav-item .collapsing {
        margin: 0
    }

    .sidebar.toggled .nav-item:last-child {
        margin-bottom: 1rem
    }

    .sidebar.toggled .nav-item .nav-link {
        text-align: center;
        padding: .75rem 1rem;
        width: 6.5rem
    }

    .sidebar.toggled .nav-item .nav-link span {
        font-size: .65rem;
        display: block
    }

    .sidebar.toggled .nav-item .nav-link i {
        margin-right: 0
    }

    .sidebar.toggled .nav-item .nav-link[data-toggle=collapse]::after {
        display: none
    }

    .sidebar.toggled .sidebar-brand .sidebar-brand-icon i {
        font-size: 2rem
    }

    .sidebar.toggled .sidebar-brand .sidebar-brand-text {
        display: none
    }

    .sidebar.toggled .sidebar-heading {
        text-align: center
    }
}

.sidebar-light .sidebar-brand {
    color: #6e707e
}

.sidebar-light hr.sidebar-divider {
    border-top: 1px solid #eaecf4
}

.sidebar-light .sidebar-heading {
    color: #b7b9cc
}

.sidebar-light .nav-item .nav-link {
    color: #858796
}

.sidebar-light .nav-item .nav-link i {
    color: #d1d3e2
}

.sidebar-light .nav-item .nav-link:active,
.sidebar-light .nav-item .nav-link:focus,
.sidebar-light .nav-item .nav-link:hover {
    color: #6e707e
}

.sidebar-light .nav-item .nav-link:active i,
.sidebar-light .nav-item .nav-link:focus i,
.sidebar-light .nav-item .nav-link:hover i {
    color: #6e707e
}

.sidebar-light .nav-item .nav-link[data-toggle=collapse]::after {
    color: #b7b9cc
}

.sidebar-light .nav-item.active .nav-link {
    color: #6e707e
}

.sidebar-light .nav-item.active .nav-link i {
    color: #6e707e
}

.sidebar-light #sidebarToggle {
    background-color: #eaecf4
}

.sidebar-light #sidebarToggle::after {
    color: #b7b9cc
}

.sidebar-light #sidebarToggle:hover {
    background-color: #dddfeb
}

.sidebar-dark .sidebar-brand {
    color: #fff
}

.sidebar-dark hr.sidebar-divider {
    border-top: 1px solid rgba(255, 255, 255, .15)
}

.sidebar-dark .sidebar-heading {
    color: rgba(255, 255, 255, .4)
}

.sidebar-dark .nav-item .nav-link {
    color: rgba(255, 255, 255, .8)
}

.sidebar-dark .nav-item .nav-link i {
    color: rgba(255, 255, 255, .3)
}

.sidebar-dark .nav-item .nav-link:active,
.sidebar-dark .nav-item .nav-link:focus,
.sidebar-dark .nav-item .nav-link:hover {
    color: #fff
}

.sidebar-dark .nav-item .nav-link:active i,
.sidebar-dark .nav-item .nav-link:focus i,
.sidebar-dark .nav-item .nav-link:hover i {
    color: #fff
}

.sidebar-dark .nav-item .nav-link[data-toggle=collapse]::after {
    color: rgba(255, 255, 255, .5)
}

.sidebar-dark .nav-item.active .nav-link {
    color: #fff
}

.sidebar-dark .nav-item.active .nav-link i {
    color: #fff
}

.sidebar-dark #sidebarToggle {
    background-color: rgba(255, 255, 255, .2)
}

.sidebar-dark #sidebarToggle::after {
    color: rgba(255, 255, 255, .5)
}

.sidebar-dark #sidebarToggle:hover {
    background-color: rgba(255, 255, 255, .25)
}

.sidebar-dark.toggled #sidebarToggle::after {
    color: rgba(255, 255, 255, .5)
}

.btn-circle {
    border-radius: 100%;
    height: 2.5rem;
    width: 2.5rem;
    font-size: 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center
}

.btn-circle.btn-sm,
.btn-group-sm>.btn-circle.btn {
    height: 1.8rem;
    width: 1.8rem;
    font-size: .75rem
}

.btn-circle.btn-lg,
.btn-group-lg>.btn-circle.btn {
    height: 3.5rem;
    width: 3.5rem;
    font-size: 1.35rem
}

.btn-icon-split {
    padding: 0;
    overflow: hidden;
    display: inline-flex;
    align-items: stretch;
    justify-content: center
}

.btn-icon-split .icon {
    background: rgba(0, 0, 0, .15);
    display: inline-block;
    padding: .375rem .75rem
}

.btn-icon-split .text {
    display: inline-block;
    padding: .375rem .75rem
}

.btn-group-sm>.btn-icon-split.btn .icon,
.btn-icon-split.btn-sm .icon {
    padding: .25rem .5rem
}

.btn-group-sm>.btn-icon-split.btn .text,
.btn-icon-split.btn-sm .text {
    padding: .25rem .5rem
}

.btn-group-lg>.btn-icon-split.btn .icon,
.btn-icon-split.btn-lg .icon {
    padding: .5rem 1rem
}

.btn-group-lg>.btn-icon-split.btn .text,
.btn-icon-split.btn-lg .text {
    padding: .5rem 1rem
}

.card .card-header .dropdown {
    line-height: 1
}

.card .card-header .dropdown .dropdown-menu {
    line-height: 1.5
}

.card .card-header[data-toggle=collapse] {
    text-decoration: none;
    position: relative;
    padding: .75rem 3.25rem .75rem 1.25rem
}

.card .card-header[data-toggle=collapse]::after {
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 1.725rem;
    line-height: 51px;
    font-weight: 900;
    content: '\\f107';
    font-family: 'Font Awesome 5 Free';
    color: #d1d3e2
}

.card .card-header[data-toggle=collapse].collapsed {
    border-radius: .35rem
}

.card .card-header[data-toggle=collapse].collapsed::after {
    content: '\\f105'
}

.chart-area {
    position: relative;
    height: 10rem;
    width: 100%
}

@media (min-width:768px) {
    .chart-area {
        height: 20rem
    }
}

.chart-bar {
    position: relative;
    height: 10rem;
    width: 100%
}

@media (min-width:768px) {
    .chart-bar {
        height: 20rem
    }
}

.chart-pie {
    position: relative;
    height: 15rem;
    width: 100%
}

@media (min-width:768px) {
    .chart-pie {
        height: calc(20rem - 43px) !important
    }
}

.bg-login-image {
    background: url(https://source.unsplash.com/K4mSJ7kc0As/600x800);
    background-position: center;
    background-size: cover
}

.bg-register-image {
    background: url(https://source.unsplash.com/Mv9hjnEUHR4/600x800);
    background-position: center;
    background-size: cover
}

.bg-password-image {
    background: url(https://source.unsplash.com/oWTW-jNGl9I/600x800);
    background-position: center;
    background-size: cover
}

form.user .custom-checkbox.small label {
    line-height: 1.5rem
}

form.user .form-control-user {
    font-size: .8rem;
    border-radius: 10rem;
    padding: 1.5rem 1rem
}

form.user .btn-user {
    font-size: .8rem;
    border-radius: 10rem;
    padding: .75rem 1rem
}

.btn-google {
    color: #fff;
    background-color: #ea4335;
    border-color: #fff
}

.btn-google:hover {
    color: #fff;
    background-color: #e12717;
    border-color: #e6e6e6
}

.btn-google.focus,
.btn-google:focus {
    color: #fff;
    background-color: #e12717;
    border-color: #e6e6e6;
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)
}

.btn-google.disabled,
.btn-google:disabled {
    color: #fff;
    background-color: #ea4335;
    border-color: #fff
}

.btn-google:not(:disabled):not(.disabled).active,
.btn-google:not(:disabled):not(.disabled):active,
.show>.btn-google.dropdown-toggle {
    color: #fff;
    background-color: #d62516;
    border-color: #dfdfdf
}

.btn-google:not(:disabled):not(.disabled).active:focus,
.btn-google:not(:disabled):not(.disabled):active:focus,
.show>.btn-google.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)
}

.btn-facebook {
    color: #fff;
    background-color: #3b5998;
    border-color: #fff
}

.btn-facebook:hover {
    color: #fff;
    background-color: #30497c;
    border-color: #e6e6e6
}

.btn-facebook.focus,
.btn-facebook:focus {
    color: #fff;
    background-color: #30497c;
    border-color: #e6e6e6;
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)
}

.btn-facebook.disabled,
.btn-facebook:disabled {
    color: #fff;
    background-color: #3b5998;
    border-color: #fff
}

.btn-facebook:not(:disabled):not(.disabled).active,
.btn-facebook:not(:disabled):not(.disabled):active,
.show>.btn-facebook.dropdown-toggle {
    color: #fff;
    background-color: #2d4373;
    border-color: #dfdfdf
}

.btn-facebook:not(:disabled):not(.disabled).active:focus,
.btn-facebook:not(:disabled):not(.disabled):active:focus,
.show>.btn-facebook.dropdown-toggle:focus {
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)
}

.error {
    color: #5a5c69;
    font-size: 7rem;
    position: relative;
    line-height: 1;
    width: 12.5rem
}

@keyframes noise-anim {
    0% {
        clip: rect(49px, 9999px, 40px, 0)
    }

    5% {
        clip: rect(75px, 9999px, 72px, 0)
    }

    10% {
        clip: rect(97px, 9999px, 93px, 0)
    }

    15% {
        clip: rect(15px, 9999px, 9px, 0)
    }

    20% {
        clip: rect(14px, 9999px, 92px, 0)
    }

    25% {
        clip: rect(18px, 9999px, 94px, 0)
    }

    30% {
        clip: rect(17px, 9999px, 20px, 0)
    }

    35% {
        clip: rect(71px, 9999px, 59px, 0)
    }

    40% {
        clip: rect(42px, 9999px, 84px, 0)
    }

    45% {
        clip: rect(56px, 9999px, 25px, 0)
    }

    50% {
        clip: rect(46px, 9999px, 14px, 0)
    }

    55% {
        clip: rect(47px, 9999px, 1px, 0)
    }

    60% {
        clip: rect(64px, 9999px, 58px, 0)
    }

    65% {
        clip: rect(89px, 9999px, 92px, 0)
    }

    70% {
        clip: rect(56px, 9999px, 39px, 0)
    }

    75% {
        clip: rect(80px, 9999px, 71px, 0)
    }

    80% {
        clip: rect(8px, 9999px, 13px, 0)
    }

    85% {
        clip: rect(66px, 9999px, 68px, 0)
    }

    90% {
        clip: rect(68px, 9999px, 4px, 0)
    }

    95% {
        clip: rect(56px, 9999px, 14px, 0)
    }

    100% {
        clip: rect(28px, 9999px, 53px, 0)
    }
}

.error:after {
    content: attr(data-text);
    position: absolute;
    left: 2px;
    text-shadow: -1px 0 #e74a3b;
    top: 0;
    color: #5a5c69;
    background: #f8f9fc;
    overflow: hidden;
    clip: rect(0, 900px, 0, 0);
    animation: noise-anim 2s infinite linear alternate-reverse
}

@keyframes noise-anim-2 {
    0% {
        clip: rect(16px, 9999px, 10px, 0)
    }

    5% {
        clip: rect(22px, 9999px, 29px, 0)
    }

    10% {
        clip: rect(6px, 9999px, 68px, 0)
    }

    15% {
        clip: rect(85px, 9999px, 95px, 0)
    }

    20% {
        clip: rect(65px, 9999px, 91px, 0)
    }

    25% {
        clip: rect(93px, 9999px, 68px, 0)
    }

    30% {
        clip: rect(10px, 9999px, 27px, 0)
    }

    35% {
        clip: rect(37px, 9999px, 25px, 0)
    }

    40% {
        clip: rect(12px, 9999px, 23px, 0)
    }

    45% {
        clip: rect(40px, 9999px, 18px, 0)
    }

    50% {
        clip: rect(19px, 9999px, 71px, 0)
    }

    55% {
        clip: rect(2px, 9999px, 35px, 0)
    }

    60% {
        clip: rect(16px, 9999px, 69px, 0)
    }

    65% {
        clip: rect(8px, 9999px, 65px, 0)
    }

    70% {
        clip: rect(30px, 9999px, 57px, 0)
    }

    75% {
        clip: rect(14px, 9999px, 4px, 0)
    }

    80% {
        clip: rect(39px, 9999px, 30px, 0)
    }

    85% {
        clip: rect(22px, 9999px, 35px, 0)
    }

    90% {
        clip: rect(58px, 9999px, 71px, 0)
    }

    95% {
        clip: rect(34px, 9999px, 90px, 0)
    }

    100% {
        clip: rect(67px, 9999px, 68px, 0)
    }
}

.error:before {
    content: attr(data-text);
    position: absolute;
    left: -2px;
    text-shadow: 1px 0 #4e73df;
    top: 0;
    color: #5a5c69;
    background: #f8f9fc;
    overflow: hidden;
    clip: rect(0, 900px, 0, 0);
    animation: noise-anim-2 3s infinite linear alternate-reverse
}

footer.sticky-footer {
    padding: 2rem 0;
    flex-shrink: 0
}

footer.sticky-footer .copyright {
    line-height: 1;
    font-size: .8rem
}

body.sidebar-toggled footer.sticky-footer {
    width: 100%
}`, "",{"version":3,"sources":["webpack://./src/css/sb-admin-2.min.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;;;;EAKE;AACF;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,4MAA4M;IAC5M;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;IACI,SAAS;IACT,6LAA6L;IAC7L,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT;AACJ;;AAEA;;;;;;IAMI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;IAEhB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;;IAII,iGAAiG;IACjG;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII,UAAU;IACV;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;IAYI,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;;;;;;IAMI,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAsEI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAsBA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;;;IAMI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,kBAAkB;IAClB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,wCAAwC;IACxC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,mCAAmC;IACnC,yDAAiR;IACjR,4BAA4B;IAC5B,yDAAyD;IACzD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,sCAAsC;IACtC;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,uCAAuC;IACvC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,mCAAmC;IACnC,yDAA4U;IAC5U,4BAA4B;IAC5B,yDAAyD;IACzD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,sCAAsC;IACtC;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB;IACJ;;IAEA;QACI,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,oBAAoB;QACpB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IAGzB,iBAAiB;IACjB,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,WAAW;IACX;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,0BAA0B;IAC1B;AACJ;;AAEA;;;IAGI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI,0BAA0B;IAC1B;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IAEpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kCAAkC;IAClC,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,+FAAsO;IACtO,yBAAyB;IACzB,qBAAqB;IAGrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kCAAkC;IAClC;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,UAAU;IACV,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,4BAA4B;IAC5B,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,6BAA6B;IAG7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IAEnB,iHAAyG;IAAzG,yGAAyG;IAEzG;AACJ;;AAEA;IACI;QAEI,wBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IAEnB,8GAAyG;IAAzG,yGAAyG;IAEzG;AACJ;;AAEA;IACI;QAEI,qBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IAEnB,6GAAyG;IAAzG,yGAAyG;IACzG;AACJ;;AAEA;IACI;QAEI,oBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;;;;;;IAMI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;;;;;QAMI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;;;;;IAMI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C;AACJ;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;IAC9C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,cAAc;IACd;AACJ;;AAEA;;IAEI,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI,8CAA8C;IAC9C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,qBAAqB;QACrB;IACJ;;IAEA;QACI,SAAY;QACZ,oBAAoB;QACpB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,SAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QAEI,eAAe;QAEf,mBAAmB;QACnB,UAAU;QACV;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kMAAkM;IAClM;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;QAEI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;;IAEI,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,4BAA4B;IAC5B,mCAAmC;IACnC,6CAA6C;IAC7C,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,0CAA0C;IAC1C,4BAA4B;IAC5B,2CAA2C;IAC3C,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;IAG1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,mCAAmC;IACnC,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,yCAAyC;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;IAC7C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAG5B;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,SAAS;IACT,6LAA6L;IAC7L,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,MAAM;IACN,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,OAAO;IACP,YAAY;IACZ;AACJ;;AAEA;;IAEI,QAAQ;IACR,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;;IAEI,OAAO;IACP,iCAAiC;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,6LAA6L;IAC7L,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,mCAAmC;IACnC;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,WAAW;IACX,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;;IAEI,OAAO;IACP,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,SAAS;IACT,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,MAAM;IACN,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,QAAQ;IACR,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;;IAEI,QAAQ;IACR,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,UAAU;IACV,iCAAiC;IACjC;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IAEnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B;AACJ;;AAEA;;;IAGI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;IAII,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAQA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,kBAAkB;IAElB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAaA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IAEV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAGI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI,6CAA6C;IAC7C;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;;;IAKI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mCAAmC;IAGnC;AACJ;;AAEA;IACI,oCAAoC;IAGpC;AACJ;;AAEA;IACI,oCAAoC;IAGpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;QAEI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;;QAGI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI,UAAU;QACV;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAcA;IACI;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;;IAGI,sBAAsB;IAEtB,uBAAuB;IAEvB;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IAEI,sBAAsB;IAEtB,uBAAuB;IAEvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;IAC3B,aAAa;IACb;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,QAAQ;IACR,+BAA+B;IAC/B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,SAAS;IACT,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,UAAU;QACV,MAAM;QAEN;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,+BAA+B;QAC/B,UAAU;QACV,QAAQ;QAER,sBAAsB;QAEtB,uBAAuB;QAEvB;IACJ;;IAEA;QACI,oDAAoD;QACpD;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gEAAgE;IAChE,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gEAAgE;IAChE,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gEAAgE;IAChE,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAwFA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,MAAM;IACN,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAwFA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,0BAA0B;IAC1B,MAAM;IACN,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ","sourcesContent":["/*!\n * Start Bootstrap - SB Admin 2 v4.1.3 (https://startbootstrap.com/theme/sb-admin-2)\n * Copyright 2013-2021 Start Bootstrap\n * Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-sb-admin-2/blob/master/LICENSE)\n */\n/*!\n * Bootstrap v4.6.0 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n    --blue: #4e73df;\n    --indigo: #6610f2;\n    --purple: #6f42c1;\n    --pink: #e83e8c;\n    --red: #e74a3b;\n    --orange: #fd7e14;\n    --yellow: #f6c23e;\n    --green: #1cc88a;\n    --teal: #20c9a6;\n    --cyan: #36b9cc;\n    --white: #fff;\n    --gray: #858796;\n    --gray-dark: #5a5c69;\n    --primary: #4e73df;\n    --secondary: #858796;\n    --success: #1cc88a;\n    --info: #36b9cc;\n    --warning: #f6c23e;\n    --danger: #e74a3b;\n    --light: #f8f9fc;\n    --dark: #5a5c69;\n    --breakpoint-xs: 0;\n    --breakpoint-sm: 576px;\n    --breakpoint-md: 768px;\n    --breakpoint-lg: 992px;\n    --breakpoint-xl: 1200px;\n    --font-family-sans-serif: \"Nunito\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace\n}\n\n*,\n::after,\n::before {\n    box-sizing: border-box\n}\n\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: transparent\n}\n\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n    display: block\n}\n\nbody {\n    margin: 0;\n    font-family: Nunito, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #858796;\n    text-align: left;\n    background-color: #fff\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n    outline: 0 !important\n}\n\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: .5rem\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nabbr[data-original-title],\nabbr[title] {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    border-bottom: 0;\n    -webkit-text-decoration-skip-ink: none;\n    text-decoration-skip-ink: none\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit\n}\n\ndl,\nol,\nul {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nol ol,\nol ul,\nul ol,\nul ul {\n    margin-bottom: 0\n}\n\ndt {\n    font-weight: 700\n}\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0\n}\n\nblockquote {\n    margin: 0 0 1rem\n}\n\nb,\nstrong {\n    font-weight: bolder\n}\n\nsmall {\n    font-size: 80%\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: 75%;\n    line-height: 0;\n    vertical-align: baseline\n}\n\nsub {\n    bottom: -.25em\n}\n\nsup {\n    top: -.5em\n}\n\na {\n    color: #4e73df;\n    text-decoration: none;\n    background-color: transparent\n}\n\na:hover {\n    color: #224abe;\n    text-decoration: underline\n}\n\na:not([href]):not([class]) {\n    color: inherit;\n    text-decoration: none\n}\n\na:not([href]):not([class]):hover {\n    color: inherit;\n    text-decoration: none\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 1em\n}\n\npre {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    -ms-overflow-style: scrollbar\n}\n\nfigure {\n    margin: 0 0 1rem\n}\n\nimg {\n    vertical-align: middle;\n    border-style: none\n}\n\nsvg {\n    overflow: hidden;\n    vertical-align: middle\n}\n\ntable {\n    border-collapse: collapse\n}\n\ncaption {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n    color: #858796;\n    text-align: left;\n    caption-side: bottom\n}\n\nth {\n    text-align: inherit;\n    text-align: -webkit-match-parent\n}\n\nlabel {\n    display: inline-block;\n    margin-bottom: .5rem\n}\n\nbutton {\n    border-radius: 0\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 0\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit\n}\n\nbutton,\ninput {\n    overflow: visible\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\n[role=button] {\n    cursor: pointer\n}\n\nselect {\n    word-wrap: normal\n}\n\n[type=button],\n[type=reset],\n[type=submit],\nbutton {\n    -webkit-appearance: button\n}\n\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled),\nbutton:not(:disabled) {\n    cursor: pointer\n}\n\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    padding: 0;\n    border-style: none\n}\n\ninput[type=checkbox],\ninput[type=radio] {\n    box-sizing: border-box;\n    padding: 0\n}\n\ntextarea {\n    overflow: auto;\n    resize: vertical\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0\n}\n\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: .5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal\n}\n\nprogress {\n    vertical-align: baseline\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n    height: auto\n}\n\n[type=search] {\n    outline-offset: -2px;\n    -webkit-appearance: none\n}\n\n[type=search]::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button\n}\n\noutput {\n    display: inline-block\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer\n}\n\ntemplate {\n    display: none\n}\n\n[hidden] {\n    display: none !important\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-bottom: .5rem;\n    font-weight: 400;\n    line-height: 1.2\n}\n\n.h1,\nh1 {\n    font-size: 2.5rem\n}\n\n.h2,\nh2 {\n    font-size: 2rem\n}\n\n.h3,\nh3 {\n    font-size: 1.75rem\n}\n\n.h4,\nh4 {\n    font-size: 1.5rem\n}\n\n.h5,\nh5 {\n    font-size: 1.25rem\n}\n\n.h6,\nh6 {\n    font-size: 1rem\n}\n\n.lead {\n    font-size: 1.25rem;\n    font-weight: 300\n}\n\n.display-1 {\n    font-size: 6rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-2 {\n    font-size: 5.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-3 {\n    font-size: 4.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-4 {\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, .1)\n}\n\n.small,\nsmall {\n    font-size: 80%;\n    font-weight: 400\n}\n\n.mark,\nmark {\n    padding: .2em;\n    background-color: #fcf8e3\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline-item {\n    display: inline-block\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: .5rem\n}\n\n.initialism {\n    font-size: 90%;\n    text-transform: uppercase\n}\n\n.blockquote {\n    margin-bottom: 1rem;\n    font-size: 1.25rem\n}\n\n.blockquote-footer {\n    display: block;\n    font-size: 80%;\n    color: #858796\n}\n\n.blockquote-footer::before {\n    content: \"\\2014\\00A0\"\n}\n\n.img-fluid {\n    max-width: 100%;\n    height: auto\n}\n\n.img-thumbnail {\n    padding: .25rem;\n    background-color: #fff;\n    border: 1px solid #dddfeb;\n    border-radius: .35rem;\n    max-width: 100%;\n    height: auto\n}\n\n.figure {\n    display: inline-block\n}\n\n.figure-img {\n    margin-bottom: .5rem;\n    line-height: 1\n}\n\n.figure-caption {\n    font-size: 90%;\n    color: #858796\n}\n\ncode {\n    font-size: 87.5%;\n    color: #e83e8c;\n    word-wrap: break-word\n}\n\na>code {\n    color: inherit\n}\n\nkbd {\n    padding: .2rem .4rem;\n    font-size: 87.5%;\n    color: #fff;\n    background-color: #3a3b45;\n    border-radius: .2rem\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700\n}\n\npre {\n    display: block;\n    font-size: 87.5%;\n    color: #3a3b45\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal\n}\n\n.pre-scrollable {\n    max-height: 340px;\n    overflow-y: scroll\n}\n\n.container,\n.container-fluid,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl {\n    width: 100%;\n    padding-right: .75rem;\n    padding-left: .75rem;\n    margin-right: auto;\n    margin-left: auto\n}\n\n@media (min-width:576px) {\n\n    .container,\n    .container-sm {\n        max-width: 540px\n    }\n}\n\n@media (min-width:768px) {\n\n    .container,\n    .container-md,\n    .container-sm {\n        max-width: 720px\n    }\n}\n\n@media (min-width:992px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm {\n        max-width: 960px\n    }\n}\n\n@media (min-width:1200px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl {\n        max-width: 1140px\n    }\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -.75rem;\n    margin-left: -.75rem\n}\n\n.no-gutters {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.no-gutters>.col,\n.no-gutters>[class*=col-] {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.col,\n.col-1,\n.col-10,\n.col-11,\n.col-12,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9,\n.col-auto,\n.col-lg,\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-auto,\n.col-md,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-auto,\n.col-sm,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-auto,\n.col-xl,\n.col-xl-1,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-auto {\n    position: relative;\n    width: 100%;\n    padding-right: .75rem;\n    padding-left: .75rem\n}\n\n.col {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%\n}\n\n.row-cols-1>* {\n    flex: 0 0 100%;\n    max-width: 100%\n}\n\n.row-cols-2>* {\n    flex: 0 0 50%;\n    max-width: 50%\n}\n\n.row-cols-3>* {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%\n}\n\n.row-cols-4>* {\n    flex: 0 0 25%;\n    max-width: 25%\n}\n\n.row-cols-5>* {\n    flex: 0 0 20%;\n    max-width: 20%\n}\n\n.row-cols-6>* {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%\n}\n\n.col-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%\n}\n\n.col-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%\n}\n\n.col-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%\n}\n\n.col-3 {\n    flex: 0 0 25%;\n    max-width: 25%\n}\n\n.col-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%\n}\n\n.col-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%\n}\n\n.col-6 {\n    flex: 0 0 50%;\n    max-width: 50%\n}\n\n.col-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%\n}\n\n.col-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%\n}\n\n.col-9 {\n    flex: 0 0 75%;\n    max-width: 75%\n}\n\n.col-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%\n}\n\n.col-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%\n}\n\n.col-12 {\n    flex: 0 0 100%;\n    max-width: 100%\n}\n\n.order-first {\n    order: -1\n}\n\n.order-last {\n    order: 13\n}\n\n.order-0 {\n    order: 0\n}\n\n.order-1 {\n    order: 1\n}\n\n.order-2 {\n    order: 2\n}\n\n.order-3 {\n    order: 3\n}\n\n.order-4 {\n    order: 4\n}\n\n.order-5 {\n    order: 5\n}\n\n.order-6 {\n    order: 6\n}\n\n.order-7 {\n    order: 7\n}\n\n.order-8 {\n    order: 8\n}\n\n.order-9 {\n    order: 9\n}\n\n.order-10 {\n    order: 10\n}\n\n.order-11 {\n    order: 11\n}\n\n.order-12 {\n    order: 12\n}\n\n.offset-1 {\n    margin-left: 8.33333%\n}\n\n.offset-2 {\n    margin-left: 16.66667%\n}\n\n.offset-3 {\n    margin-left: 25%\n}\n\n.offset-4 {\n    margin-left: 33.33333%\n}\n\n.offset-5 {\n    margin-left: 41.66667%\n}\n\n.offset-6 {\n    margin-left: 50%\n}\n\n.offset-7 {\n    margin-left: 58.33333%\n}\n\n.offset-8 {\n    margin-left: 66.66667%\n}\n\n.offset-9 {\n    margin-left: 75%\n}\n\n.offset-10 {\n    margin-left: 83.33333%\n}\n\n.offset-11 {\n    margin-left: 91.66667%\n}\n\n@media (min-width:576px) {\n    .col-sm {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-sm-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-sm-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-sm-3>* {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .row-cols-sm-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-sm-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-sm-6>* {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-sm-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-sm-1 {\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%\n    }\n\n    .col-sm-2 {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-sm-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-sm-4 {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .col-sm-5 {\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%\n    }\n\n    .col-sm-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-sm-7 {\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%\n    }\n\n    .col-sm-8 {\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%\n    }\n\n    .col-sm-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-sm-10 {\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%\n    }\n\n    .col-sm-11 {\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%\n    }\n\n    .col-sm-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-sm-first {\n        order: -1\n    }\n\n    .order-sm-last {\n        order: 13\n    }\n\n    .order-sm-0 {\n        order: 0\n    }\n\n    .order-sm-1 {\n        order: 1\n    }\n\n    .order-sm-2 {\n        order: 2\n    }\n\n    .order-sm-3 {\n        order: 3\n    }\n\n    .order-sm-4 {\n        order: 4\n    }\n\n    .order-sm-5 {\n        order: 5\n    }\n\n    .order-sm-6 {\n        order: 6\n    }\n\n    .order-sm-7 {\n        order: 7\n    }\n\n    .order-sm-8 {\n        order: 8\n    }\n\n    .order-sm-9 {\n        order: 9\n    }\n\n    .order-sm-10 {\n        order: 10\n    }\n\n    .order-sm-11 {\n        order: 11\n    }\n\n    .order-sm-12 {\n        order: 12\n    }\n\n    .offset-sm-0 {\n        margin-left: 0\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.66667%\n    }\n}\n\n@media (min-width:768px) {\n    .col-md {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-md-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-md-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-md-3>* {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .row-cols-md-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-md-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-md-6>* {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-md-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-md-1 {\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%\n    }\n\n    .col-md-2 {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-md-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-md-4 {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .col-md-5 {\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%\n    }\n\n    .col-md-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-md-7 {\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%\n    }\n\n    .col-md-8 {\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%\n    }\n\n    .col-md-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-md-10 {\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%\n    }\n\n    .col-md-11 {\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%\n    }\n\n    .col-md-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-md-first {\n        order: -1\n    }\n\n    .order-md-last {\n        order: 13\n    }\n\n    .order-md-0 {\n        order: 0\n    }\n\n    .order-md-1 {\n        order: 1\n    }\n\n    .order-md-2 {\n        order: 2\n    }\n\n    .order-md-3 {\n        order: 3\n    }\n\n    .order-md-4 {\n        order: 4\n    }\n\n    .order-md-5 {\n        order: 5\n    }\n\n    .order-md-6 {\n        order: 6\n    }\n\n    .order-md-7 {\n        order: 7\n    }\n\n    .order-md-8 {\n        order: 8\n    }\n\n    .order-md-9 {\n        order: 9\n    }\n\n    .order-md-10 {\n        order: 10\n    }\n\n    .order-md-11 {\n        order: 11\n    }\n\n    .order-md-12 {\n        order: 12\n    }\n\n    .offset-md-0 {\n        margin-left: 0\n    }\n\n    .offset-md-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-md-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-md-3 {\n        margin-left: 25%\n    }\n\n    .offset-md-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-md-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-md-6 {\n        margin-left: 50%\n    }\n\n    .offset-md-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-md-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-md-9 {\n        margin-left: 75%\n    }\n\n    .offset-md-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-md-11 {\n        margin-left: 91.66667%\n    }\n}\n\n@media (min-width:992px) {\n    .col-lg {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-lg-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-lg-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-lg-3>* {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .row-cols-lg-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-lg-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-lg-6>* {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-lg-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-lg-1 {\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%\n    }\n\n    .col-lg-2 {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-lg-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-lg-4 {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .col-lg-5 {\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%\n    }\n\n    .col-lg-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-lg-7 {\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%\n    }\n\n    .col-lg-8 {\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%\n    }\n\n    .col-lg-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-lg-10 {\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%\n    }\n\n    .col-lg-11 {\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%\n    }\n\n    .col-lg-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-lg-first {\n        order: -1\n    }\n\n    .order-lg-last {\n        order: 13\n    }\n\n    .order-lg-0 {\n        order: 0\n    }\n\n    .order-lg-1 {\n        order: 1\n    }\n\n    .order-lg-2 {\n        order: 2\n    }\n\n    .order-lg-3 {\n        order: 3\n    }\n\n    .order-lg-4 {\n        order: 4\n    }\n\n    .order-lg-5 {\n        order: 5\n    }\n\n    .order-lg-6 {\n        order: 6\n    }\n\n    .order-lg-7 {\n        order: 7\n    }\n\n    .order-lg-8 {\n        order: 8\n    }\n\n    .order-lg-9 {\n        order: 9\n    }\n\n    .order-lg-10 {\n        order: 10\n    }\n\n    .order-lg-11 {\n        order: 11\n    }\n\n    .order-lg-12 {\n        order: 12\n    }\n\n    .offset-lg-0 {\n        margin-left: 0\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.66667%\n    }\n}\n\n@media (min-width:1200px) {\n    .col-xl {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-xl-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-xl-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-xl-3>* {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .row-cols-xl-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-xl-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-xl-6>* {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-xl-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-xl-1 {\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%\n    }\n\n    .col-xl-2 {\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%\n    }\n\n    .col-xl-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-xl-4 {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%\n    }\n\n    .col-xl-5 {\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%\n    }\n\n    .col-xl-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-xl-7 {\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%\n    }\n\n    .col-xl-8 {\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%\n    }\n\n    .col-xl-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-xl-10 {\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%\n    }\n\n    .col-xl-11 {\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%\n    }\n\n    .col-xl-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-xl-first {\n        order: -1\n    }\n\n    .order-xl-last {\n        order: 13\n    }\n\n    .order-xl-0 {\n        order: 0\n    }\n\n    .order-xl-1 {\n        order: 1\n    }\n\n    .order-xl-2 {\n        order: 2\n    }\n\n    .order-xl-3 {\n        order: 3\n    }\n\n    .order-xl-4 {\n        order: 4\n    }\n\n    .order-xl-5 {\n        order: 5\n    }\n\n    .order-xl-6 {\n        order: 6\n    }\n\n    .order-xl-7 {\n        order: 7\n    }\n\n    .order-xl-8 {\n        order: 8\n    }\n\n    .order-xl-9 {\n        order: 9\n    }\n\n    .order-xl-10 {\n        order: 10\n    }\n\n    .order-xl-11 {\n        order: 11\n    }\n\n    .order-xl-12 {\n        order: 12\n    }\n\n    .offset-xl-0 {\n        margin-left: 0\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.66667%\n    }\n}\n\n.table {\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #858796\n}\n\n.table td,\n.table th {\n    padding: .75rem;\n    vertical-align: top;\n    border-top: 1px solid #e3e6f0\n}\n\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #e3e6f0\n}\n\n.table tbody+tbody {\n    border-top: 2px solid #e3e6f0\n}\n\n.table-sm td,\n.table-sm th {\n    padding: .3rem\n}\n\n.table-bordered {\n    border: 1px solid #e3e6f0\n}\n\n.table-bordered td,\n.table-bordered th {\n    border: 1px solid #e3e6f0\n}\n\n.table-bordered thead td,\n.table-bordered thead th {\n    border-bottom-width: 2px\n}\n\n.table-borderless tbody+tbody,\n.table-borderless td,\n.table-borderless th,\n.table-borderless thead th {\n    border: 0\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(0, 0, 0, .05)\n}\n\n.table-hover tbody tr:hover {\n    color: #858796;\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-primary,\n.table-primary>td,\n.table-primary>th {\n    background-color: #cdd8f6\n}\n\n.table-primary tbody+tbody,\n.table-primary td,\n.table-primary th,\n.table-primary thead th {\n    border-color: #a3b6ee\n}\n\n.table-hover .table-primary:hover {\n    background-color: #b7c7f2\n}\n\n.table-hover .table-primary:hover>td,\n.table-hover .table-primary:hover>th {\n    background-color: #b7c7f2\n}\n\n.table-secondary,\n.table-secondary>td,\n.table-secondary>th {\n    background-color: #dddde2\n}\n\n.table-secondary tbody+tbody,\n.table-secondary td,\n.table-secondary th,\n.table-secondary thead th {\n    border-color: #c0c1c8\n}\n\n.table-hover .table-secondary:hover {\n    background-color: #cfcfd6\n}\n\n.table-hover .table-secondary:hover>td,\n.table-hover .table-secondary:hover>th {\n    background-color: #cfcfd6\n}\n\n.table-success,\n.table-success>td,\n.table-success>th {\n    background-color: #bff0de\n}\n\n.table-success tbody+tbody,\n.table-success td,\n.table-success th,\n.table-success thead th {\n    border-color: #89e2c2\n}\n\n.table-hover .table-success:hover {\n    background-color: #aaebd3\n}\n\n.table-hover .table-success:hover>td,\n.table-hover .table-success:hover>th {\n    background-color: #aaebd3\n}\n\n.table-info,\n.table-info>td,\n.table-info>th {\n    background-color: #c7ebf1\n}\n\n.table-info tbody+tbody,\n.table-info td,\n.table-info th,\n.table-info thead th {\n    border-color: #96dbe4\n}\n\n.table-hover .table-info:hover {\n    background-color: #b3e4ec\n}\n\n.table-hover .table-info:hover>td,\n.table-hover .table-info:hover>th {\n    background-color: #b3e4ec\n}\n\n.table-warning,\n.table-warning>td,\n.table-warning>th {\n    background-color: #fceec9\n}\n\n.table-warning tbody+tbody,\n.table-warning td,\n.table-warning th,\n.table-warning thead th {\n    border-color: #fadf9b\n}\n\n.table-hover .table-warning:hover {\n    background-color: #fbe6b1\n}\n\n.table-hover .table-warning:hover>td,\n.table-hover .table-warning:hover>th {\n    background-color: #fbe6b1\n}\n\n.table-danger,\n.table-danger>td,\n.table-danger>th {\n    background-color: #f8ccc8\n}\n\n.table-danger tbody+tbody,\n.table-danger td,\n.table-danger th,\n.table-danger thead th {\n    border-color: #f3a199\n}\n\n.table-hover .table-danger:hover {\n    background-color: #f5b7b1\n}\n\n.table-hover .table-danger:hover>td,\n.table-hover .table-danger:hover>th {\n    background-color: #f5b7b1\n}\n\n.table-light,\n.table-light>td,\n.table-light>th {\n    background-color: #fdfdfe\n}\n\n.table-light tbody+tbody,\n.table-light td,\n.table-light th,\n.table-light thead th {\n    border-color: #fbfcfd\n}\n\n.table-hover .table-light:hover {\n    background-color: #ececf6\n}\n\n.table-hover .table-light:hover>td,\n.table-hover .table-light:hover>th {\n    background-color: #ececf6\n}\n\n.table-dark,\n.table-dark>td,\n.table-dark>th {\n    background-color: #d1d1d5\n}\n\n.table-dark tbody+tbody,\n.table-dark td,\n.table-dark th,\n.table-dark thead th {\n    border-color: #a9aab1\n}\n\n.table-hover .table-dark:hover {\n    background-color: #c4c4c9\n}\n\n.table-hover .table-dark:hover>td,\n.table-hover .table-dark:hover>th {\n    background-color: #c4c4c9\n}\n\n.table-active,\n.table-active>td,\n.table-active>th {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-hover .table-active:hover {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-hover .table-active:hover>td,\n.table-hover .table-active:hover>th {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table .thead-dark th {\n    color: #fff;\n    background-color: #5a5c69;\n    border-color: #6c6e7e\n}\n\n.table .thead-light th {\n    color: #6e707e;\n    background-color: #eaecf4;\n    border-color: #e3e6f0\n}\n\n.table-dark {\n    color: #fff;\n    background-color: #5a5c69\n}\n\n.table-dark td,\n.table-dark th,\n.table-dark thead th {\n    border-color: #6c6e7e\n}\n\n.table-dark.table-bordered {\n    border: 0\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, .05)\n}\n\n.table-dark.table-hover tbody tr:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .075)\n}\n\n@media (max-width:575.98px) {\n    .table-responsive-sm {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-sm>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width:767.98px) {\n    .table-responsive-md {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-md>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width:991.98px) {\n    .table-responsive-lg {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-lg>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width:1199.98px) {\n    .table-responsive-xl {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-xl>.table-bordered {\n        border: 0\n    }\n}\n\n.table-responsive {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch\n}\n\n.table-responsive>.table-bordered {\n    border: 0\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6e707e;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #d1d3e2;\n    border-radius: .35rem;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .form-control {\n        transition: none\n    }\n}\n\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0\n}\n\n.form-control:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #6e707e\n}\n\n.form-control:focus {\n    color: #6e707e;\n    background-color: #fff;\n    border-color: #bac8f3;\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.form-control::-webkit-input-placeholder {\n    color: #858796;\n    opacity: 1\n}\n\n.form-control::-moz-placeholder {\n    color: #858796;\n    opacity: 1\n}\n\n.form-control:-ms-input-placeholder {\n    color: #858796;\n    opacity: 1\n}\n\n.form-control::-ms-input-placeholder {\n    color: #858796;\n    opacity: 1\n}\n\n.form-control::placeholder {\n    color: #858796;\n    opacity: 1\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n    background-color: #eaecf4;\n    opacity: 1\n}\n\ninput[type=date].form-control,\ninput[type=datetime-local].form-control,\ninput[type=month].form-control,\ninput[type=time].form-control {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none\n}\n\nselect.form-control:focus::-ms-value {\n    color: #6e707e;\n    background-color: #fff\n}\n\n.form-control-file,\n.form-control-range {\n    display: block;\n    width: 100%\n}\n\n.col-form-label {\n    padding-top: calc(.375rem + 1px);\n    padding-bottom: calc(.375rem + 1px);\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5\n}\n\n.col-form-label-lg {\n    padding-top: calc(.5rem + 1px);\n    padding-bottom: calc(.5rem + 1px);\n    font-size: 1.25rem;\n    line-height: 1.5\n}\n\n.col-form-label-sm {\n    padding-top: calc(.25rem + 1px);\n    padding-bottom: calc(.25rem + 1px);\n    font-size: .875rem;\n    line-height: 1.5\n}\n\n.form-control-plaintext {\n    display: block;\n    width: 100%;\n    padding: .375rem 0;\n    margin-bottom: 0;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #858796;\n    background-color: transparent;\n    border: solid transparent;\n    border-width: 1px 0\n}\n\n.form-control-plaintext.form-control-lg,\n.form-control-plaintext.form-control-sm {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.form-control-sm {\n    height: calc(1.5em + .5rem + 2px);\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    border-radius: .2rem\n}\n\n.form-control-lg {\n    height: calc(1.5em + 1rem + 2px);\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    border-radius: .3rem\n}\n\nselect.form-control[multiple],\nselect.form-control[size] {\n    height: auto\n}\n\ntextarea.form-control {\n    height: auto\n}\n\n.form-group {\n    margin-bottom: 1rem\n}\n\n.form-text {\n    display: block;\n    margin-top: .25rem\n}\n\n.form-row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -5px;\n    margin-left: -5px\n}\n\n.form-row>.col,\n.form-row>[class*=col-] {\n    padding-right: 5px;\n    padding-left: 5px\n}\n\n.form-check {\n    position: relative;\n    display: block;\n    padding-left: 1.25rem\n}\n\n.form-check-input {\n    position: absolute;\n    margin-top: .3rem;\n    margin-left: -1.25rem\n}\n\n.form-check-input:disabled~.form-check-label,\n.form-check-input[disabled]~.form-check-label {\n    color: #858796\n}\n\n.form-check-label {\n    margin-bottom: 0\n}\n\n.form-check-inline {\n    display: inline-flex;\n    align-items: center;\n    padding-left: 0;\n    margin-right: .75rem\n}\n\n.form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: .3125rem;\n    margin-left: 0\n}\n\n.valid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: 80%;\n    color: #1cc88a\n}\n\n.valid-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .25rem .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    color: #fff;\n    background-color: rgba(28, 200, 138, .9);\n    border-radius: .35rem\n}\n\n.form-row>.col>.valid-tooltip,\n.form-row>[class*=col-]>.valid-tooltip {\n    left: 5px\n}\n\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip,\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip {\n    display: block\n}\n\n.form-control.is-valid,\n.was-validated .form-control:valid {\n    border-color: #1cc88a;\n    padding-right: calc(1.5em + .75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%231cc88a' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(.375em + .1875rem) center;\n    background-size: calc(.75em + .375rem) calc(.75em + .375rem)\n}\n\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n    border-color: #1cc88a;\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n    padding-right: calc(1.5em + .75rem);\n    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)\n}\n\n.custom-select.is-valid,\n.was-validated .custom-select:valid {\n    border-color: #1cc88a;\n    padding-right: calc(.75em + 2.3125rem);\n    background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%235a5c69' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%231cc88a' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat\n}\n\n.custom-select.is-valid:focus,\n.was-validated .custom-select:valid:focus {\n    border-color: #1cc88a;\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)\n}\n\n.form-check-input.is-valid~.form-check-label,\n.was-validated .form-check-input:valid~.form-check-label {\n    color: #1cc88a\n}\n\n.form-check-input.is-valid~.valid-feedback,\n.form-check-input.is-valid~.valid-tooltip,\n.was-validated .form-check-input:valid~.valid-feedback,\n.was-validated .form-check-input:valid~.valid-tooltip {\n    display: block\n}\n\n.custom-control-input.is-valid~.custom-control-label,\n.was-validated .custom-control-input:valid~.custom-control-label {\n    color: #1cc88a\n}\n\n.custom-control-input.is-valid~.custom-control-label::before,\n.was-validated .custom-control-input:valid~.custom-control-label::before {\n    border-color: #1cc88a\n}\n\n.custom-control-input.is-valid:checked~.custom-control-label::before,\n.was-validated .custom-control-input:valid:checked~.custom-control-label::before {\n    border-color: #34e3a4;\n    background-color: #34e3a4\n}\n\n.custom-control-input.is-valid:focus~.custom-control-label::before,\n.was-validated .custom-control-input:valid:focus~.custom-control-label::before {\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)\n}\n\n.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,\n.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before {\n    border-color: #1cc88a\n}\n\n.custom-file-input.is-valid~.custom-file-label,\n.was-validated .custom-file-input:valid~.custom-file-label {\n    border-color: #1cc88a\n}\n\n.custom-file-input.is-valid:focus~.custom-file-label,\n.was-validated .custom-file-input:valid:focus~.custom-file-label {\n    border-color: #1cc88a;\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .25)\n}\n\n.invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: 80%;\n    color: #e74a3b\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .25rem .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    color: #fff;\n    background-color: rgba(231, 74, 59, .9);\n    border-radius: .35rem\n}\n\n.form-row>.col>.invalid-tooltip,\n.form-row>[class*=col-]>.invalid-tooltip {\n    left: 5px\n}\n\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip,\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip {\n    display: block\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n    border-color: #e74a3b;\n    padding-right: calc(1.5em + .75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e74a3b' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e74a3b' stroke='none'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(.375em + .1875rem) center;\n    background-size: calc(.75em + .375rem) calc(.75em + .375rem)\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n    border-color: #e74a3b;\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n    padding-right: calc(1.5em + .75rem);\n    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)\n}\n\n.custom-select.is-invalid,\n.was-validated .custom-select:invalid {\n    border-color: #e74a3b;\n    padding-right: calc(.75em + 2.3125rem);\n    background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%235a5c69' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e74a3b' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e74a3b' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat\n}\n\n.custom-select.is-invalid:focus,\n.was-validated .custom-select:invalid:focus {\n    border-color: #e74a3b;\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)\n}\n\n.form-check-input.is-invalid~.form-check-label,\n.was-validated .form-check-input:invalid~.form-check-label {\n    color: #e74a3b\n}\n\n.form-check-input.is-invalid~.invalid-feedback,\n.form-check-input.is-invalid~.invalid-tooltip,\n.was-validated .form-check-input:invalid~.invalid-feedback,\n.was-validated .form-check-input:invalid~.invalid-tooltip {\n    display: block\n}\n\n.custom-control-input.is-invalid~.custom-control-label,\n.was-validated .custom-control-input:invalid~.custom-control-label {\n    color: #e74a3b\n}\n\n.custom-control-input.is-invalid~.custom-control-label::before,\n.was-validated .custom-control-input:invalid~.custom-control-label::before {\n    border-color: #e74a3b\n}\n\n.custom-control-input.is-invalid:checked~.custom-control-label::before,\n.was-validated .custom-control-input:invalid:checked~.custom-control-label::before {\n    border-color: #ed7468;\n    background-color: #ed7468\n}\n\n.custom-control-input.is-invalid:focus~.custom-control-label::before,\n.was-validated .custom-control-input:invalid:focus~.custom-control-label::before {\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)\n}\n\n.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,\n.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before {\n    border-color: #e74a3b\n}\n\n.custom-file-input.is-invalid~.custom-file-label,\n.was-validated .custom-file-input:invalid~.custom-file-label {\n    border-color: #e74a3b\n}\n\n.custom-file-input.is-invalid:focus~.custom-file-label,\n.was-validated .custom-file-input:invalid:focus~.custom-file-label {\n    border-color: #e74a3b;\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .25)\n}\n\n.form-inline {\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center\n}\n\n.form-inline .form-check {\n    width: 100%\n}\n\n@media (min-width:576px) {\n    .form-inline label {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 0\n    }\n\n    .form-inline .form-group {\n        display: flex;\n        flex: 0 0 auto;\n        flex-flow: row wrap;\n        align-items: center;\n        margin-bottom: 0\n    }\n\n    .form-inline .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle\n    }\n\n    .form-inline .form-control-plaintext {\n        display: inline-block\n    }\n\n    .form-inline .custom-select,\n    .form-inline .input-group {\n        width: auto\n    }\n\n    .form-inline .form-check {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: auto;\n        padding-left: 0\n    }\n\n    .form-inline .form-check-input {\n        position: relative;\n        flex-shrink: 0;\n        margin-top: 0;\n        margin-right: .25rem;\n        margin-left: 0\n    }\n\n    .form-inline .custom-control {\n        align-items: center;\n        justify-content: center\n    }\n\n    .form-inline .custom-control-label {\n        margin-bottom: 0\n    }\n}\n\n.btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #858796;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: .35rem;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .btn {\n        transition: none\n    }\n}\n\n.btn:hover {\n    color: #858796;\n    text-decoration: none\n}\n\n.btn.focus,\n.btn:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.btn.disabled,\n.btn:disabled {\n    opacity: .65\n}\n\n.btn:not(:disabled):not(.disabled) {\n    cursor: pointer\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n    pointer-events: none\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.btn-Excel {\n    color: #f5f5f5;\n    background-color: #38c61c;\n    border-color: #38c61c;\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #2e59d9;\n    border-color: #2653d4\n}\n\n.btn-primary.focus,\n.btn-primary:focus {\n    color: #fff;\n    background-color: #2e59d9;\n    border-color: #2653d4;\n    box-shadow: 0 0 0 .2rem rgba(105, 136, 228, .5)\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active,\n.show>.btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #2653d4;\n    border-color: #244ec9\n}\n\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(105, 136, 228, .5)\n}\n\n.btn-secondary {\n    color: #fff;\n    background-color: #858796;\n    border-color: #858796\n}\n\n.btn-secondary:hover {\n    color: #fff;\n    background-color: #717384;\n    border-color: #6b6d7d\n}\n\n.btn-secondary.focus,\n.btn-secondary:focus {\n    color: #fff;\n    background-color: #717384;\n    border-color: #6b6d7d;\n    box-shadow: 0 0 0 .2rem rgba(151, 153, 166, .5)\n}\n\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n    color: #fff;\n    background-color: #858796;\n    border-color: #858796\n}\n\n.btn-secondary:not(:disabled):not(.disabled).active,\n.btn-secondary:not(:disabled):not(.disabled):active,\n.show>.btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6b6d7d;\n    border-color: #656776\n}\n\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-secondary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(151, 153, 166, .5)\n}\n\n.btn-success {\n    color: #fff;\n    background-color: #1cc88a;\n    border-color: #1cc88a\n}\n\n.btn-success:hover {\n    color: #fff;\n    background-color: #17a673;\n    border-color: #169b6b\n}\n\n.btn-success.focus,\n.btn-success:focus {\n    color: #fff;\n    background-color: #17a673;\n    border-color: #169b6b;\n    box-shadow: 0 0 0 .2rem rgba(62, 208, 156, .5)\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n    color: #fff;\n    background-color: #1cc88a;\n    border-color: #1cc88a\n}\n\n.btn-success:not(:disabled):not(.disabled).active,\n.btn-success:not(:disabled):not(.disabled):active,\n.show>.btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #169b6b;\n    border-color: #149063\n}\n\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.show>.btn-success.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(62, 208, 156, .5)\n}\n\n.btn-info {\n    color: #fff;\n    background-color: #36b9cc;\n    border-color: #36b9cc\n}\n\n.btn-info:hover {\n    color: #fff;\n    background-color: #2c9faf;\n    border-color: #2a96a5\n}\n\n.btn-info.focus,\n.btn-info:focus {\n    color: #fff;\n    background-color: #2c9faf;\n    border-color: #2a96a5;\n    box-shadow: 0 0 0 .2rem rgba(84, 196, 212, .5)\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n    color: #fff;\n    background-color: #36b9cc;\n    border-color: #36b9cc\n}\n\n.btn-info:not(:disabled):not(.disabled).active,\n.btn-info:not(:disabled):not(.disabled):active,\n.show>.btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #2a96a5;\n    border-color: #278c9b\n}\n\n.btn-info:not(:disabled):not(.disabled).active:focus,\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.show>.btn-info.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(84, 196, 212, .5)\n}\n\n.btn-warning {\n    color: #fff;\n    background-color: #f6c23e;\n    border-color: #f6c23e\n}\n\n.btn-warning:hover {\n    color: #fff;\n    background-color: #f4b619;\n    border-color: #f4b30d\n}\n\n.btn-warning.focus,\n.btn-warning:focus {\n    color: #fff;\n    background-color: #f4b619;\n    border-color: #f4b30d;\n    box-shadow: 0 0 0 .2rem rgba(247, 203, 91, .5)\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n    color: #fff;\n    background-color: #f6c23e;\n    border-color: #f6c23e\n}\n\n.btn-warning:not(:disabled):not(.disabled).active,\n.btn-warning:not(:disabled):not(.disabled):active,\n.show>.btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #f4b30d;\n    border-color: #e9aa0b\n}\n\n.btn-warning:not(:disabled):not(.disabled).active:focus,\n.btn-warning:not(:disabled):not(.disabled):active:focus,\n.show>.btn-warning.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(247, 203, 91, .5)\n}\n\n.btn-danger {\n    color: #fff;\n    background-color: #e74a3b;\n    border-color: #e74a3b\n}\n\n.btn-danger:hover {\n    color: #fff;\n    background-color: #e02d1b;\n    border-color: #d52a1a\n}\n\n.btn-danger.focus,\n.btn-danger:focus {\n    color: #fff;\n    background-color: #e02d1b;\n    border-color: #d52a1a;\n    box-shadow: 0 0 0 .2rem rgba(235, 101, 88, .5)\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n    color: #fff;\n    background-color: #e74a3b;\n    border-color: #e74a3b\n}\n\n.btn-danger:not(:disabled):not(.disabled).active,\n.btn-danger:not(:disabled):not(.disabled):active,\n.show>.btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #d52a1a;\n    border-color: #ca2819\n}\n\n.btn-danger:not(:disabled):not(.disabled).active:focus,\n.btn-danger:not(:disabled):not(.disabled):active:focus,\n.show>.btn-danger.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(235, 101, 88, .5)\n}\n\n.btn-light {\n    color: #3a3b45;\n    background-color: #f8f9fc;\n    border-color: #f8f9fc\n}\n\n.btn-light:hover {\n    color: #3a3b45;\n    background-color: #dde2f1;\n    border-color: #d4daed\n}\n\n.btn-light.focus,\n.btn-light:focus {\n    color: #3a3b45;\n    background-color: #dde2f1;\n    border-color: #d4daed;\n    box-shadow: 0 0 0 .2rem rgba(220, 221, 225, .5)\n}\n\n.btn-light.disabled,\n.btn-light:disabled {\n    color: #3a3b45;\n    background-color: #f8f9fc;\n    border-color: #f8f9fc\n}\n\n.btn-light:not(:disabled):not(.disabled).active,\n.btn-light:not(:disabled):not(.disabled):active,\n.show>.btn-light.dropdown-toggle {\n    color: #3a3b45;\n    background-color: #d4daed;\n    border-color: #cbd3e9\n}\n\n.btn-light:not(:disabled):not(.disabled).active:focus,\n.btn-light:not(:disabled):not(.disabled):active:focus,\n.show>.btn-light.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(220, 221, 225, .5)\n}\n\n.btn-dark {\n    color: #fff;\n    background-color: #5a5c69;\n    border-color: #5a5c69\n}\n\n.btn-dark:hover {\n    color: #fff;\n    background-color: #484a54;\n    border-color: #42444e\n}\n\n.btn-dark.focus,\n.btn-dark:focus {\n    color: #fff;\n    background-color: #484a54;\n    border-color: #42444e;\n    box-shadow: 0 0 0 .2rem rgba(115, 116, 128, .5)\n}\n\n.btn-dark.disabled,\n.btn-dark:disabled {\n    color: #fff;\n    background-color: #5a5c69;\n    border-color: #5a5c69\n}\n\n.btn-dark:not(:disabled):not(.disabled).active,\n.btn-dark:not(:disabled):not(.disabled):active,\n.show>.btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #42444e;\n    border-color: #3d3e47\n}\n\n.btn-dark:not(:disabled):not(.disabled).active:focus,\n.btn-dark:not(:disabled):not(.disabled):active:focus,\n.show>.btn-dark.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(115, 116, 128, .5)\n}\n\n.btn-outline-primary {\n    color: #4e73df;\n    border-color: #4e73df\n}\n\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.btn-outline-primary.focus,\n.btn-outline-primary:focus {\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n    color: #4e73df;\n    background-color: transparent\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.show>.btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-primary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)\n}\n\n.btn-outline-secondary {\n    color: #858796;\n    border-color: #858796\n}\n\n.btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #858796;\n    border-color: #858796\n}\n\n.btn-outline-secondary.focus,\n.btn-outline-secondary:focus {\n    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)\n}\n\n.btn-outline-secondary.disabled,\n.btn-outline-secondary:disabled {\n    color: #858796;\n    background-color: transparent\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\n.show>.btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #858796;\n    border-color: #858796\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-secondary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)\n}\n\n.btn-outline-success {\n    color: #1cc88a;\n    border-color: #1cc88a\n}\n\n.btn-outline-success:hover {\n    color: #fff;\n    background-color: #1cc88a;\n    border-color: #1cc88a\n}\n\n.btn-outline-success.focus,\n.btn-outline-success:focus {\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n    color: #1cc88a;\n    background-color: transparent\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.btn-outline-success:not(:disabled):not(.disabled):active,\n.show>.btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #1cc88a;\n    border-color: #1cc88a\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-success.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)\n}\n\n.btn-outline-info {\n    color: #36b9cc;\n    border-color: #36b9cc\n}\n\n.btn-outline-info:hover {\n    color: #fff;\n    background-color: #36b9cc;\n    border-color: #36b9cc\n}\n\n.btn-outline-info.focus,\n.btn-outline-info:focus {\n    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n    color: #36b9cc;\n    background-color: transparent\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.btn-outline-info:not(:disabled):not(.disabled):active,\n.show>.btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #36b9cc;\n    border-color: #36b9cc\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-info.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)\n}\n\n.btn-outline-warning {\n    color: #f6c23e;\n    border-color: #f6c23e\n}\n\n.btn-outline-warning:hover {\n    color: #fff;\n    background-color: #f6c23e;\n    border-color: #f6c23e\n}\n\n.btn-outline-warning.focus,\n.btn-outline-warning:focus {\n    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n    color: #f6c23e;\n    background-color: transparent\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.btn-outline-warning:not(:disabled):not(.disabled):active,\n.show>.btn-outline-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #f6c23e;\n    border-color: #f6c23e\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-warning.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)\n}\n\n.btn-outline-danger {\n    color: #e74a3b;\n    border-color: #e74a3b\n}\n\n.btn-outline-danger:hover {\n    color: #fff;\n    background-color: #e74a3b;\n    border-color: #e74a3b\n}\n\n.btn-outline-danger.focus,\n.btn-outline-danger:focus {\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n    color: #e74a3b;\n    background-color: transparent\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.btn-outline-danger:not(:disabled):not(.disabled):active,\n.show>.btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #e74a3b;\n    border-color: #e74a3b\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-danger.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)\n}\n\n.btn-outline-light {\n    color: #f8f9fc;\n    border-color: #f8f9fc\n}\n\n.btn-outline-light:hover {\n    color: #3a3b45;\n    background-color: #f8f9fc;\n    border-color: #f8f9fc\n}\n\n.btn-outline-light.focus,\n.btn-outline-light:focus {\n    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)\n}\n\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n    color: #f8f9fc;\n    background-color: transparent\n}\n\n.btn-outline-light:not(:disabled):not(.disabled).active,\n.btn-outline-light:not(:disabled):not(.disabled):active,\n.show>.btn-outline-light.dropdown-toggle {\n    color: #3a3b45;\n    background-color: #f8f9fc;\n    border-color: #f8f9fc\n}\n\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-light.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)\n}\n\n.btn-outline-dark {\n    color: #5a5c69;\n    border-color: #5a5c69\n}\n\n.btn-outline-dark:hover {\n    color: #fff;\n    background-color: #5a5c69;\n    border-color: #5a5c69\n}\n\n.btn-outline-dark.focus,\n.btn-outline-dark:focus {\n    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)\n}\n\n.btn-outline-dark.disabled,\n.btn-outline-dark:disabled {\n    color: #5a5c69;\n    background-color: transparent\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled).active,\n.btn-outline-dark:not(:disabled):not(.disabled):active,\n.show>.btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #5a5c69;\n    border-color: #5a5c69\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\n.show>.btn-outline-dark.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)\n}\n\n.btn-link {\n    font-weight: 400;\n    color: #4e73df;\n    text-decoration: none\n}\n\n.btn-link:hover {\n    color: #224abe;\n    text-decoration: underline\n}\n\n.btn-link.focus,\n.btn-link:focus {\n    text-decoration: underline\n}\n\n.btn-link.disabled,\n.btn-link:disabled {\n    color: #858796;\n    pointer-events: none\n}\n\n.btn-group-lg>.btn,\n.btn-lg {\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    border-radius: .3rem\n}\n\n.btn-group-sm>.btn,\n.btn-sm {\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    border-radius: .2rem\n}\n\n.btn-block {\n    display: block;\n    width: 100%\n}\n\n.btn-block+.btn-block {\n    margin-top: .5rem\n}\n\ninput[type=button].btn-block,\ninput[type=reset].btn-block,\ninput[type=submit].btn-block {\n    width: 100%\n}\n\n.fade {\n    transition: opacity .15s linear\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .fade {\n        transition: none\n    }\n}\n\n.fade:not(.show) {\n    opacity: 0\n}\n\n.collapse:not(.show) {\n    display: none\n}\n\n.collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition: height .15s ease\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .collapsing {\n        transition: none\n    }\n}\n\n.dropdown,\n.dropleft,\n.dropright,\n.dropup {\n    position: relative\n}\n\n.dropdown-toggle {\n    white-space: nowrap\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid;\n    border-right: .3em solid transparent;\n    border-bottom: 0;\n    border-left: .3em solid transparent\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: .5rem 0;\n    margin: .125rem 0 0;\n    font-size: .85rem;\n    color: #858796;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #e3e6f0;\n    border-radius: .35rem\n}\n\n.dropdown-menu-left {\n    right: auto;\n    left: 0\n}\n\n.dropdown-menu-right {\n    right: 0;\n    left: auto\n}\n\n@media (min-width:576px) {\n    .dropdown-menu-sm-left {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-sm-right {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width:768px) {\n    .dropdown-menu-md-left {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-md-right {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width:992px) {\n    .dropdown-menu-lg-left {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-lg-right {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width:1200px) {\n    .dropdown-menu-xl-left {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-xl-right {\n        right: 0;\n        left: auto\n    }\n}\n\n.dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: .125rem\n}\n\n.dropup .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: 0;\n    border-right: .3em solid transparent;\n    border-bottom: .3em solid;\n    border-left: .3em solid transparent\n}\n\n.dropup .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropright .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: .125rem\n}\n\n.dropright .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid transparent;\n    border-right: 0;\n    border-bottom: .3em solid transparent;\n    border-left: .3em solid\n}\n\n.dropright .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropright .dropdown-toggle::after {\n    vertical-align: 0\n}\n\n.dropleft .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: .125rem\n}\n\n.dropleft .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\"\n}\n\n.dropleft .dropdown-toggle::after {\n    display: none\n}\n\n.dropleft .dropdown-toggle::before {\n    display: inline-block;\n    margin-right: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid transparent;\n    border-right: .3em solid;\n    border-bottom: .3em solid transparent\n}\n\n.dropleft .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropleft .dropdown-toggle::before {\n    vertical-align: 0\n}\n\n.dropdown-menu[x-placement^=bottom],\n.dropdown-menu[x-placement^=left],\n.dropdown-menu[x-placement^=right],\n.dropdown-menu[x-placement^=top] {\n    right: auto;\n    bottom: auto\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: .5rem 0;\n    overflow: hidden;\n    border-top: 1px solid #eaecf4\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: .25rem 1.5rem;\n    clear: both;\n    font-weight: 400;\n    color: #3a3b45;\n    text-align: inherit;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    color: #2e2f37;\n    text-decoration: none;\n    background-color: #eaecf4\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #4e73df\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n    color: #b7b9cc;\n    pointer-events: none;\n    background-color: transparent\n}\n\n.dropdown-menu.show {\n    display: block\n}\n\n.dropdown-header {\n    display: block;\n    padding: .5rem 1.5rem;\n    margin-bottom: 0;\n    font-size: .875rem;\n    color: #858796;\n    white-space: nowrap\n}\n\n.dropdown-item-text {\n    display: block;\n    padding: .25rem 1.5rem;\n    color: #3a3b45\n}\n\n.btn-group,\n.btn-group-vertical {\n    position: relative;\n    display: inline-flex;\n    vertical-align: middle\n}\n\n.btn-group-vertical>.btn,\n.btn-group>.btn {\n    position: relative;\n    flex: 1 1 auto\n}\n\n.btn-group-vertical>.btn:hover,\n.btn-group>.btn:hover {\n    z-index: 1\n}\n\n.btn-group-vertical>.btn.active,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn:focus,\n.btn-group>.btn.active,\n.btn-group>.btn:active,\n.btn-group>.btn:focus {\n    z-index: 1\n}\n\n.btn-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start\n}\n\n.btn-toolbar .input-group {\n    width: auto\n}\n\n.btn-group>.btn-group:not(:first-child),\n.btn-group>.btn:not(:first-child) {\n    margin-left: -1px\n}\n\n.btn-group>.btn-group:not(:last-child)>.btn,\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.btn-group>.btn-group:not(:first-child)>.btn,\n.btn-group>.btn:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.dropdown-toggle-split {\n    padding-right: .5625rem;\n    padding-left: .5625rem\n}\n\n.dropdown-toggle-split::after,\n.dropright .dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after {\n    margin-left: 0\n}\n\n.dropleft .dropdown-toggle-split::before {\n    margin-right: 0\n}\n\n.btn-group-sm>.btn+.dropdown-toggle-split,\n.btn-sm+.dropdown-toggle-split {\n    padding-right: .375rem;\n    padding-left: .375rem\n}\n\n.btn-group-lg>.btn+.dropdown-toggle-split,\n.btn-lg+.dropdown-toggle-split {\n    padding-right: .75rem;\n    padding-left: .75rem\n}\n\n.btn-group-vertical {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n    width: 100%\n}\n\n.btn-group-vertical>.btn-group:not(:first-child),\n.btn-group-vertical>.btn:not(:first-child) {\n    margin-top: -1px\n}\n\n.btn-group-vertical>.btn-group:not(:last-child)>.btn,\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.btn-group-vertical>.btn-group:not(:first-child)>.btn,\n.btn-group-vertical>.btn:not(:first-child) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.btn-group-toggle>.btn,\n.btn-group-toggle>.btn-group>.btn {\n    margin-bottom: 0\n}\n\n.btn-group-toggle>.btn input[type=checkbox],\n.btn-group-toggle>.btn input[type=radio],\n.btn-group-toggle>.btn-group>.btn input[type=checkbox],\n.btn-group-toggle>.btn-group>.btn input[type=radio] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none\n}\n\n.input-group {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%\n}\n\n.input-group>.custom-file,\n.input-group>.custom-select,\n.input-group>.form-control,\n.input-group>.form-control-plaintext {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0;\n    margin-bottom: 0\n}\n\n.input-group>.custom-file+.custom-file,\n.input-group>.custom-file+.custom-select,\n.input-group>.custom-file+.form-control,\n.input-group>.custom-select+.custom-file,\n.input-group>.custom-select+.custom-select,\n.input-group>.custom-select+.form-control,\n.input-group>.form-control+.custom-file,\n.input-group>.form-control+.custom-select,\n.input-group>.form-control+.form-control,\n.input-group>.form-control-plaintext+.custom-file,\n.input-group>.form-control-plaintext+.custom-select,\n.input-group>.form-control-plaintext+.form-control {\n    margin-left: -1px\n}\n\n.input-group>.custom-file .custom-file-input:focus~.custom-file-label,\n.input-group>.custom-select:focus,\n.input-group>.form-control:focus {\n    z-index: 3\n}\n\n.input-group>.custom-file .custom-file-input:focus {\n    z-index: 4\n}\n\n.input-group>.custom-select:not(:first-child),\n.input-group>.form-control:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.input-group>.custom-file {\n    display: flex;\n    align-items: center\n}\n\n.input-group>.custom-file:not(:first-child) .custom-file-label,\n.input-group>.custom-file:not(:last-child) .custom-file-label {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after,\n.input-group:not(.has-validation)>.custom-select:not(:last-child),\n.input-group:not(.has-validation)>.form-control:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label::after,\n.input-group.has-validation>.custom-select:nth-last-child(n+3),\n.input-group.has-validation>.form-control:nth-last-child(n+3) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group-append,\n.input-group-prepend {\n    display: flex\n}\n\n.input-group-append .btn,\n.input-group-prepend .btn {\n    position: relative;\n    z-index: 2\n}\n\n.input-group-append .btn:focus,\n.input-group-prepend .btn:focus {\n    z-index: 3\n}\n\n.input-group-append .btn+.btn,\n.input-group-append .btn+.input-group-text,\n.input-group-append .input-group-text+.btn,\n.input-group-append .input-group-text+.input-group-text,\n.input-group-prepend .btn+.btn,\n.input-group-prepend .btn+.input-group-text,\n.input-group-prepend .input-group-text+.btn,\n.input-group-prepend .input-group-text+.input-group-text {\n    margin-left: -1px\n}\n\n.input-group-prepend {\n    margin-right: -1px\n}\n\n.input-group-append {\n    margin-left: -1px\n}\n\n.input-group-text {\n    display: flex;\n    align-items: center;\n    padding: .375rem .75rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6e707e;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #eaecf4;\n    border: 1px solid #d1d3e2;\n    border-radius: .35rem\n}\n\n.input-group-text input[type=checkbox],\n.input-group-text input[type=radio] {\n    margin-top: 0\n}\n\n.input-group-lg>.custom-select,\n.input-group-lg>.form-control:not(textarea) {\n    height: calc(1.5em + 1rem + 2px)\n}\n\n.input-group-lg>.custom-select,\n.input-group-lg>.form-control,\n.input-group-lg>.input-group-append>.btn,\n.input-group-lg>.input-group-append>.input-group-text,\n.input-group-lg>.input-group-prepend>.btn,\n.input-group-lg>.input-group-prepend>.input-group-text {\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    border-radius: .3rem\n}\n\n.input-group-sm>.custom-select,\n.input-group-sm>.form-control:not(textarea) {\n    height: calc(1.5em + .5rem + 2px)\n}\n\n.input-group-sm>.custom-select,\n.input-group-sm>.form-control,\n.input-group-sm>.input-group-append>.btn,\n.input-group-sm>.input-group-append>.input-group-text,\n.input-group-sm>.input-group-prepend>.btn,\n.input-group-sm>.input-group-prepend>.input-group-text {\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    border-radius: .2rem\n}\n\n.input-group-lg>.custom-select,\n.input-group-sm>.custom-select {\n    padding-right: 1.75rem\n}\n\n.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,\n.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,\n.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,\n.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,\n.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\n.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),\n.input-group>.input-group-prepend>.btn,\n.input-group>.input-group-prepend>.input-group-text {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group>.input-group-append>.btn,\n.input-group>.input-group-append>.input-group-text,\n.input-group>.input-group-prepend:first-child>.btn:not(:first-child),\n.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),\n.input-group>.input-group-prepend:not(:first-child)>.btn,\n.input-group>.input-group-prepend:not(:first-child)>.input-group-text {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.custom-control {\n    position: relative;\n    z-index: 1;\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.5rem;\n    -webkit-print-color-adjust: exact;\n    color-adjust: exact\n}\n\n.custom-control-inline {\n    display: inline-flex;\n    margin-right: 1rem\n}\n\n.custom-control-input {\n    position: absolute;\n    left: 0;\n    z-index: -1;\n    width: 1rem;\n    height: 1.25rem;\n    opacity: 0\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n    color: #fff;\n    border-color: #4e73df;\n    background-color: #4e73df\n}\n\n.custom-control-input:focus~.custom-control-label::before {\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-control-input:focus:not(:checked)~.custom-control-label::before {\n    border-color: #bac8f3\n}\n\n.custom-control-input:not(:disabled):active~.custom-control-label::before {\n    color: #fff;\n    background-color: #e5ebfa;\n    border-color: #e5ebfa\n}\n\n.custom-control-input:disabled~.custom-control-label,\n.custom-control-input[disabled]~.custom-control-label {\n    color: #858796\n}\n\n.custom-control-input:disabled~.custom-control-label::before,\n.custom-control-input[disabled]~.custom-control-label::before {\n    background-color: #eaecf4\n}\n\n.custom-control-label {\n    position: relative;\n    margin-bottom: 0;\n    vertical-align: top\n}\n\n.custom-control-label::before {\n    position: absolute;\n    top: .25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    background-color: #fff;\n    border: #b7b9cc solid 1px\n}\n\n.custom-control-label::after {\n    position: absolute;\n    top: .25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background: 50%/50% 50% no-repeat\n}\n\n.custom-checkbox .custom-control-label::before {\n    border-radius: .35rem\n}\n\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")\n}\n\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {\n    border-color: #4e73df;\n    background-color: #4e73df\n}\n\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")\n}\n\n.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {\n    background-color: rgba(78, 115, 223, .5)\n}\n\n.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {\n    background-color: rgba(78, 115, 223, .5)\n}\n\n.custom-radio .custom-control-label::before {\n    border-radius: 50%\n}\n\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")\n}\n\n.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {\n    background-color: rgba(78, 115, 223, .5)\n}\n\n.custom-switch {\n    padding-left: 2.25rem\n}\n\n.custom-switch .custom-control-label::before {\n    left: -2.25rem;\n    width: 1.75rem;\n    pointer-events: all;\n    border-radius: .5rem\n}\n\n.custom-switch .custom-control-label::after {\n    top: calc(.25rem + 2px);\n    left: calc(-2.25rem + 2px);\n    width: calc(1rem - 4px);\n    height: calc(1rem - 4px);\n    background-color: #b7b9cc;\n    border-radius: .5rem;\n    transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .custom-switch .custom-control-label::after {\n        transition: none\n    }\n}\n\n.custom-switch .custom-control-input:checked~.custom-control-label::after {\n    background-color: #fff;\n    transform: translateX(.75rem)\n}\n\n.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {\n    background-color: rgba(78, 115, 223, .5)\n}\n\n.custom-select {\n    display: inline-block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem 1.75rem .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6e707e;\n    vertical-align: middle;\n    background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%235a5c69' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat;\n    border: 1px solid #d1d3e2;\n    border-radius: .35rem;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none\n}\n\n.custom-select:focus {\n    border-color: #bac8f3;\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-select:focus::-ms-value {\n    color: #6e707e;\n    background-color: #fff\n}\n\n.custom-select[multiple],\n.custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: .75rem;\n    background-image: none\n}\n\n.custom-select:disabled {\n    color: #858796;\n    background-color: #eaecf4\n}\n\n.custom-select::-ms-expand {\n    display: none\n}\n\n.custom-select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #6e707e\n}\n\n.custom-select-sm {\n    height: calc(1.5em + .5rem + 2px);\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n    padding-left: .5rem;\n    font-size: .875rem\n}\n\n.custom-select-lg {\n    height: calc(1.5em + 1rem + 2px);\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    padding-left: 1rem;\n    font-size: 1.25rem\n}\n\n.custom-file {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    margin-bottom: 0\n}\n\n.custom-file-input {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    margin: 0;\n    overflow: hidden;\n    opacity: 0\n}\n\n.custom-file-input:focus~.custom-file-label {\n    border-color: #bac8f3;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-file-input:disabled~.custom-file-label,\n.custom-file-input[disabled]~.custom-file-label {\n    background-color: #eaecf4\n}\n\n.custom-file-input:lang(en)~.custom-file-label::after {\n    content: \"Browse\"\n}\n\n.custom-file-input~.custom-file-label[data-browse]::after {\n    content: attr(data-browse)\n}\n\n.custom-file-label {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem .75rem;\n    overflow: hidden;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6e707e;\n    background-color: #fff;\n    border: 1px solid #d1d3e2;\n    border-radius: .35rem\n}\n\n.custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(1.5em + .75rem);\n    padding: .375rem .75rem;\n    line-height: 1.5;\n    color: #6e707e;\n    content: \"Browse\";\n    background-color: #eaecf4;\n    border-left: inherit;\n    border-radius: 0 .35rem .35rem 0\n}\n\n.custom-range {\n    width: 100%;\n    height: 1.4rem;\n    padding: 0;\n    background-color: transparent;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none\n}\n\n.custom-range:focus {\n    outline: 0\n}\n\n.custom-range:focus::-webkit-slider-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-range:focus::-moz-range-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-range:focus::-ms-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.custom-range::-moz-focus-outer {\n    border: 0\n}\n\n.custom-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -.25rem;\n    background-color: #4e73df;\n    border: 0;\n    border-radius: 1rem;\n    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    -webkit-appearance: none;\n    appearance: none\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .custom-range::-webkit-slider-thumb {\n        -webkit-transition: none;\n        transition: none\n    }\n}\n\n.custom-range::-webkit-slider-thumb:active {\n    background-color: #e5ebfa\n}\n\n.custom-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: .5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dddfeb;\n    border-color: transparent;\n    border-radius: 1rem\n}\n\n.custom-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #4e73df;\n    border: 0;\n    border-radius: 1rem;\n    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    -moz-appearance: none;\n    appearance: none\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .custom-range::-moz-range-thumb {\n        -moz-transition: none;\n        transition: none\n    }\n}\n\n.custom-range::-moz-range-thumb:active {\n    background-color: #e5ebfa\n}\n\n.custom-range::-moz-range-track {\n    width: 100%;\n    height: .5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dddfeb;\n    border-color: transparent;\n    border-radius: 1rem\n}\n\n.custom-range::-ms-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: 0;\n    margin-right: .2rem;\n    margin-left: .2rem;\n    background-color: #4e73df;\n    border: 0;\n    border-radius: 1rem;\n    -ms-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    appearance: none\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .custom-range::-ms-thumb {\n        -ms-transition: none;\n        transition: none\n    }\n}\n\n.custom-range::-ms-thumb:active {\n    background-color: #e5ebfa\n}\n\n.custom-range::-ms-track {\n    width: 100%;\n    height: .5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: .5rem\n}\n\n.custom-range::-ms-fill-lower {\n    background-color: #dddfeb;\n    border-radius: 1rem\n}\n\n.custom-range::-ms-fill-upper {\n    margin-right: 15px;\n    background-color: #dddfeb;\n    border-radius: 1rem\n}\n\n.custom-range:disabled::-webkit-slider-thumb {\n    background-color: #b7b9cc\n}\n\n.custom-range:disabled::-webkit-slider-runnable-track {\n    cursor: default\n}\n\n.custom-range:disabled::-moz-range-thumb {\n    background-color: #b7b9cc\n}\n\n.custom-range:disabled::-moz-range-track {\n    cursor: default\n}\n\n.custom-range:disabled::-ms-thumb {\n    background-color: #b7b9cc\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .custom-control-label::before,\n    .custom-file-label,\n    .custom-select {\n        transition: none\n    }\n}\n\n.nav {\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.nav-link {\n    display: block;\n    padding: .5rem 1rem\n}\n\n.nav-link:focus,\n.nav-link:hover {\n    text-decoration: none\n}\n\n.nav-link.disabled {\n    color: #858796;\n    pointer-events: none;\n    cursor: default\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #dddfeb\n}\n\n.nav-tabs .nav-link {\n    margin-bottom: -1px;\n    border: 1px solid transparent;\n    border-top-left-radius: .35rem;\n    border-top-right-radius: .35rem\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n    border-color: #eaecf4 #eaecf4 #dddfeb\n}\n\n.nav-tabs .nav-link.disabled {\n    color: #858796;\n    background-color: transparent;\n    border-color: transparent\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    color: #6e707e;\n    background-color: #fff;\n    border-color: #dddfeb #dddfeb #fff\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav-pills .nav-link {\n    border-radius: .35rem\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n    color: #fff;\n    background-color: #4e73df\n}\n\n.nav-fill .nav-item,\n.nav-fill>.nav-link {\n    flex: 1 1 auto;\n    text-align: center\n}\n\n.nav-justified .nav-item,\n.nav-justified>.nav-link {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center\n}\n\n.tab-content>.tab-pane {\n    display: none\n}\n\n.tab-content>.active {\n    display: block\n}\n\n.navbar {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: .5rem 1rem\n}\n\n.navbar .container,\n.navbar .container-fluid,\n.navbar .container-lg,\n.navbar .container-md,\n.navbar .container-sm,\n.navbar .container-xl {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between\n}\n\n.navbar-brand {\n    display: inline-block;\n    padding-top: .3125rem;\n    padding-bottom: .3125rem;\n    margin-right: 1rem;\n    font-size: 1.25rem;\n    line-height: inherit;\n    white-space: nowrap\n}\n\n.navbar-brand:focus,\n.navbar-brand:hover {\n    text-decoration: none\n}\n\n.navbar-nav {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.navbar-nav .dropdown-menu {\n    position: static;\n    float: none\n}\n\n.navbar-text {\n    display: inline-block;\n    padding-top: .5rem;\n    padding-bottom: .5rem\n}\n\n.navbar-collapse {\n    flex-basis: 100%;\n    flex-grow: 1;\n    align-items: center\n}\n\n.navbar-toggler {\n    padding: .25rem .75rem;\n    font-size: 1.25rem;\n    line-height: 1;\n    background-color: transparent;\n    border: 1px solid transparent;\n    border-radius: .35rem\n}\n\n.navbar-toggler:focus,\n.navbar-toggler:hover {\n    text-decoration: none\n}\n\n.navbar-toggler-icon {\n    display: inline-block;\n    width: 1.5em;\n    height: 1.5em;\n    vertical-align: middle;\n    content: \"\";\n    background: 50%/100% 100% no-repeat\n}\n\n.navbar-nav-scroll {\n    max-height: 75vh;\n    overflow-y: auto\n}\n\n@media (max-width:575.98px) {\n\n    .navbar-expand-sm>.container,\n    .navbar-expand-sm>.container-fluid,\n    .navbar-expand-sm>.container-lg,\n    .navbar-expand-sm>.container-md,\n    .navbar-expand-sm>.container-sm,\n    .navbar-expand-sm>.container-xl {\n        padding-right: 0;\n        padding-left: 0\n    }\n}\n\n@media (min-width:576px) {\n    .navbar-expand-sm {\n        flex-flow: row nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-sm .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem\n    }\n\n    .navbar-expand-sm>.container,\n    .navbar-expand-sm>.container-fluid,\n    .navbar-expand-sm>.container-lg,\n    .navbar-expand-sm>.container-md,\n    .navbar-expand-sm>.container-sm,\n    .navbar-expand-sm>.container-xl {\n        flex-wrap: nowrap\n    }\n\n    .navbar-expand-sm .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-sm .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-sm .navbar-toggler {\n        display: none\n    }\n}\n\n@media (max-width:767.98px) {\n\n    .navbar-expand-md>.container,\n    .navbar-expand-md>.container-fluid,\n    .navbar-expand-md>.container-lg,\n    .navbar-expand-md>.container-md,\n    .navbar-expand-md>.container-sm,\n    .navbar-expand-md>.container-xl {\n        padding-right: 0;\n        padding-left: 0\n    }\n}\n\n@media (min-width:768px) {\n    .navbar-expand-md {\n        flex-flow: row nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-md .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem\n    }\n\n    .navbar-expand-md>.container,\n    .navbar-expand-md>.container-fluid,\n    .navbar-expand-md>.container-lg,\n    .navbar-expand-md>.container-md,\n    .navbar-expand-md>.container-sm,\n    .navbar-expand-md>.container-xl {\n        flex-wrap: nowrap\n    }\n\n    .navbar-expand-md .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-md .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-md .navbar-toggler {\n        display: none\n    }\n}\n\n@media (max-width:991.98px) {\n\n    .navbar-expand-lg>.container,\n    .navbar-expand-lg>.container-fluid,\n    .navbar-expand-lg>.container-lg,\n    .navbar-expand-lg>.container-md,\n    .navbar-expand-lg>.container-sm,\n    .navbar-expand-lg>.container-xl {\n        padding-right: 0;\n        padding-left: 0\n    }\n}\n\n@media (min-width:992px) {\n    .navbar-expand-lg {\n        flex-flow: row nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-lg .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem\n    }\n\n    .navbar-expand-lg>.container,\n    .navbar-expand-lg>.container-fluid,\n    .navbar-expand-lg>.container-lg,\n    .navbar-expand-lg>.container-md,\n    .navbar-expand-lg>.container-sm,\n    .navbar-expand-lg>.container-xl {\n        flex-wrap: nowrap\n    }\n\n    .navbar-expand-lg .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-lg .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-lg .navbar-toggler {\n        display: none\n    }\n}\n\n@media (max-width:1199.98px) {\n\n    .navbar-expand-xl>.container,\n    .navbar-expand-xl>.container-fluid,\n    .navbar-expand-xl>.container-lg,\n    .navbar-expand-xl>.container-md,\n    .navbar-expand-xl>.container-sm,\n    .navbar-expand-xl>.container-xl {\n        padding-right: 0;\n        padding-left: 0\n    }\n}\n\n@media (min-width:1200px) {\n    .navbar-expand-xl {\n        flex-flow: row nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-xl .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem\n    }\n\n    .navbar-expand-xl>.container,\n    .navbar-expand-xl>.container-fluid,\n    .navbar-expand-xl>.container-lg,\n    .navbar-expand-xl>.container-md,\n    .navbar-expand-xl>.container-sm,\n    .navbar-expand-xl>.container-xl {\n        flex-wrap: nowrap\n    }\n\n    .navbar-expand-xl .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-xl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-xl .navbar-toggler {\n        display: none\n    }\n}\n\n.navbar-expand {\n    flex-flow: row nowrap;\n    justify-content: flex-start\n}\n\n.navbar-expand>.container,\n.navbar-expand>.container-fluid,\n.navbar-expand>.container-lg,\n.navbar-expand>.container-md,\n.navbar-expand>.container-sm,\n.navbar-expand>.container-xl {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.navbar-expand .navbar-nav {\n    flex-direction: row\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n    position: absolute\n}\n\n.navbar-expand .navbar-nav .nav-link {\n    padding-right: .5rem;\n    padding-left: .5rem\n}\n\n.navbar-expand>.container,\n.navbar-expand>.container-fluid,\n.navbar-expand>.container-lg,\n.navbar-expand>.container-md,\n.navbar-expand>.container-sm,\n.navbar-expand>.container-xl {\n    flex-wrap: nowrap\n}\n\n.navbar-expand .navbar-nav-scroll {\n    overflow: visible\n}\n\n.navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto\n}\n\n.navbar-expand .navbar-toggler {\n    display: none\n}\n\n.navbar-light .navbar-brand {\n    color: rgba(0, 0, 0, .9)\n}\n\n.navbar-light .navbar-brand:focus,\n.navbar-light .navbar-brand:hover {\n    color: rgba(0, 0, 0, .9)\n}\n\n.navbar-light .navbar-nav .nav-link {\n    color: rgba(0, 0, 0, .5)\n}\n\n.navbar-light .navbar-nav .nav-link:focus,\n.navbar-light .navbar-nav .nav-link:hover {\n    color: rgba(0, 0, 0, .7)\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, .3)\n}\n\n.navbar-light .navbar-nav .active>.nav-link,\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .show>.nav-link {\n    color: rgba(0, 0, 0, .9)\n}\n\n.navbar-light .navbar-toggler {\n    color: rgba(0, 0, 0, .5);\n    border-color: rgba(0, 0, 0, .1)\n}\n\n.navbar-light .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n.navbar-light .navbar-text {\n    color: rgba(0, 0, 0, .5)\n}\n\n.navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, .9)\n}\n\n.navbar-light .navbar-text a:focus,\n.navbar-light .navbar-text a:hover {\n    color: rgba(0, 0, 0, .9)\n}\n\n.navbar-dark .navbar-brand {\n    color: #fff\n}\n\n.navbar-dark .navbar-brand:focus,\n.navbar-dark .navbar-brand:hover {\n    color: #fff\n}\n\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, .5)\n}\n\n.navbar-dark .navbar-nav .nav-link:focus,\n.navbar-dark .navbar-nav .nav-link:hover {\n    color: rgba(255, 255, 255, .75)\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, .25)\n}\n\n.navbar-dark .navbar-nav .active>.nav-link,\n.navbar-dark .navbar-nav .nav-link.active,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .show>.nav-link {\n    color: #fff\n}\n\n.navbar-dark .navbar-toggler {\n    color: rgba(255, 255, 255, .5);\n    border-color: rgba(255, 255, 255, .1)\n}\n\n.navbar-dark .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n.navbar-dark .navbar-text {\n    color: rgba(255, 255, 255, .5)\n}\n\n.navbar-dark .navbar-text a {\n    color: #fff\n}\n\n.navbar-dark .navbar-text a:focus,\n.navbar-dark .navbar-text a:hover {\n    color: #fff\n}\n\n.card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid #e3e6f0;\n    border-radius: .35rem\n}\n\n.card>hr {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.card>.list-group {\n    border-top: inherit;\n    border-bottom: inherit\n}\n\n.card>.list-group:first-child {\n    border-top-width: 0;\n    border-top-left-radius: calc(.35rem - 1px);\n    border-top-right-radius: calc(.35rem - 1px)\n}\n\n.card>.list-group:last-child {\n    border-bottom-width: 0;\n    border-bottom-right-radius: calc(.35rem - 1px);\n    border-bottom-left-radius: calc(.35rem - 1px)\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n    border-top: 0\n}\n\n.card-body {\n    flex: 1 1 auto;\n    min-height: 1px;\n    padding: 1.25rem\n}\n\n.card-title {\n    margin-bottom: .75rem\n}\n\n.card-subtitle {\n    margin-top: -.375rem;\n    margin-bottom: 0\n}\n\n.card-text:last-child {\n    margin-bottom: 0\n}\n\n.card-link:hover {\n    text-decoration: none\n}\n\n.card-link+.card-link {\n    margin-left: 1.25rem\n}\n\n.card-header {\n    padding: .75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: #f8f9fc;\n    border-bottom: 1px solid #e3e6f0\n}\n\n.card-header:first-child {\n    border-radius: calc(.35rem - 1px) calc(.35rem - 1px) 0 0\n}\n\n.card-footer {\n    padding: .75rem 1.25rem;\n    background-color: #f8f9fc;\n    border-top: 1px solid #e3e6f0\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 calc(.35rem - 1px) calc(.35rem - 1px)\n}\n\n.card-header-tabs {\n    margin-right: -.625rem;\n    margin-bottom: -.75rem;\n    margin-left: -.625rem;\n    border-bottom: 0\n}\n\n.card-header-pills {\n    margin-right: -.625rem;\n    margin-left: -.625rem\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1.25rem;\n    border-radius: calc(.35rem - 1px)\n}\n\n.card-img,\n.card-img-bottom,\n.card-img-top {\n    flex-shrink: 0;\n    width: 100%\n}\n\n.card-img,\n.card-img-top {\n    border-top-left-radius: calc(.35rem - 1px);\n    border-top-right-radius: calc(.35rem - 1px)\n}\n\n.card-img,\n.card-img-bottom {\n    border-bottom-right-radius: calc(.35rem - 1px);\n    border-bottom-left-radius: calc(.35rem - 1px)\n}\n\n.card-deck .card {\n    margin-bottom: .75rem\n}\n\n@media (min-width:576px) {\n    .card-deck {\n        display: flex;\n        flex-flow: row wrap;\n        margin-right: -.75rem;\n        margin-left: -.75rem\n    }\n\n    .card-deck .card {\n        flex: 1 0 0%;\n        margin-right: .75rem;\n        margin-bottom: 0;\n        margin-left: .75rem\n    }\n}\n\n.card-group>.card {\n    margin-bottom: .75rem\n}\n\n@media (min-width:576px) {\n    .card-group {\n        display: flex;\n        flex-flow: row wrap\n    }\n\n    .card-group>.card {\n        flex: 1 0 0%;\n        margin-bottom: 0\n    }\n\n    .card-group>.card+.card {\n        margin-left: 0;\n        border-left: 0\n    }\n\n    .card-group>.card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-header,\n    .card-group>.card:not(:last-child) .card-img-top {\n        border-top-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-footer,\n    .card-group>.card:not(:last-child) .card-img-bottom {\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-header,\n    .card-group>.card:not(:first-child) .card-img-top {\n        border-top-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-footer,\n    .card-group>.card:not(:first-child) .card-img-bottom {\n        border-bottom-left-radius: 0\n    }\n}\n\n.card-columns .card {\n    margin-bottom: .75rem\n}\n\n@media (min-width:576px) {\n    .card-columns {\n        -moz-column-count: 3;\n        column-count: 3;\n        -moz-column-gap: 1.25rem;\n        column-gap: 1.25rem;\n        orphans: 1;\n        widows: 1\n    }\n\n    .card-columns .card {\n        display: inline-block;\n        width: 100%\n    }\n}\n\n.accordion {\n    overflow-anchor: none\n}\n\n.accordion>.card {\n    overflow: hidden\n}\n\n.accordion>.card:not(:last-of-type) {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.accordion>.card:not(:first-of-type) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.accordion>.card>.card-header {\n    border-radius: 0;\n    margin-bottom: -1px\n}\n\n.breadcrumb {\n    display: flex;\n    flex-wrap: wrap;\n    padding: .75rem 1rem;\n    margin-bottom: 1rem;\n    list-style: none;\n    background-color: #eaecf4;\n    border-radius: .35rem\n}\n\n.breadcrumb-item+.breadcrumb-item {\n    padding-left: .5rem\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    float: left;\n    padding-right: .5rem;\n    color: #858796;\n    content: \"/\"\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n    text-decoration: underline\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n    text-decoration: none\n}\n\n.breadcrumb-item.active {\n    color: #858796\n}\n\n.pagination {\n    display: flex;\n    padding-left: 0;\n    list-style: none;\n    border-radius: .35rem\n}\n\n.page-link {\n    position: relative;\n    display: block;\n    padding: .5rem .75rem;\n    margin-left: -1px;\n    line-height: 1.25;\n    color: #4e73df;\n    background-color: #fff;\n    border: 1px solid #dddfeb\n}\n\n.page-link:hover {\n    z-index: 2;\n    color: #224abe;\n    text-decoration: none;\n    background-color: #eaecf4;\n    border-color: #dddfeb\n}\n\n.page-link:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .25)\n}\n\n.page-item:first-child .page-link {\n    margin-left: 0;\n    border-top-left-radius: .35rem;\n    border-bottom-left-radius: .35rem\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: .35rem;\n    border-bottom-right-radius: .35rem\n}\n\n.page-item.active .page-link {\n    z-index: 3;\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.page-item.disabled .page-link {\n    color: #858796;\n    pointer-events: none;\n    cursor: auto;\n    background-color: #fff;\n    border-color: #dddfeb\n}\n\n.pagination-lg .page-link {\n    padding: .75rem 1.5rem;\n    font-size: 1.25rem;\n    line-height: 1.5\n}\n\n.pagination-lg .page-item:first-child .page-link {\n    border-top-left-radius: .3rem;\n    border-bottom-left-radius: .3rem\n}\n\n.pagination-lg .page-item:last-child .page-link {\n    border-top-right-radius: .3rem;\n    border-bottom-right-radius: .3rem\n}\n\n.pagination-sm .page-link {\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    line-height: 1.5\n}\n\n.pagination-sm .page-item:first-child .page-link {\n    border-top-left-radius: .2rem;\n    border-bottom-left-radius: .2rem\n}\n\n.pagination-sm .page-item:last-child .page-link {\n    border-top-right-radius: .2rem;\n    border-bottom-right-radius: .2rem\n}\n\n.badge {\n    display: inline-block;\n    padding: .25em .4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .35rem;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .badge {\n        transition: none\n    }\n}\n\na.badge:focus,\na.badge:hover {\n    text-decoration: none\n}\n\n.badge:empty {\n    display: none\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px\n}\n\n.badge-pill {\n    padding-right: .6em;\n    padding-left: .6em;\n    border-radius: 10rem\n}\n\n.badge-primary {\n    color: #fff;\n    background-color: #4e73df\n}\n\na.badge-primary:focus,\na.badge-primary:hover {\n    color: #fff;\n    background-color: #2653d4\n}\n\na.badge-primary.focus,\na.badge-primary:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(78, 115, 223, .5)\n}\n\n.badge-secondary {\n    color: #fff;\n    background-color: #858796\n}\n\na.badge-secondary:focus,\na.badge-secondary:hover {\n    color: #fff;\n    background-color: #6b6d7d\n}\n\na.badge-secondary.focus,\na.badge-secondary:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(133, 135, 150, .5)\n}\n\n.badge-success {\n    color: #fff;\n    background-color: #1cc88a\n}\n\na.badge-success:focus,\na.badge-success:hover {\n    color: #fff;\n    background-color: #169b6b\n}\n\na.badge-success.focus,\na.badge-success:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(28, 200, 138, .5)\n}\n\n.badge-info {\n    color: #fff;\n    background-color: #36b9cc\n}\n\na.badge-info:focus,\na.badge-info:hover {\n    color: #fff;\n    background-color: #2a96a5\n}\n\na.badge-info.focus,\na.badge-info:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(54, 185, 204, .5)\n}\n\n.badge-warning {\n    color: #fff;\n    background-color: #f6c23e\n}\n\na.badge-warning:focus,\na.badge-warning:hover {\n    color: #fff;\n    background-color: #f4b30d\n}\n\na.badge-warning.focus,\na.badge-warning:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(246, 194, 62, .5)\n}\n\n.badge-danger {\n    color: #fff;\n    background-color: #e74a3b\n}\n\na.badge-danger:focus,\na.badge-danger:hover {\n    color: #fff;\n    background-color: #d52a1a\n}\n\na.badge-danger.focus,\na.badge-danger:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(231, 74, 59, .5)\n}\n\n.badge-light {\n    color: #3a3b45;\n    background-color: #f8f9fc\n}\n\na.badge-light:focus,\na.badge-light:hover {\n    color: #3a3b45;\n    background-color: #d4daed\n}\n\na.badge-light.focus,\na.badge-light:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(248, 249, 252, .5)\n}\n\n.badge-dark {\n    color: #fff;\n    background-color: #5a5c69\n}\n\na.badge-dark:focus,\na.badge-dark:hover {\n    color: #fff;\n    background-color: #42444e\n}\n\na.badge-dark.focus,\na.badge-dark:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .2rem rgba(90, 92, 105, .5)\n}\n\n.jumbotron {\n    padding: 2rem 1rem;\n    margin-bottom: 2rem;\n    background-color: #eaecf4;\n    border-radius: .3rem\n}\n\n@media (min-width:576px) {\n    .jumbotron {\n        padding: 4rem 2rem\n    }\n}\n\n.jumbotron-fluid {\n    padding-right: 0;\n    padding-left: 0;\n    border-radius: 0\n}\n\n.alert {\n    position: relative;\n    padding: .75rem 1.25rem;\n    margin-bottom: 1rem;\n    border: 1px solid transparent;\n    border-radius: .35rem\n}\n\n.alert-heading {\n    color: inherit\n}\n\n.alert-link {\n    font-weight: 700\n}\n\n.alert-dismissible {\n    padding-right: 4rem\n}\n\n.alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: .75rem 1.25rem;\n    color: inherit\n}\n\n.alert-primary {\n    color: #293c74;\n    background-color: #dce3f9;\n    border-color: #cdd8f6\n}\n\n.alert-primary hr {\n    border-top-color: #b7c7f2\n}\n\n.alert-primary .alert-link {\n    color: #1c294e\n}\n\n.alert-secondary {\n    color: #45464e;\n    background-color: #e7e7ea;\n    border-color: #dddde2\n}\n\n.alert-secondary hr {\n    border-top-color: #cfcfd6\n}\n\n.alert-secondary .alert-link {\n    color: #2d2e33\n}\n\n.alert-success {\n    color: #0f6848;\n    background-color: #d2f4e8;\n    border-color: #bff0de\n}\n\n.alert-success hr {\n    border-top-color: #aaebd3\n}\n\n.alert-success .alert-link {\n    color: #093b29\n}\n\n.alert-info {\n    color: #1c606a;\n    background-color: #d7f1f5;\n    border-color: #c7ebf1\n}\n\n.alert-info hr {\n    border-top-color: #b3e4ec\n}\n\n.alert-info .alert-link {\n    color: #113b42\n}\n\n.alert-warning {\n    color: #806520;\n    background-color: #fdf3d8;\n    border-color: #fceec9\n}\n\n.alert-warning hr {\n    border-top-color: #fbe6b1\n}\n\n.alert-warning .alert-link {\n    color: #574516\n}\n\n.alert-danger {\n    color: #78261f;\n    background-color: #fadbd8;\n    border-color: #f8ccc8\n}\n\n.alert-danger hr {\n    border-top-color: #f5b7b1\n}\n\n.alert-danger .alert-link {\n    color: #4f1915\n}\n\n.alert-light {\n    color: #818183;\n    background-color: #fefefe;\n    border-color: #fdfdfe\n}\n\n.alert-light hr {\n    border-top-color: #ececf6\n}\n\n.alert-light .alert-link {\n    color: #686869\n}\n\n.alert-dark {\n    color: #2f3037;\n    background-color: #dedee1;\n    border-color: #d1d1d5\n}\n\n.alert-dark hr {\n    border-top-color: #c4c4c9\n}\n\n.alert-dark .alert-link {\n    color: #18181c\n}\n\n@-webkit-keyframes progress-bar-stripes {\n    from {\n        background-position: 1rem 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n}\n\n@keyframes progress-bar-stripes {\n    from {\n        background-position: 1rem 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n}\n\n.progress {\n    display: flex;\n    height: 1rem;\n    overflow: hidden;\n    line-height: 0;\n    font-size: .75rem;\n    background-color: #eaecf4;\n    border-radius: .35rem\n}\n\n.progress-bar {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #4e73df;\n    transition: width .6s ease\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .progress-bar {\n        transition: none\n    }\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n    background-size: 1rem 1rem\n}\n\n.progress-bar-animated {\n    -webkit-animation: 1s linear infinite progress-bar-stripes;\n    animation: 1s linear infinite progress-bar-stripes\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .progress-bar-animated {\n        -webkit-animation: none;\n        animation: none\n    }\n}\n\n.media {\n    display: flex;\n    align-items: flex-start\n}\n\n.media-body {\n    flex: 1\n}\n\n.list-group {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    border-radius: .35rem\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: #6e707e;\n    text-align: inherit\n}\n\n.list-group-item-action:focus,\n.list-group-item-action:hover {\n    z-index: 1;\n    color: #6e707e;\n    text-decoration: none;\n    background-color: #f8f9fc\n}\n\n.list-group-item-action:active {\n    color: #858796;\n    background-color: #eaecf4\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: .75rem 1.25rem;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, .125)\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit\n}\n\n.list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n    color: #858796;\n    pointer-events: none;\n    background-color: #fff\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #4e73df;\n    border-color: #4e73df\n}\n\n.list-group-item+.list-group-item {\n    border-top-width: 0\n}\n\n.list-group-item+.list-group-item.active {\n    margin-top: -1px;\n    border-top-width: 1px\n}\n\n.list-group-horizontal {\n    flex-direction: row\n}\n\n.list-group-horizontal>.list-group-item:first-child {\n    border-bottom-left-radius: .35rem;\n    border-top-right-radius: 0\n}\n\n.list-group-horizontal>.list-group-item:last-child {\n    border-top-right-radius: .35rem;\n    border-bottom-left-radius: 0\n}\n\n.list-group-horizontal>.list-group-item.active {\n    margin-top: 0\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px\n}\n\n@media (min-width:576px) {\n    .list-group-horizontal-sm {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-sm>.list-group-item:first-child {\n        border-bottom-left-radius: .35rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item:last-child {\n        border-top-right-radius: .35rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width:768px) {\n    .list-group-horizontal-md {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-md>.list-group-item:first-child {\n        border-bottom-left-radius: .35rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item:last-child {\n        border-top-right-radius: .35rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width:992px) {\n    .list-group-horizontal-lg {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-lg>.list-group-item:first-child {\n        border-bottom-left-radius: .35rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item:last-child {\n        border-top-right-radius: .35rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width:1200px) {\n    .list-group-horizontal-xl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xl>.list-group-item:first-child {\n        border-bottom-left-radius: .35rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item:last-child {\n        border-top-right-radius: .35rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n.list-group-flush {\n    border-radius: 0\n}\n\n.list-group-flush>.list-group-item {\n    border-width: 0 0 1px\n}\n\n.list-group-flush>.list-group-item:last-child {\n    border-bottom-width: 0\n}\n\n.list-group-item-primary {\n    color: #293c74;\n    background-color: #cdd8f6\n}\n\n.list-group-item-primary.list-group-item-action:focus,\n.list-group-item-primary.list-group-item-action:hover {\n    color: #293c74;\n    background-color: #b7c7f2\n}\n\n.list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #293c74;\n    border-color: #293c74\n}\n\n.list-group-item-secondary {\n    color: #45464e;\n    background-color: #dddde2\n}\n\n.list-group-item-secondary.list-group-item-action:focus,\n.list-group-item-secondary.list-group-item-action:hover {\n    color: #45464e;\n    background-color: #cfcfd6\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #45464e;\n    border-color: #45464e\n}\n\n.list-group-item-success {\n    color: #0f6848;\n    background-color: #bff0de\n}\n\n.list-group-item-success.list-group-item-action:focus,\n.list-group-item-success.list-group-item-action:hover {\n    color: #0f6848;\n    background-color: #aaebd3\n}\n\n.list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #0f6848;\n    border-color: #0f6848\n}\n\n.list-group-item-info {\n    color: #1c606a;\n    background-color: #c7ebf1\n}\n\n.list-group-item-info.list-group-item-action:focus,\n.list-group-item-info.list-group-item-action:hover {\n    color: #1c606a;\n    background-color: #b3e4ec\n}\n\n.list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #1c606a;\n    border-color: #1c606a\n}\n\n.list-group-item-warning {\n    color: #806520;\n    background-color: #fceec9\n}\n\n.list-group-item-warning.list-group-item-action:focus,\n.list-group-item-warning.list-group-item-action:hover {\n    color: #806520;\n    background-color: #fbe6b1\n}\n\n.list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #806520;\n    border-color: #806520\n}\n\n.list-group-item-danger {\n    color: #78261f;\n    background-color: #f8ccc8\n}\n\n.list-group-item-danger.list-group-item-action:focus,\n.list-group-item-danger.list-group-item-action:hover {\n    color: #78261f;\n    background-color: #f5b7b1\n}\n\n.list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #78261f;\n    border-color: #78261f\n}\n\n.list-group-item-light {\n    color: #818183;\n    background-color: #fdfdfe\n}\n\n.list-group-item-light.list-group-item-action:focus,\n.list-group-item-light.list-group-item-action:hover {\n    color: #818183;\n    background-color: #ececf6\n}\n\n.list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #818183;\n    border-color: #818183\n}\n\n.list-group-item-dark {\n    color: #2f3037;\n    background-color: #d1d1d5\n}\n\n.list-group-item-dark.list-group-item-action:focus,\n.list-group-item-dark.list-group-item-action:hover {\n    color: #2f3037;\n    background-color: #c4c4c9\n}\n\n.list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #2f3037;\n    border-color: #2f3037\n}\n\n.close {\n    float: right;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: .5\n}\n\n.close:hover {\n    color: #000;\n    text-decoration: none\n}\n\n.close:not(:disabled):not(.disabled):focus,\n.close:not(:disabled):not(.disabled):hover {\n    opacity: .75\n}\n\nbutton.close {\n    padding: 0;\n    background-color: transparent;\n    border: 0\n}\n\na.close.disabled {\n    pointer-events: none\n}\n\n.toast {\n    flex-basis: 350px;\n    max-width: 350px;\n    font-size: .875rem;\n    background-color: rgba(255, 255, 255, .85);\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, .1);\n    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .1);\n    opacity: 0;\n    border-radius: .25rem\n}\n\n.toast:not(:last-child) {\n    margin-bottom: .75rem\n}\n\n.toast.showing {\n    opacity: 1\n}\n\n.toast.show {\n    display: block;\n    opacity: 1\n}\n\n.toast.hide {\n    display: none\n}\n\n.toast-header {\n    display: flex;\n    align-items: center;\n    padding: .25rem .75rem;\n    color: #858796;\n    background-color: rgba(255, 255, 255, .85);\n    background-clip: padding-box;\n    border-bottom: 1px solid rgba(0, 0, 0, .05);\n    border-top-left-radius: calc(.25rem - 1px);\n    border-top-right-radius: calc(.25rem - 1px)\n}\n\n.toast-body {\n    padding: .75rem\n}\n\n.modal-open {\n    overflow: hidden\n}\n\n.modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    outline: 0\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: .5rem;\n    pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(0, -50px)\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .modal.fade .modal-dialog {\n        transition: none\n    }\n}\n\n.modal.show .modal-dialog {\n    transform: none\n}\n\n.modal.modal-static .modal-dialog {\n    transform: scale(1.02)\n}\n\n.modal-dialog-scrollable {\n    display: flex;\n    max-height: calc(100% - 1rem)\n}\n\n.modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 1rem);\n    overflow: hidden\n}\n\n.modal-dialog-scrollable .modal-footer,\n.modal-dialog-scrollable .modal-header {\n    flex-shrink: 0\n}\n\n.modal-dialog-scrollable .modal-body {\n    overflow-y: auto\n}\n\n.modal-dialog-centered {\n    display: flex;\n    align-items: center;\n    min-height: calc(100% - 1rem)\n}\n\n.modal-dialog-centered::before {\n    display: block;\n    height: calc(100vh - 1rem);\n    height: -webkit-min-content;\n    height: -moz-min-content;\n    height: min-content;\n    content: \"\"\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n    max-height: none\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n    content: none\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, .2);\n    border-radius: .3rem;\n    outline: 0\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000\n}\n\n.modal-backdrop.fade {\n    opacity: 0\n}\n\n.modal-backdrop.show {\n    opacity: .5\n}\n\n.modal-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 1rem 1rem;\n    border-bottom: 1px solid #e3e6f0;\n    border-top-left-radius: calc(.3rem - 1px);\n    border-top-right-radius: calc(.3rem - 1px)\n}\n\n.modal-header .close {\n    padding: 1rem 1rem;\n    margin: -1rem -1rem -1rem auto\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: 1.5\n}\n\n.modal-body {\n    position: relative;\n    flex: 1 1 auto;\n    padding: 1rem\n}\n\n.modal-footer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    padding: .75rem;\n    border-top: 1px solid #e3e6f0;\n    border-bottom-right-radius: calc(.3rem - 1px);\n    border-bottom-left-radius: calc(.3rem - 1px)\n}\n\n.modal-footer>* {\n    margin: .25rem\n}\n\n.modal-scrollbar-measure {\n    position: absolute;\n    top: -9999px;\n    width: 50px;\n    height: 50px;\n    overflow: scroll\n}\n\n@media (min-width:576px) {\n    .modal-dialog {\n        max-width: 500px;\n        margin: 1.75rem auto\n    }\n\n    .modal-dialog-scrollable {\n        max-height: calc(100% - 3.5rem)\n    }\n\n    .modal-dialog-scrollable .modal-content {\n        max-height: calc(100vh - 3.5rem)\n    }\n\n    .modal-dialog-centered {\n        min-height: calc(100% - 3.5rem)\n    }\n\n    .modal-dialog-centered::before {\n        height: calc(100vh - 3.5rem);\n        height: -webkit-min-content;\n        height: -moz-min-content;\n        height: min-content\n    }\n\n    .modal-sm {\n        max-width: 300px\n    }\n}\n\n@media (min-width:992px) {\n\n    .modal-lg,\n    .modal-xl {\n        max-width: 800px\n    }\n}\n\n@media (min-width:1200px) {\n    .modal-xl {\n        max-width: 1140px\n    }\n}\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    margin: 0;\n    font-family: Nunito, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: .875rem;\n    word-wrap: break-word;\n    opacity: 0\n}\n\n.tooltip.show {\n    opacity: .9\n}\n\n.tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: .8rem;\n    height: .4rem\n}\n\n.tooltip .arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid\n}\n\n.bs-tooltip-auto[x-placement^=top],\n.bs-tooltip-top {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow,\n.bs-tooltip-top .arrow {\n    bottom: 0\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow::before,\n.bs-tooltip-top .arrow::before {\n    top: 0;\n    border-width: .4rem .4rem 0;\n    border-top-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=right],\n.bs-tooltip-right {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow,\n.bs-tooltip-right .arrow {\n    left: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow::before,\n.bs-tooltip-right .arrow::before {\n    right: 0;\n    border-width: .4rem .4rem .4rem 0;\n    border-right-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=bottom],\n.bs-tooltip-bottom {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow,\n.bs-tooltip-bottom .arrow {\n    top: 0\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before,\n.bs-tooltip-bottom .arrow::before {\n    bottom: 0;\n    border-width: 0 .4rem .4rem;\n    border-bottom-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=left],\n.bs-tooltip-left {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow,\n.bs-tooltip-left .arrow {\n    right: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow::before,\n.bs-tooltip-left .arrow::before {\n    left: 0;\n    border-width: .4rem 0 .4rem .4rem;\n    border-left-color: #000\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: .25rem .5rem;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: .35rem\n}\n\n.popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: block;\n    max-width: 276px;\n    font-family: Nunito, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: .875rem;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, .2);\n    border-radius: .3rem\n}\n\n.popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: .5rem;\n    margin: 0 .3rem\n}\n\n.popover .arrow::after,\n.popover .arrow::before {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid\n}\n\n.bs-popover-auto[x-placement^=top],\n.bs-popover-top {\n    margin-bottom: .5rem\n}\n\n.bs-popover-auto[x-placement^=top]>.arrow,\n.bs-popover-top>.arrow {\n    bottom: calc(-.5rem - 1px)\n}\n\n.bs-popover-auto[x-placement^=top]>.arrow::before,\n.bs-popover-top>.arrow::before {\n    bottom: 0;\n    border-width: .5rem .5rem 0;\n    border-top-color: rgba(0, 0, 0, .25)\n}\n\n.bs-popover-auto[x-placement^=top]>.arrow::after,\n.bs-popover-top>.arrow::after {\n    bottom: 1px;\n    border-width: .5rem .5rem 0;\n    border-top-color: #fff\n}\n\n.bs-popover-auto[x-placement^=right],\n.bs-popover-right {\n    margin-left: .5rem\n}\n\n.bs-popover-auto[x-placement^=right]>.arrow,\n.bs-popover-right>.arrow {\n    left: calc(-.5rem - 1px);\n    width: .5rem;\n    height: 1rem;\n    margin: .3rem 0\n}\n\n.bs-popover-auto[x-placement^=right]>.arrow::before,\n.bs-popover-right>.arrow::before {\n    left: 0;\n    border-width: .5rem .5rem .5rem 0;\n    border-right-color: rgba(0, 0, 0, .25)\n}\n\n.bs-popover-auto[x-placement^=right]>.arrow::after,\n.bs-popover-right>.arrow::after {\n    left: 1px;\n    border-width: .5rem .5rem .5rem 0;\n    border-right-color: #fff\n}\n\n.bs-popover-auto[x-placement^=bottom],\n.bs-popover-bottom {\n    margin-top: .5rem\n}\n\n.bs-popover-auto[x-placement^=bottom]>.arrow,\n.bs-popover-bottom>.arrow {\n    top: calc(-.5rem - 1px)\n}\n\n.bs-popover-auto[x-placement^=bottom]>.arrow::before,\n.bs-popover-bottom>.arrow::before {\n    top: 0;\n    border-width: 0 .5rem .5rem .5rem;\n    border-bottom-color: rgba(0, 0, 0, .25)\n}\n\n.bs-popover-auto[x-placement^=bottom]>.arrow::after,\n.bs-popover-bottom>.arrow::after {\n    top: 1px;\n    border-width: 0 .5rem .5rem .5rem;\n    border-bottom-color: #fff\n}\n\n.bs-popover-auto[x-placement^=bottom] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7\n}\n\n.bs-popover-auto[x-placement^=left],\n.bs-popover-left {\n    margin-right: .5rem\n}\n\n.bs-popover-auto[x-placement^=left]>.arrow,\n.bs-popover-left>.arrow {\n    right: calc(-.5rem - 1px);\n    width: .5rem;\n    height: 1rem;\n    margin: .3rem 0\n}\n\n.bs-popover-auto[x-placement^=left]>.arrow::before,\n.bs-popover-left>.arrow::before {\n    right: 0;\n    border-width: .5rem 0 .5rem .5rem;\n    border-left-color: rgba(0, 0, 0, .25)\n}\n\n.bs-popover-auto[x-placement^=left]>.arrow::after,\n.bs-popover-left>.arrow::after {\n    right: 1px;\n    border-width: .5rem 0 .5rem .5rem;\n    border-left-color: #fff\n}\n\n.popover-header {\n    padding: .5rem .75rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ebebeb;\n    border-top-left-radius: calc(.3rem - 1px);\n    border-top-right-radius: calc(.3rem - 1px)\n}\n\n.popover-header:empty {\n    display: none\n}\n\n.popover-body {\n    padding: .5rem .75rem;\n    color: #858796\n}\n\n.carousel {\n    position: relative\n}\n\n.carousel.pointer-event {\n    touch-action: pan-y\n}\n\n.carousel-inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden\n}\n\n.carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.carousel-item {\n    position: relative;\n    display: none;\n    float: left;\n    width: 100%;\n    margin-right: -100%;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    transition: transform .6s ease-in-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .carousel-item {\n        transition: none\n    }\n}\n\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n    display: block\n}\n\n.active.carousel-item-right,\n.carousel-item-next:not(.carousel-item-left) {\n    transform: translateX(100%)\n}\n\n.active.carousel-item-left,\n.carousel-item-prev:not(.carousel-item-right) {\n    transform: translateX(-100%)\n}\n\n.carousel-fade .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none\n}\n\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right,\n.carousel-fade .carousel-item.active {\n    z-index: 1;\n    opacity: 1\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    transition: opacity 0s .6s\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .carousel-fade .active.carousel-item-left,\n    .carousel-fade .active.carousel-item-right {\n        transition: none\n    }\n}\n\n.carousel-control-next,\n.carousel-control-prev {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 15%;\n    color: #fff;\n    text-align: center;\n    opacity: .5;\n    transition: opacity .15s ease\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .carousel-control-next,\n    .carousel-control-prev {\n        transition: none\n    }\n}\n\n.carousel-control-next:focus,\n.carousel-control-next:hover,\n.carousel-control-prev:focus,\n.carousel-control-prev:hover {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9\n}\n\n.carousel-control-prev {\n    left: 0\n}\n\n.carousel-control-next {\n    right: 0\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background: 50%/100% 100% no-repeat\n}\n\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")\n}\n\n.carousel-indicators {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 15;\n    display: flex;\n    justify-content: center;\n    padding-left: 0;\n    margin-right: 15%;\n    margin-left: 15%;\n    list-style: none\n}\n\n.carousel-indicators li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    opacity: .5;\n    transition: opacity .6s ease\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .carousel-indicators li {\n        transition: none\n    }\n}\n\n.carousel-indicators .active {\n    opacity: 1\n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    bottom: 20px;\n    left: 15%;\n    z-index: 10;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    color: #fff;\n    text-align: center\n}\n\n@-webkit-keyframes spinner-border {\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes spinner-border {\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n.spinner-border {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    vertical-align: text-bottom;\n    border: .25em solid currentColor;\n    border-right-color: transparent;\n    border-radius: 50%;\n    -webkit-animation: .75s linear infinite spinner-border;\n    animation: .75s linear infinite spinner-border\n}\n\n.spinner-border-sm {\n    width: 1rem;\n    height: 1rem;\n    border-width: .2em\n}\n\n@-webkit-keyframes spinner-grow {\n    0% {\n        transform: scale(0)\n    }\n\n    50% {\n        opacity: 1;\n        transform: none\n    }\n}\n\n@keyframes spinner-grow {\n    0% {\n        transform: scale(0)\n    }\n\n    50% {\n        opacity: 1;\n        transform: none\n    }\n}\n\n.spinner-grow {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    vertical-align: text-bottom;\n    background-color: currentColor;\n    border-radius: 50%;\n    opacity: 0;\n    -webkit-animation: .75s linear infinite spinner-grow;\n    animation: .75s linear infinite spinner-grow\n}\n\n.spinner-grow-sm {\n    width: 1rem;\n    height: 1rem\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .spinner-border,\n    .spinner-grow {\n        -webkit-animation-duration: 1.5s;\n        animation-duration: 1.5s\n    }\n}\n\n.align-baseline {\n    vertical-align: baseline !important\n}\n\n.align-top {\n    vertical-align: top !important\n}\n\n.align-middle {\n    vertical-align: middle !important\n}\n\n.align-bottom {\n    vertical-align: bottom !important\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important\n}\n\n.align-text-top {\n    vertical-align: text-top !important\n}\n\n.bg-primary {\n    background-color: #4e73df !important\n}\n\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n    background-color: #2653d4 !important\n}\n\n.bg-secondary {\n    background-color: #858796 !important\n}\n\na.bg-secondary:focus,\na.bg-secondary:hover,\nbutton.bg-secondary:focus,\nbutton.bg-secondary:hover {\n    background-color: #6b6d7d !important\n}\n\n.bg-success {\n    background-color: #1cc88a !important\n}\n\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n    background-color: #169b6b !important\n}\n\n.bg-info {\n    background-color: #36b9cc !important\n}\n\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n    background-color: #2a96a5 !important\n}\n\n.bg-warning {\n    background-color: #f6c23e !important\n}\n\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n    background-color: #f4b30d !important\n}\n\n.bg-danger {\n    background-color: #e74a3b !important\n}\n\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n    background-color: #d52a1a !important\n}\n\n.bg-light {\n    background-color: #f8f9fc !important\n}\n\na.bg-light:focus,\na.bg-light:hover,\nbutton.bg-light:focus,\nbutton.bg-light:hover {\n    background-color: #d4daed !important\n}\n\n.bg-dark {\n    background-color: #5a5c69 !important\n}\n\na.bg-dark:focus,\na.bg-dark:hover,\nbutton.bg-dark:focus,\nbutton.bg-dark:hover {\n    background-color: #42444e !important\n}\n\n.bg-white {\n    background-color: #fff !important\n}\n\n.bg-transparent {\n    background-color: transparent !important\n}\n\n.border {\n    border: 1px solid #e3e6f0 !important\n}\n\n.border-top {\n    border-top: 1px solid #e3e6f0 !important\n}\n\n.border-right {\n    border-right: 1px solid #e3e6f0 !important\n}\n\n.border-bottom {\n    border-bottom: 1px solid #e3e6f0 !important\n}\n\n.border-left {\n    border-left: 1px solid #e3e6f0 !important\n}\n\n.border-0 {\n    border: 0 !important\n}\n\n.border-top-0 {\n    border-top: 0 !important\n}\n\n.border-right-0 {\n    border-right: 0 !important\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important\n}\n\n.border-left-0 {\n    border-left: 0 !important\n}\n\n.border-primary {\n    border-color: #4e73df !important\n}\n\n.border-secondary {\n    border-color: #858796 !important\n}\n\n.border-success {\n    border-color: #1cc88a !important\n}\n\n.border-info {\n    border-color: #36b9cc !important\n}\n\n.border-warning {\n    border-color: #f6c23e !important\n}\n\n.border-danger {\n    border-color: #e74a3b !important\n}\n\n.border-light {\n    border-color: #f8f9fc !important\n}\n\n.border-dark {\n    border-color: #5a5c69 !important\n}\n\n.border-white {\n    border-color: #fff !important\n}\n\n.rounded-sm {\n    border-radius: .2rem !important\n}\n\n.rounded {\n    border-radius: .35rem !important\n}\n\n.rounded-top {\n    border-top-left-radius: .35rem !important;\n    border-top-right-radius: .35rem !important\n}\n\n.rounded-right {\n    border-top-right-radius: .35rem !important;\n    border-bottom-right-radius: .35rem !important\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: .35rem !important;\n    border-bottom-left-radius: .35rem !important\n}\n\n.rounded-left {\n    border-top-left-radius: .35rem !important;\n    border-bottom-left-radius: .35rem !important\n}\n\n.rounded-lg {\n    border-radius: .3rem !important\n}\n\n.rounded-circle {\n    border-radius: 50% !important\n}\n\n.rounded-pill {\n    border-radius: 50rem !important\n}\n\n.rounded-0 {\n    border-radius: 0 !important\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.d-none {\n    display: none !important\n}\n\n.d-inline {\n    display: inline !important\n}\n\n.d-inline-block {\n    display: inline-block !important\n}\n\n.d-block {\n    display: block !important\n}\n\n.d-table {\n    display: table !important\n}\n\n.d-table-row {\n    display: table-row !important\n}\n\n.d-table-cell {\n    display: table-cell !important\n}\n\n.d-flex {\n    display: flex !important\n}\n\n.d-inline-flex {\n    display: inline-flex !important\n}\n\n@media (min-width:576px) {\n    .d-sm-none {\n        display: none !important\n    }\n\n    .d-sm-inline {\n        display: inline !important\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important\n    }\n\n    .d-sm-block {\n        display: block !important\n    }\n\n    .d-sm-table {\n        display: table !important\n    }\n\n    .d-sm-table-row {\n        display: table-row !important\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important\n    }\n\n    .d-sm-flex {\n        display: flex !important\n    }\n\n    .d-sm-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width:768px) {\n    .d-md-none {\n        display: none !important\n    }\n\n    .d-md-inline {\n        display: inline !important\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important\n    }\n\n    .d-md-block {\n        display: block !important\n    }\n\n    .d-md-table {\n        display: table !important\n    }\n\n    .d-md-table-row {\n        display: table-row !important\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important\n    }\n\n    .d-md-flex {\n        display: flex !important\n    }\n\n    .d-md-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width:992px) {\n    .d-lg-none {\n        display: none !important\n    }\n\n    .d-lg-inline {\n        display: inline !important\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important\n    }\n\n    .d-lg-block {\n        display: block !important\n    }\n\n    .d-lg-table {\n        display: table !important\n    }\n\n    .d-lg-table-row {\n        display: table-row !important\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important\n    }\n\n    .d-lg-flex {\n        display: flex !important\n    }\n\n    .d-lg-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width:1200px) {\n    .d-xl-none {\n        display: none !important\n    }\n\n    .d-xl-inline {\n        display: inline !important\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xl-block {\n        display: block !important\n    }\n\n    .d-xl-table {\n        display: table !important\n    }\n\n    .d-xl-table-row {\n        display: table-row !important\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xl-flex {\n        display: flex !important\n    }\n\n    .d-xl-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media print {\n    .d-print-none {\n        display: none !important\n    }\n\n    .d-print-inline {\n        display: inline !important\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important\n    }\n\n    .d-print-block {\n        display: block !important\n    }\n\n    .d-print-table {\n        display: table !important\n    }\n\n    .d-print-table-row {\n        display: table-row !important\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important\n    }\n\n    .d-print-flex {\n        display: flex !important\n    }\n\n    .d-print-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n.embed-responsive {\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    overflow: hidden\n}\n\n.embed-responsive::before {\n    display: block;\n    content: \"\"\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive embed,\n.embed-responsive iframe,\n.embed-responsive object,\n.embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0\n}\n\n.embed-responsive-21by9::before {\n    padding-top: 42.85714%\n}\n\n.embed-responsive-16by9::before {\n    padding-top: 56.25%\n}\n\n.embed-responsive-4by3::before {\n    padding-top: 75%\n}\n\n.embed-responsive-1by1::before {\n    padding-top: 100%\n}\n\n.flex-row {\n    flex-direction: row !important\n}\n\n.flex-column {\n    flex-direction: column !important\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse !important\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse !important\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important\n}\n\n.flex-nowrap {\n    flex-wrap: nowrap !important\n}\n\n.flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important\n}\n\n.flex-fill {\n    flex: 1 1 auto !important\n}\n\n.flex-grow-0 {\n    flex-grow: 0 !important\n}\n\n.flex-grow-1 {\n    flex-grow: 1 !important\n}\n\n.flex-shrink-0 {\n    flex-shrink: 0 !important\n}\n\n.flex-shrink-1 {\n    flex-shrink: 1 !important\n}\n\n.justify-content-start {\n    justify-content: flex-start !important\n}\n\n.justify-content-end {\n    justify-content: flex-end !important\n}\n\n.justify-content-center {\n    justify-content: center !important\n}\n\n.justify-content-between {\n    justify-content: space-between !important\n}\n\n.justify-content-around {\n    justify-content: space-around !important\n}\n\n.align-items-start {\n    align-items: flex-start !important\n}\n\n.align-items-end {\n    align-items: flex-end !important\n}\n\n.align-items-center {\n    align-items: center !important\n}\n\n.align-items-baseline {\n    align-items: baseline !important\n}\n\n.align-items-stretch {\n    align-items: stretch !important\n}\n\n.align-content-start {\n    align-content: flex-start !important\n}\n\n.align-content-end {\n    align-content: flex-end !important\n}\n\n.align-content-center {\n    align-content: center !important\n}\n\n.align-content-between {\n    align-content: space-between !important\n}\n\n.align-content-around {\n    align-content: space-around !important\n}\n\n.align-content-stretch {\n    align-content: stretch !important\n}\n\n.align-self-auto {\n    align-self: auto !important\n}\n\n.align-self-start {\n    align-self: flex-start !important\n}\n\n.align-self-end {\n    align-self: flex-end !important\n}\n\n.align-self-center {\n    align-self: center !important\n}\n\n.align-self-baseline {\n    align-self: baseline !important\n}\n\n.align-self-stretch {\n    align-self: stretch !important\n}\n\n@media (min-width:576px) {\n    .flex-sm-row {\n        flex-direction: row !important\n    }\n\n    .flex-sm-column {\n        flex-direction: column !important\n    }\n\n    .flex-sm-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-sm-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-sm-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-sm-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-sm-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-sm-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-sm-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-sm-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-sm-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-sm-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-sm-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-sm-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-sm-center {\n        justify-content: center !important\n    }\n\n    .justify-content-sm-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-sm-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-sm-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-sm-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-sm-center {\n        align-items: center !important\n    }\n\n    .align-items-sm-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-sm-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-sm-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-sm-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-sm-center {\n        align-content: center !important\n    }\n\n    .align-content-sm-between {\n        align-content: space-between !important\n    }\n\n    .align-content-sm-around {\n        align-content: space-around !important\n    }\n\n    .align-content-sm-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-sm-auto {\n        align-self: auto !important\n    }\n\n    .align-self-sm-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-sm-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-sm-center {\n        align-self: center !important\n    }\n\n    .align-self-sm-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-sm-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width:768px) {\n    .flex-md-row {\n        flex-direction: row !important\n    }\n\n    .flex-md-column {\n        flex-direction: column !important\n    }\n\n    .flex-md-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-md-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-md-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-md-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-md-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-md-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-md-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-md-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-md-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-md-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-md-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-md-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-md-center {\n        justify-content: center !important\n    }\n\n    .justify-content-md-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-md-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-md-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-md-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-md-center {\n        align-items: center !important\n    }\n\n    .align-items-md-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-md-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-md-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-md-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-md-center {\n        align-content: center !important\n    }\n\n    .align-content-md-between {\n        align-content: space-between !important\n    }\n\n    .align-content-md-around {\n        align-content: space-around !important\n    }\n\n    .align-content-md-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-md-auto {\n        align-self: auto !important\n    }\n\n    .align-self-md-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-md-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-md-center {\n        align-self: center !important\n    }\n\n    .align-self-md-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-md-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width:992px) {\n    .flex-lg-row {\n        flex-direction: row !important\n    }\n\n    .flex-lg-column {\n        flex-direction: column !important\n    }\n\n    .flex-lg-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-lg-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-lg-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-lg-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-lg-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-lg-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-lg-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-lg-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-lg-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-lg-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-lg-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-lg-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-lg-center {\n        justify-content: center !important\n    }\n\n    .justify-content-lg-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-lg-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-lg-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-lg-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-lg-center {\n        align-items: center !important\n    }\n\n    .align-items-lg-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-lg-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-lg-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-lg-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-lg-center {\n        align-content: center !important\n    }\n\n    .align-content-lg-between {\n        align-content: space-between !important\n    }\n\n    .align-content-lg-around {\n        align-content: space-around !important\n    }\n\n    .align-content-lg-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-lg-auto {\n        align-self: auto !important\n    }\n\n    .align-self-lg-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-lg-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-lg-center {\n        align-self: center !important\n    }\n\n    .align-self-lg-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-lg-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width:1200px) {\n    .flex-xl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-xl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-xl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xl-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-xl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xl-center {\n        align-items: center !important\n    }\n\n    .align-items-xl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xl-center {\n        align-content: center !important\n    }\n\n    .align-content-xl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xl-center {\n        align-self: center !important\n    }\n\n    .align-self-xl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xl-stretch {\n        align-self: stretch !important\n    }\n}\n\n.float-left {\n    float: left !important\n}\n\n.float-right {\n    float: right !important\n}\n\n.float-none {\n    float: none !important\n}\n\n@media (min-width:576px) {\n    .float-sm-left {\n        float: left !important\n    }\n\n    .float-sm-right {\n        float: right !important\n    }\n\n    .float-sm-none {\n        float: none !important\n    }\n}\n\n@media (min-width:768px) {\n    .float-md-left {\n        float: left !important\n    }\n\n    .float-md-right {\n        float: right !important\n    }\n\n    .float-md-none {\n        float: none !important\n    }\n}\n\n@media (min-width:992px) {\n    .float-lg-left {\n        float: left !important\n    }\n\n    .float-lg-right {\n        float: right !important\n    }\n\n    .float-lg-none {\n        float: none !important\n    }\n}\n\n@media (min-width:1200px) {\n    .float-xl-left {\n        float: left !important\n    }\n\n    .float-xl-right {\n        float: right !important\n    }\n\n    .float-xl-none {\n        float: none !important\n    }\n}\n\n.user-select-all {\n    -webkit-user-select: all !important;\n    -moz-user-select: all !important;\n    -ms-user-select: all !important;\n    user-select: all !important\n}\n\n.user-select-auto {\n    -webkit-user-select: auto !important;\n    -moz-user-select: auto !important;\n    -ms-user-select: auto !important;\n    user-select: auto !important\n}\n\n.user-select-none {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    -ms-user-select: none !important;\n    user-select: none !important\n}\n\n.overflow-auto {\n    overflow: auto !important\n}\n\n.overflow-hidden {\n    overflow: hidden !important\n}\n\n.position-static {\n    position: static !important\n}\n\n.position-relative {\n    position: relative !important\n}\n\n.position-absolute {\n    position: absolute !important\n}\n\n.position-fixed {\n    position: fixed !important\n}\n\n.position-sticky {\n    position: -webkit-sticky !important;\n    position: sticky !important\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030\n}\n\n@supports ((position:-webkit-sticky) or (position:sticky)) {\n    .sticky-top {\n        position: -webkit-sticky;\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal\n}\n\n.shadow-sm {\n    box-shadow: 0 .125rem .25rem 0 rgba(58, 59, 69, .2) !important\n}\n\n.shadow {\n    box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important\n}\n\n.shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important\n}\n\n.shadow-none {\n    box-shadow: none !important\n}\n\n.w-25 {\n    width: 25% !important\n}\n\n.w-50 {\n    width: 50% !important\n}\n\n.w-75 {\n    width: 75% !important\n}\n\n.w-100 {\n    width: 100% !important\n}\n\n.w-auto {\n    width: auto !important\n}\n\n.h-25 {\n    height: 25% !important\n}\n\n.h-50 {\n    height: 50% !important\n}\n\n.h-75 {\n    height: 75% !important\n}\n\n.h-100 {\n    height: 100% !important\n}\n\n.h-auto {\n    height: auto !important\n}\n\n.mw-100 {\n    max-width: 100% !important\n}\n\n.mh-100 {\n    max-height: 100% !important\n}\n\n.min-vw-100 {\n    min-width: 100vw !important\n}\n\n.min-vh-100 {\n    min-height: 100vh !important\n}\n\n.vw-100 {\n    width: 100vw !important\n}\n\n.vh-100 {\n    height: 100vh !important\n}\n\n.m-0 {\n    margin: 0 !important\n}\n\n.mt-0,\n.my-0 {\n    margin-top: 0 !important\n}\n\n.mr-0,\n.mx-0 {\n    margin-right: 0 !important\n}\n\n.mb-0,\n.my-0 {\n    margin-bottom: 0 !important\n}\n\n.ml-0,\n.mx-0 {\n    margin-left: 0 !important\n}\n\n.m-1 {\n    margin: .25rem !important\n}\n\n.mt-1,\n.my-1 {\n    margin-top: .25rem !important\n}\n\n.mr-1,\n.mx-1 {\n    margin-right: .25rem !important\n}\n\n.mb-1,\n.my-1 {\n    margin-bottom: .25rem !important\n}\n\n.ml-1,\n.mx-1 {\n    margin-left: .25rem !important\n}\n\n.m-2 {\n    margin: .5rem !important\n}\n\n.mt-2,\n.my-2 {\n    margin-top: .5rem !important\n}\n\n.mr-2,\n.mx-2 {\n    margin-right: .5rem !important\n}\n\n.mb-2,\n.my-2 {\n    margin-bottom: .5rem !important\n}\n\n.ml-2,\n.mx-2 {\n    margin-left: .5rem !important\n}\n\n.m-3 {\n    margin: 1rem !important\n}\n\n.mt-3,\n.my-3 {\n    margin-top: 1rem !important\n}\n\n.mr-3,\n.mx-3 {\n    margin-right: 1rem !important\n}\n\n.mb-3,\n.my-3 {\n    margin-bottom: 1rem !important\n}\n\n.ml-3,\n.mx-3 {\n    margin-left: 1rem !important\n}\n\n.m-4 {\n    margin: 1.5rem !important\n}\n\n.mt-4,\n.my-4 {\n    margin-top: 1.5rem !important\n}\n\n.mr-4,\n.mx-4 {\n    margin-right: 1.5rem !important\n}\n\n.mb-4,\n.my-4 {\n    margin-bottom: 1.5rem !important\n}\n\n.ml-4,\n.mx-4 {\n    margin-left: 1.5rem !important\n}\n\n.m-5 {\n    margin: 3rem !important\n}\n\n.mt-5,\n.my-5 {\n    margin-top: 3rem !important\n}\n\n.mr-5,\n.mx-5 {\n    margin-right: 3rem !important\n}\n\n.mb-5,\n.my-5 {\n    margin-bottom: 3rem !important\n}\n\n.ml-5,\n.mx-5 {\n    margin-left: 3rem !important\n}\n\n.p-0 {\n    padding: 0 !important\n}\n\n.pt-0,\n.py-0 {\n    padding-top: 0 !important\n}\n\n.pr-0,\n.px-0 {\n    padding-right: 0 !important\n}\n\n.pb-0,\n.py-0 {\n    padding-bottom: 0 !important\n}\n\n.pl-0,\n.px-0 {\n    padding-left: 0 !important\n}\n\n.p-1 {\n    padding: .25rem !important\n}\n\n.pt-1,\n.py-1 {\n    padding-top: .25rem !important\n}\n\n.pr-1,\n.px-1 {\n    padding-right: .25rem !important\n}\n\n.pb-1,\n.py-1 {\n    padding-bottom: .25rem !important\n}\n\n.pl-1,\n.px-1 {\n    padding-left: .25rem !important\n}\n\n.p-2 {\n    padding: .5rem !important\n}\n\n.pt-2,\n.py-2 {\n    padding-top: .5rem !important\n}\n\n.pr-2,\n.px-2 {\n    padding-right: .5rem !important\n}\n\n.pb-2,\n.py-2 {\n    padding-bottom: .5rem !important\n}\n\n.pl-2,\n.px-2 {\n    padding-left: .5rem !important\n}\n\n.p-3 {\n    padding: 1rem !important\n}\n\n.pt-3,\n.py-3 {\n    padding-top: 1rem !important\n}\n\n.pr-3,\n.px-3 {\n    padding-right: 1rem !important\n}\n\n.pb-3,\n.py-3 {\n    padding-bottom: 1rem !important\n}\n\n.pl-3,\n.px-3 {\n    padding-left: 1rem !important\n}\n\n.p-4 {\n    padding: 1.5rem !important\n}\n\n.pt-4,\n.py-4 {\n    padding-top: 1.5rem !important\n}\n\n.pr-4,\n.px-4 {\n    padding-right: 1.5rem !important\n}\n\n.pb-4,\n.py-4 {\n    padding-bottom: 1.5rem !important\n}\n\n.pl-4,\n.px-4 {\n    padding-left: 1.5rem !important\n}\n\n.p-5 {\n    padding: 3rem !important\n}\n\n.pt-5,\n.py-5 {\n    padding-top: 3rem !important\n}\n\n.pr-5,\n.px-5 {\n    padding-right: 3rem !important\n}\n\n.pb-5,\n.py-5 {\n    padding-bottom: 3rem !important\n}\n\n.pl-5,\n.px-5 {\n    padding-left: 3rem !important\n}\n\n.m-n1 {\n    margin: -.25rem !important\n}\n\n.mt-n1,\n.my-n1 {\n    margin-top: -.25rem !important\n}\n\n.mr-n1,\n.mx-n1 {\n    margin-right: -.25rem !important\n}\n\n.mb-n1,\n.my-n1 {\n    margin-bottom: -.25rem !important\n}\n\n.ml-n1,\n.mx-n1 {\n    margin-left: -.25rem !important\n}\n\n.m-n2 {\n    margin: -.5rem !important\n}\n\n.mt-n2,\n.my-n2 {\n    margin-top: -.5rem !important\n}\n\n.mr-n2,\n.mx-n2 {\n    margin-right: -.5rem !important\n}\n\n.mb-n2,\n.my-n2 {\n    margin-bottom: -.5rem !important\n}\n\n.ml-n2,\n.mx-n2 {\n    margin-left: -.5rem !important\n}\n\n.m-n3 {\n    margin: -1rem !important\n}\n\n.mt-n3,\n.my-n3 {\n    margin-top: -1rem !important\n}\n\n.mr-n3,\n.mx-n3 {\n    margin-right: -1rem !important\n}\n\n.mb-n3,\n.my-n3 {\n    margin-bottom: -1rem !important\n}\n\n.ml-n3,\n.mx-n3 {\n    margin-left: -1rem !important\n}\n\n.m-n4 {\n    margin: -1.5rem !important\n}\n\n.mt-n4,\n.my-n4 {\n    margin-top: -1.5rem !important\n}\n\n.mr-n4,\n.mx-n4 {\n    margin-right: -1.5rem !important\n}\n\n.mb-n4,\n.my-n4 {\n    margin-bottom: -1.5rem !important\n}\n\n.ml-n4,\n.mx-n4 {\n    margin-left: -1.5rem !important\n}\n\n.m-n5 {\n    margin: -3rem !important\n}\n\n.mt-n5,\n.my-n5 {\n    margin-top: -3rem !important\n}\n\n.mr-n5,\n.mx-n5 {\n    margin-right: -3rem !important\n}\n\n.mb-n5,\n.my-n5 {\n    margin-bottom: -3rem !important\n}\n\n.ml-n5,\n.mx-n5 {\n    margin-left: -3rem !important\n}\n\n.m-auto {\n    margin: auto !important\n}\n\n.mt-auto,\n.my-auto {\n    margin-top: auto !important\n}\n\n.mr-auto,\n.mx-auto {\n    margin-right: auto !important\n}\n\n.mb-auto,\n.my-auto {\n    margin-bottom: auto !important\n}\n\n.ml-auto,\n.mx-auto {\n    margin-left: auto !important\n}\n\n@media (min-width:576px) {\n    .m-sm-0 {\n        margin: 0 !important\n    }\n\n    .mt-sm-0,\n    .my-sm-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-sm-0,\n    .mx-sm-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-sm-0,\n    .my-sm-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-sm-0,\n    .mx-sm-0 {\n        margin-left: 0 !important\n    }\n\n    .m-sm-1 {\n        margin: .25rem !important\n    }\n\n    .mt-sm-1,\n    .my-sm-1 {\n        margin-top: .25rem !important\n    }\n\n    .mr-sm-1,\n    .mx-sm-1 {\n        margin-right: .25rem !important\n    }\n\n    .mb-sm-1,\n    .my-sm-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .ml-sm-1,\n    .mx-sm-1 {\n        margin-left: .25rem !important\n    }\n\n    .m-sm-2 {\n        margin: .5rem !important\n    }\n\n    .mt-sm-2,\n    .my-sm-2 {\n        margin-top: .5rem !important\n    }\n\n    .mr-sm-2,\n    .mx-sm-2 {\n        margin-right: .5rem !important\n    }\n\n    .mb-sm-2,\n    .my-sm-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .ml-sm-2,\n    .mx-sm-2 {\n        margin-left: .5rem !important\n    }\n\n    .m-sm-3 {\n        margin: 1rem !important\n    }\n\n    .mt-sm-3,\n    .my-sm-3 {\n        margin-top: 1rem !important\n    }\n\n    .mr-sm-3,\n    .mx-sm-3 {\n        margin-right: 1rem !important\n    }\n\n    .mb-sm-3,\n    .my-sm-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .ml-sm-3,\n    .mx-sm-3 {\n        margin-left: 1rem !important\n    }\n\n    .m-sm-4 {\n        margin: 1.5rem !important\n    }\n\n    .mt-sm-4,\n    .my-sm-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mr-sm-4,\n    .mx-sm-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .mb-sm-4,\n    .my-sm-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .ml-sm-4,\n    .mx-sm-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .m-sm-5 {\n        margin: 3rem !important\n    }\n\n    .mt-sm-5,\n    .my-sm-5 {\n        margin-top: 3rem !important\n    }\n\n    .mr-sm-5,\n    .mx-sm-5 {\n        margin-right: 3rem !important\n    }\n\n    .mb-sm-5,\n    .my-sm-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .ml-sm-5,\n    .mx-sm-5 {\n        margin-left: 3rem !important\n    }\n\n    .p-sm-0 {\n        padding: 0 !important\n    }\n\n    .pt-sm-0,\n    .py-sm-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-sm-0,\n    .px-sm-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-sm-0,\n    .py-sm-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-sm-0,\n    .px-sm-0 {\n        padding-left: 0 !important\n    }\n\n    .p-sm-1 {\n        padding: .25rem !important\n    }\n\n    .pt-sm-1,\n    .py-sm-1 {\n        padding-top: .25rem !important\n    }\n\n    .pr-sm-1,\n    .px-sm-1 {\n        padding-right: .25rem !important\n    }\n\n    .pb-sm-1,\n    .py-sm-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pl-sm-1,\n    .px-sm-1 {\n        padding-left: .25rem !important\n    }\n\n    .p-sm-2 {\n        padding: .5rem !important\n    }\n\n    .pt-sm-2,\n    .py-sm-2 {\n        padding-top: .5rem !important\n    }\n\n    .pr-sm-2,\n    .px-sm-2 {\n        padding-right: .5rem !important\n    }\n\n    .pb-sm-2,\n    .py-sm-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pl-sm-2,\n    .px-sm-2 {\n        padding-left: .5rem !important\n    }\n\n    .p-sm-3 {\n        padding: 1rem !important\n    }\n\n    .pt-sm-3,\n    .py-sm-3 {\n        padding-top: 1rem !important\n    }\n\n    .pr-sm-3,\n    .px-sm-3 {\n        padding-right: 1rem !important\n    }\n\n    .pb-sm-3,\n    .py-sm-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pl-sm-3,\n    .px-sm-3 {\n        padding-left: 1rem !important\n    }\n\n    .p-sm-4 {\n        padding: 1.5rem !important\n    }\n\n    .pt-sm-4,\n    .py-sm-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pr-sm-4,\n    .px-sm-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pb-sm-4,\n    .py-sm-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pl-sm-4,\n    .px-sm-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .p-sm-5 {\n        padding: 3rem !important\n    }\n\n    .pt-sm-5,\n    .py-sm-5 {\n        padding-top: 3rem !important\n    }\n\n    .pr-sm-5,\n    .px-sm-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-sm-5,\n    .py-sm-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pl-sm-5,\n    .px-sm-5 {\n        padding-left: 3rem !important\n    }\n\n    .m-sm-n1 {\n        margin: -.25rem !important\n    }\n\n    .mt-sm-n1,\n    .my-sm-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mr-sm-n1,\n    .mx-sm-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .mb-sm-n1,\n    .my-sm-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .ml-sm-n1,\n    .mx-sm-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .m-sm-n2 {\n        margin: -.5rem !important\n    }\n\n    .mt-sm-n2,\n    .my-sm-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mr-sm-n2,\n    .mx-sm-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .mb-sm-n2,\n    .my-sm-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .ml-sm-n2,\n    .mx-sm-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .m-sm-n3 {\n        margin: -1rem !important\n    }\n\n    .mt-sm-n3,\n    .my-sm-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mr-sm-n3,\n    .mx-sm-n3 {\n        margin-right: -1rem !important\n    }\n\n    .mb-sm-n3,\n    .my-sm-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .ml-sm-n3,\n    .mx-sm-n3 {\n        margin-left: -1rem !important\n    }\n\n    .m-sm-n4 {\n        margin: -1.5rem !important\n    }\n\n    .mt-sm-n4,\n    .my-sm-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mr-sm-n4,\n    .mx-sm-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .mb-sm-n4,\n    .my-sm-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .ml-sm-n4,\n    .mx-sm-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .m-sm-n5 {\n        margin: -3rem !important\n    }\n\n    .mt-sm-n5,\n    .my-sm-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mr-sm-n5,\n    .mx-sm-n5 {\n        margin-right: -3rem !important\n    }\n\n    .mb-sm-n5,\n    .my-sm-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .ml-sm-n5,\n    .mx-sm-n5 {\n        margin-left: -3rem !important\n    }\n\n    .m-sm-auto {\n        margin: auto !important\n    }\n\n    .mt-sm-auto,\n    .my-sm-auto {\n        margin-top: auto !important\n    }\n\n    .mr-sm-auto,\n    .mx-sm-auto {\n        margin-right: auto !important\n    }\n\n    .mb-sm-auto,\n    .my-sm-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-sm-auto,\n    .mx-sm-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width:768px) {\n    .m-md-0 {\n        margin: 0 !important\n    }\n\n    .mt-md-0,\n    .my-md-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-md-0,\n    .mx-md-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-md-0,\n    .my-md-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-md-0,\n    .mx-md-0 {\n        margin-left: 0 !important\n    }\n\n    .m-md-1 {\n        margin: .25rem !important\n    }\n\n    .mt-md-1,\n    .my-md-1 {\n        margin-top: .25rem !important\n    }\n\n    .mr-md-1,\n    .mx-md-1 {\n        margin-right: .25rem !important\n    }\n\n    .mb-md-1,\n    .my-md-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .ml-md-1,\n    .mx-md-1 {\n        margin-left: .25rem !important\n    }\n\n    .m-md-2 {\n        margin: .5rem !important\n    }\n\n    .mt-md-2,\n    .my-md-2 {\n        margin-top: .5rem !important\n    }\n\n    .mr-md-2,\n    .mx-md-2 {\n        margin-right: .5rem !important\n    }\n\n    .mb-md-2,\n    .my-md-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .ml-md-2,\n    .mx-md-2 {\n        margin-left: .5rem !important\n    }\n\n    .m-md-3 {\n        margin: 1rem !important\n    }\n\n    .mt-md-3,\n    .my-md-3 {\n        margin-top: 1rem !important\n    }\n\n    .mr-md-3,\n    .mx-md-3 {\n        margin-right: 1rem !important\n    }\n\n    .mb-md-3,\n    .my-md-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .ml-md-3,\n    .mx-md-3 {\n        margin-left: 1rem !important\n    }\n\n    .m-md-4 {\n        margin: 1.5rem !important\n    }\n\n    .mt-md-4,\n    .my-md-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mr-md-4,\n    .mx-md-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .mb-md-4,\n    .my-md-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .ml-md-4,\n    .mx-md-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .m-md-5 {\n        margin: 3rem !important\n    }\n\n    .mt-md-5,\n    .my-md-5 {\n        margin-top: 3rem !important\n    }\n\n    .mr-md-5,\n    .mx-md-5 {\n        margin-right: 3rem !important\n    }\n\n    .mb-md-5,\n    .my-md-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .ml-md-5,\n    .mx-md-5 {\n        margin-left: 3rem !important\n    }\n\n    .p-md-0 {\n        padding: 0 !important\n    }\n\n    .pt-md-0,\n    .py-md-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-md-0,\n    .px-md-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-md-0,\n    .py-md-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-md-0,\n    .px-md-0 {\n        padding-left: 0 !important\n    }\n\n    .p-md-1 {\n        padding: .25rem !important\n    }\n\n    .pt-md-1,\n    .py-md-1 {\n        padding-top: .25rem !important\n    }\n\n    .pr-md-1,\n    .px-md-1 {\n        padding-right: .25rem !important\n    }\n\n    .pb-md-1,\n    .py-md-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pl-md-1,\n    .px-md-1 {\n        padding-left: .25rem !important\n    }\n\n    .p-md-2 {\n        padding: .5rem !important\n    }\n\n    .pt-md-2,\n    .py-md-2 {\n        padding-top: .5rem !important\n    }\n\n    .pr-md-2,\n    .px-md-2 {\n        padding-right: .5rem !important\n    }\n\n    .pb-md-2,\n    .py-md-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pl-md-2,\n    .px-md-2 {\n        padding-left: .5rem !important\n    }\n\n    .p-md-3 {\n        padding: 1rem !important\n    }\n\n    .pt-md-3,\n    .py-md-3 {\n        padding-top: 1rem !important\n    }\n\n    .pr-md-3,\n    .px-md-3 {\n        padding-right: 1rem !important\n    }\n\n    .pb-md-3,\n    .py-md-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pl-md-3,\n    .px-md-3 {\n        padding-left: 1rem !important\n    }\n\n    .p-md-4 {\n        padding: 1.5rem !important\n    }\n\n    .pt-md-4,\n    .py-md-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pr-md-4,\n    .px-md-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pb-md-4,\n    .py-md-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pl-md-4,\n    .px-md-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .p-md-5 {\n        padding: 3rem !important\n    }\n\n    .pt-md-5,\n    .py-md-5 {\n        padding-top: 3rem !important\n    }\n\n    .pr-md-5,\n    .px-md-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-md-5,\n    .py-md-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pl-md-5,\n    .px-md-5 {\n        padding-left: 3rem !important\n    }\n\n    .m-md-n1 {\n        margin: -.25rem !important\n    }\n\n    .mt-md-n1,\n    .my-md-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mr-md-n1,\n    .mx-md-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .mb-md-n1,\n    .my-md-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .ml-md-n1,\n    .mx-md-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .m-md-n2 {\n        margin: -.5rem !important\n    }\n\n    .mt-md-n2,\n    .my-md-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mr-md-n2,\n    .mx-md-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .mb-md-n2,\n    .my-md-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .ml-md-n2,\n    .mx-md-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .m-md-n3 {\n        margin: -1rem !important\n    }\n\n    .mt-md-n3,\n    .my-md-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mr-md-n3,\n    .mx-md-n3 {\n        margin-right: -1rem !important\n    }\n\n    .mb-md-n3,\n    .my-md-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .ml-md-n3,\n    .mx-md-n3 {\n        margin-left: -1rem !important\n    }\n\n    .m-md-n4 {\n        margin: -1.5rem !important\n    }\n\n    .mt-md-n4,\n    .my-md-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mr-md-n4,\n    .mx-md-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .mb-md-n4,\n    .my-md-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .ml-md-n4,\n    .mx-md-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .m-md-n5 {\n        margin: -3rem !important\n    }\n\n    .mt-md-n5,\n    .my-md-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mr-md-n5,\n    .mx-md-n5 {\n        margin-right: -3rem !important\n    }\n\n    .mb-md-n5,\n    .my-md-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .ml-md-n5,\n    .mx-md-n5 {\n        margin-left: -3rem !important\n    }\n\n    .m-md-auto {\n        margin: auto !important\n    }\n\n    .mt-md-auto,\n    .my-md-auto {\n        margin-top: auto !important\n    }\n\n    .mr-md-auto,\n    .mx-md-auto {\n        margin-right: auto !important\n    }\n\n    .mb-md-auto,\n    .my-md-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-md-auto,\n    .mx-md-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width:992px) {\n    .m-lg-0 {\n        margin: 0 !important\n    }\n\n    .mt-lg-0,\n    .my-lg-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-lg-0,\n    .mx-lg-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-lg-0,\n    .my-lg-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-lg-0,\n    .mx-lg-0 {\n        margin-left: 0 !important\n    }\n\n    .m-lg-1 {\n        margin: .25rem !important\n    }\n\n    .mt-lg-1,\n    .my-lg-1 {\n        margin-top: .25rem !important\n    }\n\n    .mr-lg-1,\n    .mx-lg-1 {\n        margin-right: .25rem !important\n    }\n\n    .mb-lg-1,\n    .my-lg-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .ml-lg-1,\n    .mx-lg-1 {\n        margin-left: .25rem !important\n    }\n\n    .m-lg-2 {\n        margin: .5rem !important\n    }\n\n    .mt-lg-2,\n    .my-lg-2 {\n        margin-top: .5rem !important\n    }\n\n    .mr-lg-2,\n    .mx-lg-2 {\n        margin-right: .5rem !important\n    }\n\n    .mb-lg-2,\n    .my-lg-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .ml-lg-2,\n    .mx-lg-2 {\n        margin-left: .5rem !important\n    }\n\n    .m-lg-3 {\n        margin: 1rem !important\n    }\n\n    .mt-lg-3,\n    .my-lg-3 {\n        margin-top: 1rem !important\n    }\n\n    .mr-lg-3,\n    .mx-lg-3 {\n        margin-right: 1rem !important\n    }\n\n    .mb-lg-3,\n    .my-lg-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .ml-lg-3,\n    .mx-lg-3 {\n        margin-left: 1rem !important\n    }\n\n    .m-lg-4 {\n        margin: 1.5rem !important\n    }\n\n    .mt-lg-4,\n    .my-lg-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mr-lg-4,\n    .mx-lg-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .mb-lg-4,\n    .my-lg-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .ml-lg-4,\n    .mx-lg-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .m-lg-5 {\n        margin: 3rem !important\n    }\n\n    .mt-lg-5,\n    .my-lg-5 {\n        margin-top: 3rem !important\n    }\n\n    .mr-lg-5,\n    .mx-lg-5 {\n        margin-right: 3rem !important\n    }\n\n    .mb-lg-5,\n    .my-lg-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .ml-lg-5,\n    .mx-lg-5 {\n        margin-left: 3rem !important\n    }\n\n    .p-lg-0 {\n        padding: 0 !important\n    }\n\n    .pt-lg-0,\n    .py-lg-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-lg-0,\n    .px-lg-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-lg-0,\n    .py-lg-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-lg-0,\n    .px-lg-0 {\n        padding-left: 0 !important\n    }\n\n    .p-lg-1 {\n        padding: .25rem !important\n    }\n\n    .pt-lg-1,\n    .py-lg-1 {\n        padding-top: .25rem !important\n    }\n\n    .pr-lg-1,\n    .px-lg-1 {\n        padding-right: .25rem !important\n    }\n\n    .pb-lg-1,\n    .py-lg-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pl-lg-1,\n    .px-lg-1 {\n        padding-left: .25rem !important\n    }\n\n    .p-lg-2 {\n        padding: .5rem !important\n    }\n\n    .pt-lg-2,\n    .py-lg-2 {\n        padding-top: .5rem !important\n    }\n\n    .pr-lg-2,\n    .px-lg-2 {\n        padding-right: .5rem !important\n    }\n\n    .pb-lg-2,\n    .py-lg-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pl-lg-2,\n    .px-lg-2 {\n        padding-left: .5rem !important\n    }\n\n    .p-lg-3 {\n        padding: 1rem !important\n    }\n\n    .pt-lg-3,\n    .py-lg-3 {\n        padding-top: 1rem !important\n    }\n\n    .pr-lg-3,\n    .px-lg-3 {\n        padding-right: 1rem !important\n    }\n\n    .pb-lg-3,\n    .py-lg-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pl-lg-3,\n    .px-lg-3 {\n        padding-left: 1rem !important\n    }\n\n    .p-lg-4 {\n        padding: 1.5rem !important\n    }\n\n    .pt-lg-4,\n    .py-lg-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pr-lg-4,\n    .px-lg-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pb-lg-4,\n    .py-lg-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pl-lg-4,\n    .px-lg-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .p-lg-5 {\n        padding: 3rem !important\n    }\n\n    .pt-lg-5,\n    .py-lg-5 {\n        padding-top: 3rem !important\n    }\n\n    .pr-lg-5,\n    .px-lg-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-lg-5,\n    .py-lg-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pl-lg-5,\n    .px-lg-5 {\n        padding-left: 3rem !important\n    }\n\n    .m-lg-n1 {\n        margin: -.25rem !important\n    }\n\n    .mt-lg-n1,\n    .my-lg-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mr-lg-n1,\n    .mx-lg-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .mb-lg-n1,\n    .my-lg-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .ml-lg-n1,\n    .mx-lg-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .m-lg-n2 {\n        margin: -.5rem !important\n    }\n\n    .mt-lg-n2,\n    .my-lg-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mr-lg-n2,\n    .mx-lg-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .mb-lg-n2,\n    .my-lg-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .ml-lg-n2,\n    .mx-lg-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .m-lg-n3 {\n        margin: -1rem !important\n    }\n\n    .mt-lg-n3,\n    .my-lg-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mr-lg-n3,\n    .mx-lg-n3 {\n        margin-right: -1rem !important\n    }\n\n    .mb-lg-n3,\n    .my-lg-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .ml-lg-n3,\n    .mx-lg-n3 {\n        margin-left: -1rem !important\n    }\n\n    .m-lg-n4 {\n        margin: -1.5rem !important\n    }\n\n    .mt-lg-n4,\n    .my-lg-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mr-lg-n4,\n    .mx-lg-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .mb-lg-n4,\n    .my-lg-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .ml-lg-n4,\n    .mx-lg-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .m-lg-n5 {\n        margin: -3rem !important\n    }\n\n    .mt-lg-n5,\n    .my-lg-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mr-lg-n5,\n    .mx-lg-n5 {\n        margin-right: -3rem !important\n    }\n\n    .mb-lg-n5,\n    .my-lg-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .ml-lg-n5,\n    .mx-lg-n5 {\n        margin-left: -3rem !important\n    }\n\n    .m-lg-auto {\n        margin: auto !important\n    }\n\n    .mt-lg-auto,\n    .my-lg-auto {\n        margin-top: auto !important\n    }\n\n    .mr-lg-auto,\n    .mx-lg-auto {\n        margin-right: auto !important\n    }\n\n    .mb-lg-auto,\n    .my-lg-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-lg-auto,\n    .mx-lg-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width:1200px) {\n    .m-xl-0 {\n        margin: 0 !important\n    }\n\n    .mt-xl-0,\n    .my-xl-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-xl-0,\n    .mx-xl-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-xl-0,\n    .my-xl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-xl-0,\n    .mx-xl-0 {\n        margin-left: 0 !important\n    }\n\n    .m-xl-1 {\n        margin: .25rem !important\n    }\n\n    .mt-xl-1,\n    .my-xl-1 {\n        margin-top: .25rem !important\n    }\n\n    .mr-xl-1,\n    .mx-xl-1 {\n        margin-right: .25rem !important\n    }\n\n    .mb-xl-1,\n    .my-xl-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .ml-xl-1,\n    .mx-xl-1 {\n        margin-left: .25rem !important\n    }\n\n    .m-xl-2 {\n        margin: .5rem !important\n    }\n\n    .mt-xl-2,\n    .my-xl-2 {\n        margin-top: .5rem !important\n    }\n\n    .mr-xl-2,\n    .mx-xl-2 {\n        margin-right: .5rem !important\n    }\n\n    .mb-xl-2,\n    .my-xl-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .ml-xl-2,\n    .mx-xl-2 {\n        margin-left: .5rem !important\n    }\n\n    .m-xl-3 {\n        margin: 1rem !important\n    }\n\n    .mt-xl-3,\n    .my-xl-3 {\n        margin-top: 1rem !important\n    }\n\n    .mr-xl-3,\n    .mx-xl-3 {\n        margin-right: 1rem !important\n    }\n\n    .mb-xl-3,\n    .my-xl-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .ml-xl-3,\n    .mx-xl-3 {\n        margin-left: 1rem !important\n    }\n\n    .m-xl-4 {\n        margin: 1.5rem !important\n    }\n\n    .mt-xl-4,\n    .my-xl-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mr-xl-4,\n    .mx-xl-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .mb-xl-4,\n    .my-xl-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .ml-xl-4,\n    .mx-xl-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .m-xl-5 {\n        margin: 3rem !important\n    }\n\n    .mt-xl-5,\n    .my-xl-5 {\n        margin-top: 3rem !important\n    }\n\n    .mr-xl-5,\n    .mx-xl-5 {\n        margin-right: 3rem !important\n    }\n\n    .mb-xl-5,\n    .my-xl-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .ml-xl-5,\n    .mx-xl-5 {\n        margin-left: 3rem !important\n    }\n\n    .p-xl-0 {\n        padding: 0 !important\n    }\n\n    .pt-xl-0,\n    .py-xl-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-xl-0,\n    .px-xl-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-xl-0,\n    .py-xl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-xl-0,\n    .px-xl-0 {\n        padding-left: 0 !important\n    }\n\n    .p-xl-1 {\n        padding: .25rem !important\n    }\n\n    .pt-xl-1,\n    .py-xl-1 {\n        padding-top: .25rem !important\n    }\n\n    .pr-xl-1,\n    .px-xl-1 {\n        padding-right: .25rem !important\n    }\n\n    .pb-xl-1,\n    .py-xl-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pl-xl-1,\n    .px-xl-1 {\n        padding-left: .25rem !important\n    }\n\n    .p-xl-2 {\n        padding: .5rem !important\n    }\n\n    .pt-xl-2,\n    .py-xl-2 {\n        padding-top: .5rem !important\n    }\n\n    .pr-xl-2,\n    .px-xl-2 {\n        padding-right: .5rem !important\n    }\n\n    .pb-xl-2,\n    .py-xl-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pl-xl-2,\n    .px-xl-2 {\n        padding-left: .5rem !important\n    }\n\n    .p-xl-3 {\n        padding: 1rem !important\n    }\n\n    .pt-xl-3,\n    .py-xl-3 {\n        padding-top: 1rem !important\n    }\n\n    .pr-xl-3,\n    .px-xl-3 {\n        padding-right: 1rem !important\n    }\n\n    .pb-xl-3,\n    .py-xl-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pl-xl-3,\n    .px-xl-3 {\n        padding-left: 1rem !important\n    }\n\n    .p-xl-4 {\n        padding: 1.5rem !important\n    }\n\n    .pt-xl-4,\n    .py-xl-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pr-xl-4,\n    .px-xl-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pb-xl-4,\n    .py-xl-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pl-xl-4,\n    .px-xl-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .p-xl-5 {\n        padding: 3rem !important\n    }\n\n    .pt-xl-5,\n    .py-xl-5 {\n        padding-top: 3rem !important\n    }\n\n    .pr-xl-5,\n    .px-xl-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-xl-5,\n    .py-xl-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pl-xl-5,\n    .px-xl-5 {\n        padding-left: 3rem !important\n    }\n\n    .m-xl-n1 {\n        margin: -.25rem !important\n    }\n\n    .mt-xl-n1,\n    .my-xl-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mr-xl-n1,\n    .mx-xl-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .mb-xl-n1,\n    .my-xl-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .ml-xl-n1,\n    .mx-xl-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .m-xl-n2 {\n        margin: -.5rem !important\n    }\n\n    .mt-xl-n2,\n    .my-xl-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mr-xl-n2,\n    .mx-xl-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .mb-xl-n2,\n    .my-xl-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .ml-xl-n2,\n    .mx-xl-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .m-xl-n3 {\n        margin: -1rem !important\n    }\n\n    .mt-xl-n3,\n    .my-xl-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mr-xl-n3,\n    .mx-xl-n3 {\n        margin-right: -1rem !important\n    }\n\n    .mb-xl-n3,\n    .my-xl-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .ml-xl-n3,\n    .mx-xl-n3 {\n        margin-left: -1rem !important\n    }\n\n    .m-xl-n4 {\n        margin: -1.5rem !important\n    }\n\n    .mt-xl-n4,\n    .my-xl-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mr-xl-n4,\n    .mx-xl-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .mb-xl-n4,\n    .my-xl-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .ml-xl-n4,\n    .mx-xl-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .m-xl-n5 {\n        margin: -3rem !important\n    }\n\n    .mt-xl-n5,\n    .my-xl-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mr-xl-n5,\n    .mx-xl-n5 {\n        margin-right: -3rem !important\n    }\n\n    .mb-xl-n5,\n    .my-xl-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .ml-xl-n5,\n    .mx-xl-n5 {\n        margin-left: -3rem !important\n    }\n\n    .m-xl-auto {\n        margin: auto !important\n    }\n\n    .mt-xl-auto,\n    .my-xl-auto {\n        margin-top: auto !important\n    }\n\n    .mr-xl-auto,\n    .mx-xl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xl-auto,\n    .my-xl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-xl-auto,\n    .mx-xl-auto {\n        margin-left: auto !important\n    }\n}\n\n.stretched-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0)\n}\n\n.text-monospace {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important\n}\n\n.text-justify {\n    text-align: justify !important\n}\n\n.text-wrap {\n    white-space: normal !important\n}\n\n.text-nowrap {\n    white-space: nowrap !important\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.text-left {\n    text-align: left !important\n}\n\n.text-right {\n    text-align: right !important\n}\n\n.text-center {\n    text-align: center !important\n}\n\n@media (min-width:576px) {\n    .text-sm-left {\n        text-align: left !important\n    }\n\n    .text-sm-right {\n        text-align: right !important\n    }\n\n    .text-sm-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width:768px) {\n    .text-md-left {\n        text-align: left !important\n    }\n\n    .text-md-right {\n        text-align: right !important\n    }\n\n    .text-md-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width:992px) {\n    .text-lg-left {\n        text-align: left !important\n    }\n\n    .text-lg-right {\n        text-align: right !important\n    }\n\n    .text-lg-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width:1200px) {\n    .text-xl-left {\n        text-align: left !important\n    }\n\n    .text-xl-right {\n        text-align: right !important\n    }\n\n    .text-xl-center {\n        text-align: center !important\n    }\n}\n\n.text-lowercase {\n    text-transform: lowercase !important\n}\n\n.dropdown .dropdown-menu .dropdown-header,\n.sidebar .sidebar-heading,\n.text-uppercase {\n    text-transform: uppercase !important\n}\n\n.text-capitalize {\n    text-transform: capitalize !important\n}\n\n.font-weight-light {\n    font-weight: 300 !important\n}\n\n.font-weight-lighter {\n    font-weight: lighter !important\n}\n\n.font-weight-normal {\n    font-weight: 400 !important\n}\n\n.font-weight-bold {\n    font-weight: 700 !important\n}\n\n.font-weight-bolder {\n    font-weight: bolder !important\n}\n\n.font-italic {\n    font-style: italic !important\n}\n\n.text-white {\n    color: #fff !important\n}\n\n.text-primary {\n    color: #4e73df !important\n}\n\na.text-primary:focus,\na.text-primary:hover {\n    color: #224abe !important\n}\n\n.text-secondary {\n    color: #858796 !important\n}\n\na.text-secondary:focus,\na.text-secondary:hover {\n    color: #60616f !important\n}\n\n.text-success {\n    color: #1cc88a !important\n}\n\na.text-success:focus,\na.text-success:hover {\n    color: #13855c !important\n}\n\n.text-info {\n    color: #36b9cc !important\n}\n\na.text-info:focus,\na.text-info:hover {\n    color: #258391 !important\n}\n\n.text-warning {\n    color: #f6c23e !important\n}\n\na.text-warning:focus,\na.text-warning:hover {\n    color: #dda20a !important\n}\n\n.text-danger {\n    color: #e74a3b !important\n}\n\na.text-danger:focus,\na.text-danger:hover {\n    color: #be2617 !important\n}\n\n.text-light {\n    color: #f8f9fc !important\n}\n\na.text-light:focus,\na.text-light:hover {\n    color: #c2cbe5 !important\n}\n\n.text-dark {\n    color: #5a5c69 !important\n}\n\na.text-dark:focus,\na.text-dark:hover {\n    color: #373840 !important\n}\n\n.text-body {\n    color: #858796 !important\n}\n\n.text-muted {\n    color: #858796 !important\n}\n\n.text-black-50 {\n    color: rgba(0, 0, 0, .5) !important\n}\n\n.text-white-50 {\n    color: rgba(255, 255, 255, .5) !important\n}\n\n.text-hide {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0\n}\n\n.text-decoration-none {\n    text-decoration: none !important\n}\n\n.text-break {\n    word-break: break-word !important;\n    word-wrap: break-word !important\n}\n\n.text-reset {\n    color: inherit !important\n}\n\n.visible {\n    visibility: visible !important\n}\n\n.invisible {\n    visibility: hidden !important\n}\n\n@media print {\n\n    *,\n    ::after,\n    ::before {\n        text-shadow: none !important;\n        box-shadow: none !important\n    }\n\n    a:not(.btn) {\n        text-decoration: underline\n    }\n\n    abbr[title]::after {\n        content: \" (\" attr(title) \")\"\n    }\n\n    pre {\n        white-space: pre-wrap !important\n    }\n\n    blockquote,\n    pre {\n        border: 1px solid #b7b9cc;\n        page-break-inside: avoid\n    }\n\n    thead {\n        display: table-header-group\n    }\n\n    img,\n    tr {\n        page-break-inside: avoid\n    }\n\n    h2,\n    h3,\n    p {\n        orphans: 3;\n        widows: 3\n    }\n\n    h2,\n    h3 {\n        page-break-after: avoid\n    }\n\n    @page {\n        size: a3\n    }\n\n    body {\n        min-width: 992px !important\n    }\n\n    .container {\n        min-width: 992px !important\n    }\n\n    .navbar {\n        display: none\n    }\n\n    .badge {\n        border: 1px solid #000\n    }\n\n    .table {\n        border-collapse: collapse !important\n    }\n\n    .table td,\n    .table th {\n        background-color: #fff !important\n    }\n\n    .table-bordered td,\n    .table-bordered th {\n        border: 1px solid #dddfeb !important\n    }\n\n    .table-dark {\n        color: inherit\n    }\n\n    .table-dark tbody+tbody,\n    .table-dark td,\n    .table-dark th,\n    .table-dark thead th {\n        border-color: #e3e6f0\n    }\n\n    .table .thead-dark th {\n        color: inherit;\n        border-color: #e3e6f0\n    }\n}\n\nhtml {\n    position: relative;\n    min-height: 100%\n}\n\nbody {\n    height: 100%\n}\n\na:focus {\n    outline: 0\n}\n\n#wrapper {\n    display: flex\n}\n\n#wrapper #content-wrapper {\n    background-color: #f8f9fc;\n    width: 100%;\n    overflow-x: hidden\n}\n\n#wrapper #content-wrapper #content {\n    flex: 1 0 auto\n}\n\n.container,\n.container-fluid,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem\n}\n\n.scroll-to-top {\n    position: fixed;\n    right: 1rem;\n    bottom: 1rem;\n    display: none;\n    width: 2.75rem;\n    height: 2.75rem;\n    text-align: center;\n    color: #fff;\n    background: rgba(90, 92, 105, .5);\n    line-height: 46px\n}\n\n.scroll-to-top:focus,\n.scroll-to-top:hover {\n    color: #fff\n}\n\n.scroll-to-top:hover {\n    background: #5a5c69\n}\n\n.scroll-to-top i {\n    font-weight: 800\n}\n\n@-webkit-keyframes growIn {\n    0% {\n        transform: scale(.9);\n        opacity: 0\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1\n    }\n}\n\n@keyframes growIn {\n    0% {\n        transform: scale(.9);\n        opacity: 0\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1\n    }\n}\n\n.animated--grow-in,\n.sidebar .nav-item .collapse {\n    -webkit-animation-name: growIn;\n    animation-name: growIn;\n    -webkit-animation-duration: .2s;\n    animation-duration: .2s;\n    -webkit-animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1);\n    animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1)\n}\n\n@-webkit-keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.animated--fade-in {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: .2s;\n    animation-duration: .2s;\n    -webkit-animation-timing-function: opacity cubic-bezier(0, 1, .4, 1);\n    animation-timing-function: opacity cubic-bezier(0, 1, .4, 1)\n}\n\n.bg-gradient-primary {\n    background-color: #4e73df;\n    background-image: linear-gradient(180deg, #4e73df 10%, #224abe 100%);\n    background-size: cover\n}\n\n.bg-gradient-secondary {\n    background-color: #858796;\n    background-image: linear-gradient(180deg, #858796 10%, #60616f 100%);\n    background-size: cover\n}\n\n.bg-gradient-success {\n    background-color: #1cc88a;\n    background-image: linear-gradient(180deg, #1cc88a 10%, #13855c 100%);\n    background-size: cover\n}\n\n.bg-gradient-info {\n    background-color: #36b9cc;\n    background-image: linear-gradient(180deg, #36b9cc 10%, #258391 100%);\n    background-size: cover\n}\n\n.bg-gradient-warning {\n    background-color: #f6c23e;\n    background-image: linear-gradient(180deg, #f6c23e 10%, #dda20a 100%);\n    background-size: cover\n}\n\n.bg-gradient-danger {\n    background-color: #e74a3b;\n    background-image: linear-gradient(180deg, #e74a3b 10%, #be2617 100%);\n    background-size: cover\n}\n\n.bg-gradient-light {\n    background-color: #f8f9fc;\n    background-image: linear-gradient(180deg, #f8f9fc 10%, #c2cbe5 100%);\n    background-size: cover\n}\n\n.bg-gradient-dark {\n    background-color: #5a5c69;\n    background-image: linear-gradient(180deg, #5a5c69 10%, #373840 100%);\n    background-size: cover\n}\n\n.bg-gray-100 {\n    background-color: #f8f9fc !important\n}\n\n.bg-gray-200 {\n    background-color: #eaecf4 !important\n}\n\n.bg-gray-300 {\n    background-color: #dddfeb !important\n}\n\n.bg-gray-400 {\n    background-color: #d1d3e2 !important\n}\n\n.bg-gray-500 {\n    background-color: #b7b9cc !important\n}\n\n.bg-gray-600 {\n    background-color: #858796 !important\n}\n\n.bg-gray-700 {\n    background-color: #6e707e !important\n}\n\n.bg-gray-800 {\n    background-color: #5a5c69 !important\n}\n\n.bg-gray-900 {\n    background-color: #3a3b45 !important\n}\n\n.o-hidden {\n    overflow: hidden !important\n}\n\n.text-xs {\n    font-size: .7rem\n}\n\n.text-lg {\n    font-size: 1.2rem\n}\n\n.text-gray-100 {\n    color: #f8f9fc !important\n}\n\n.text-gray-200 {\n    color: #eaecf4 !important\n}\n\n.text-gray-300 {\n    color: #dddfeb !important\n}\n\n.text-gray-400 {\n    color: #d1d3e2 !important\n}\n\n.text-gray-500 {\n    color: #b7b9cc !important\n}\n\n.text-gray-600 {\n    color: #858796 !important\n}\n\n.text-gray-700 {\n    color: #6e707e !important\n}\n\n.text-gray-800 {\n    color: #5a5c69 !important\n}\n\n.text-gray-900 {\n    color: #3a3b45 !important\n}\n\n.icon-circle {\n    height: 2.5rem;\n    width: 2.5rem;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center\n}\n\n.border-left-primary {\n    border-left: .25rem solid #4e73df !important\n}\n\n.border-bottom-primary {\n    border-bottom: .25rem solid #4e73df !important\n}\n\n.border-left-secondary {\n    border-left: .25rem solid #858796 !important\n}\n\n.border-bottom-secondary {\n    border-bottom: .25rem solid #858796 !important\n}\n\n.border-left-success {\n    border-left: .25rem solid #1cc88a !important\n}\n\n.border-bottom-success {\n    border-bottom: .25rem solid #1cc88a !important\n}\n\n.border-left-info {\n    border-left: .25rem solid #36b9cc !important\n}\n\n.border-bottom-info {\n    border-bottom: .25rem solid #36b9cc !important\n}\n\n.border-left-warning {\n    border-left: .25rem solid #f6c23e !important\n}\n\n.border-bottom-warning {\n    border-bottom: .25rem solid #f6c23e !important\n}\n\n.border-left-danger {\n    border-left: .25rem solid #e74a3b !important\n}\n\n.border-bottom-danger {\n    border-bottom: .25rem solid #e74a3b !important\n}\n\n.border-left-light {\n    border-left: .25rem solid #f8f9fc !important\n}\n\n.border-bottom-light {\n    border-bottom: .25rem solid #f8f9fc !important\n}\n\n.border-left-dark {\n    border-left: .25rem solid #5a5c69 !important\n}\n\n.border-bottom-dark {\n    border-bottom: .25rem solid #5a5c69 !important\n}\n\n.progress-sm {\n    height: .5rem\n}\n\n.rotate-15 {\n    transform: rotate(15deg)\n}\n\n.rotate-n-15 {\n    transform: rotate(-15deg)\n}\n\n.dropdown .dropdown-menu {\n    font-size: .85rem\n}\n\n.dropdown .dropdown-menu .dropdown-header {\n    font-weight: 800;\n    font-size: .65rem;\n    color: #b7b9cc\n}\n\n.dropdown.no-arrow .dropdown-toggle::after {\n    display: none\n}\n\n.sidebar .nav-item.dropdown .dropdown-toggle::after,\n.topbar .nav-item.dropdown .dropdown-toggle::after {\n    width: 1rem;\n    text-align: center;\n    float: right;\n    vertical-align: 0;\n    border: 0;\n    font-weight: 900;\n    content: '\\f105';\n    font-family: 'Font Awesome 5 Free'\n}\n\n.sidebar .nav-item.dropdown.show .dropdown-toggle::after,\n.topbar .nav-item.dropdown.show .dropdown-toggle::after {\n    content: '\\f107'\n}\n\n.sidebar .nav-item .nav-link,\n.topbar .nav-item .nav-link {\n    position: relative\n}\n\n.sidebar .nav-item .nav-link .badge-counter,\n.topbar .nav-item .nav-link .badge-counter {\n    position: absolute;\n    transform: scale(.7);\n    transform-origin: top right;\n    right: .25rem;\n    margin-top: -.25rem\n}\n\n.sidebar .nav-item .nav-link .img-profile,\n.topbar .nav-item .nav-link .img-profile {\n    height: 2rem;\n    width: 2rem\n}\n\n.topbar {\n    height: 4.375rem\n}\n\n.topbar #sidebarToggleTop {\n    height: 2.5rem;\n    width: 2.5rem\n}\n\n.topbar #sidebarToggleTop:hover {\n    background-color: #eaecf4\n}\n\n.topbar #sidebarToggleTop:active {\n    background-color: #dddfeb\n}\n\n.topbar .navbar-search {\n    width: 25rem\n}\n\n.topbar .navbar-search input {\n    font-size: .85rem;\n    height: auto\n}\n\n.topbar .topbar-divider {\n    width: 0;\n    border-right: 1px solid #e3e6f0;\n    height: calc(4.375rem - 2rem);\n    margin: auto 1rem\n}\n\n.topbar .nav-item .nav-link {\n    height: 4.375rem;\n    display: flex;\n    align-items: center;\n    padding: 0 .75rem\n}\n\n.topbar .nav-item .nav-link:focus {\n    outline: 0\n}\n\n.topbar .nav-item:focus {\n    outline: 0\n}\n\n.topbar .dropdown {\n    position: static\n}\n\n.topbar .dropdown .dropdown-menu {\n    width: calc(100% - 1.5rem);\n    right: .75rem\n}\n\n.topbar .dropdown-list {\n    padding: 0;\n    border: none;\n    overflow: hidden\n}\n\n.topbar .dropdown-list .dropdown-header {\n    background-color: #4e73df;\n    border: 1px solid #4e73df;\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n    color: #fff\n}\n\n.topbar .dropdown-list .dropdown-item {\n    white-space: normal;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    border-left: 1px solid #e3e6f0;\n    border-right: 1px solid #e3e6f0;\n    border-bottom: 1px solid #e3e6f0;\n    line-height: 1.3rem\n}\n\n.topbar .dropdown-list .dropdown-item .dropdown-list-image {\n    position: relative;\n    height: 2.5rem;\n    width: 2.5rem\n}\n\n.topbar .dropdown-list .dropdown-item .dropdown-list-image img {\n    height: 2.5rem;\n    width: 2.5rem\n}\n\n.topbar .dropdown-list .dropdown-item .dropdown-list-image .status-indicator {\n    background-color: #eaecf4;\n    height: .75rem;\n    width: .75rem;\n    border-radius: 100%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    border: .125rem solid #fff\n}\n\n.topbar .dropdown-list .dropdown-item .text-truncate {\n    max-width: 10rem\n}\n\n.topbar .dropdown-list .dropdown-item:active {\n    background-color: #eaecf4;\n    color: #3a3b45\n}\n\n@media (min-width:576px) {\n    .topbar .dropdown {\n        position: relative\n    }\n\n    .topbar .dropdown .dropdown-menu {\n        width: auto;\n        right: 0\n    }\n\n    .topbar .dropdown-list {\n        width: 20rem !important\n    }\n\n    .topbar .dropdown-list .dropdown-item .text-truncate {\n        max-width: 13.375rem\n    }\n}\n\n.topbar.navbar-dark .navbar-nav .nav-item .nav-link {\n    color: rgba(255, 255, 255, .8)\n}\n\n.topbar.navbar-dark .navbar-nav .nav-item .nav-link:hover {\n    color: #fff\n}\n\n.topbar.navbar-dark .navbar-nav .nav-item .nav-link:active {\n    color: #fff\n}\n\n.topbar.navbar-light .navbar-nav .nav-item .nav-link {\n    color: #d1d3e2\n}\n\n.topbar.navbar-light .navbar-nav .nav-item .nav-link:hover {\n    color: #b7b9cc\n}\n\n.topbar.navbar-light .navbar-nav .nav-item .nav-link:active {\n    color: #858796\n}\n\n.sidebar {\n    width: 6.5rem;\n    min-height: 100vh\n}\n\n.sidebar .nav-item {\n    position: relative\n}\n\n.sidebar .nav-item:last-child {\n    margin-bottom: 1rem\n}\n\n.sidebar .nav-item .nav-link {\n    text-align: center;\n    padding: .75rem 1rem;\n    width: 6.5rem\n}\n\n.sidebar .nav-item .nav-link span {\n    font-size: .65rem;\n    display: block\n}\n\n.sidebar .nav-item.active .nav-link {\n    font-weight: 700\n}\n\n.sidebar .nav-item .collapse {\n    position: absolute;\n    left: calc(6.5rem + 1.5rem / 2);\n    z-index: 1;\n    top: 2px\n}\n\n.sidebar .nav-item .collapse .collapse-inner {\n    border-radius: .35rem;\n    box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15)\n}\n\n.sidebar .nav-item .collapsing {\n    display: none;\n    transition: none\n}\n\n.sidebar .nav-item .collapse .collapse-inner,\n.sidebar .nav-item .collapsing .collapse-inner {\n    padding: .5rem 0;\n    min-width: 10rem;\n    font-size: .85rem;\n    margin: 0 0 1rem 0\n}\n\n.sidebar .nav-item .collapse .collapse-inner .collapse-header,\n.sidebar .nav-item .collapsing .collapse-inner .collapse-header {\n    margin: 0;\n    white-space: nowrap;\n    padding: .5rem 1.5rem;\n    text-transform: uppercase;\n    font-weight: 800;\n    font-size: .65rem;\n    color: #b7b9cc\n}\n\n.sidebar .nav-item .collapse .collapse-inner .collapse-item,\n.sidebar .nav-item .collapsing .collapse-inner .collapse-item {\n    padding: .5rem 1rem;\n    margin: 0 .5rem;\n    display: block;\n    color: #3a3b45;\n    text-decoration: none;\n    border-radius: .35rem;\n    white-space: nowrap\n}\n\n.sidebar .nav-item .collapse .collapse-inner .collapse-item:hover,\n.sidebar .nav-item .collapsing .collapse-inner .collapse-item:hover {\n    background-color: #eaecf4\n}\n\n.sidebar .nav-item .collapse .collapse-inner .collapse-item:active,\n.sidebar .nav-item .collapsing .collapse-inner .collapse-item:active {\n    background-color: #dddfeb\n}\n\n.sidebar .nav-item .collapse .collapse-inner .collapse-item.active,\n.sidebar .nav-item .collapsing .collapse-inner .collapse-item.active {\n    color: #4e73df;\n    font-weight: 700\n}\n\n.sidebar #sidebarToggle {\n    width: 2.5rem;\n    height: 2.5rem;\n    text-align: center;\n    margin-bottom: 1rem;\n    cursor: pointer\n}\n\n.sidebar #sidebarToggle::after {\n    font-weight: 900;\n    content: '\\f104';\n    font-family: 'Font Awesome 5 Free';\n    margin-right: .1rem\n}\n\n.sidebar #sidebarToggle:hover {\n    text-decoration: none\n}\n\n.sidebar #sidebarToggle:focus {\n    outline: 0\n}\n\n.sidebar.toggled {\n    width: 0 !important;\n    overflow: hidden\n}\n\n.sidebar.toggled #sidebarToggle::after {\n    content: '\\f105';\n    font-family: 'Font Awesome 5 Free';\n    margin-left: .25rem\n}\n\n.sidebar.toggled .sidebar-card {\n    display: none\n}\n\n.sidebar .sidebar-brand {\n    height: 4.375rem;\n    text-decoration: none;\n    font-size: 1rem;\n    font-weight: 800;\n    padding: 1.5rem 1rem;\n    text-align: center;\n    text-transform: uppercase;\n    letter-spacing: .05rem;\n    z-index: 1\n}\n\n.sidebar .sidebar-brand .sidebar-brand-icon i {\n    font-size: 2rem\n}\n\n.sidebar .sidebar-brand .sidebar-brand-text {\n    display: none\n}\n\n.sidebar hr.sidebar-divider {\n    margin: 0 1rem 1rem\n}\n\n.sidebar .sidebar-heading {\n    text-align: center;\n    padding: 0 1rem;\n    font-weight: 800;\n    font-size: .65rem\n}\n\n.sidebar .sidebar-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: .875rem;\n    border-radius: .35rem;\n    color: rgba(255, 255, 255, .8);\n    margin-left: 1rem;\n    margin-right: 1rem;\n    margin-bottom: 1rem;\n    padding: 1rem;\n    background-color: rgba(0, 0, 0, .1)\n}\n\n.sidebar .sidebar-card .sidebar-card-illustration {\n    height: 3rem;\n    display: block\n}\n\n.sidebar .sidebar-card .sidebar-card-title {\n    font-weight: 700\n}\n\n.sidebar .sidebar-card p {\n    font-size: .75rem;\n    color: rgba(255, 255, 255, .5)\n}\n\n@media (min-width:768px) {\n    .sidebar {\n        width: 14rem !important\n    }\n\n    .sidebar .nav-item .collapse {\n        position: relative;\n        left: 0;\n        z-index: 1;\n        top: 0;\n        -webkit-animation: none;\n        animation: none\n    }\n\n    .sidebar .nav-item .collapse .collapse-inner {\n        border-radius: 0;\n        box-shadow: none\n    }\n\n    .sidebar .nav-item .collapsing {\n        display: block;\n        transition: height .15s ease\n    }\n\n    .sidebar .nav-item .collapse,\n    .sidebar .nav-item .collapsing {\n        margin: 0 1rem\n    }\n\n    .sidebar .nav-item .nav-link {\n        display: block;\n        width: 100%;\n        text-align: left;\n        padding: 1rem;\n        width: 14rem\n    }\n\n    .sidebar .nav-item .nav-link i {\n        font-size: .85rem;\n        margin-right: .25rem\n    }\n\n    .sidebar .nav-item .nav-link span {\n        font-size: .85rem;\n        display: inline\n    }\n\n    .sidebar .nav-item .nav-link[data-toggle=collapse]::after {\n        width: 1rem;\n        text-align: center;\n        float: right;\n        vertical-align: 0;\n        border: 0;\n        font-weight: 900;\n        content: '\\f107';\n        font-family: 'Font Awesome 5 Free'\n    }\n\n    .sidebar .nav-item .nav-link[data-toggle=collapse].collapsed::after {\n        content: '\\f105'\n    }\n\n    .sidebar .sidebar-brand .sidebar-brand-icon i {\n        font-size: 2rem\n    }\n\n    .sidebar .sidebar-brand .sidebar-brand-text {\n        display: inline\n    }\n\n    .sidebar .sidebar-heading {\n        text-align: left\n    }\n\n    .sidebar.toggled {\n        overflow: visible;\n        width: 6.5rem !important\n    }\n\n    .sidebar.toggled .nav-item .collapse {\n        position: absolute;\n        left: calc(6.5rem + 1.5rem / 2);\n        z-index: 1;\n        top: 2px;\n        -webkit-animation-name: growIn;\n        animation-name: growIn;\n        -webkit-animation-duration: .2s;\n        animation-duration: .2s;\n        -webkit-animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1);\n        animation-timing-function: transform cubic-bezier(.18, 1.25, .4, 1), opacity cubic-bezier(0, 1, .4, 1)\n    }\n\n    .sidebar.toggled .nav-item .collapse .collapse-inner {\n        box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15);\n        border-radius: .35rem\n    }\n\n    .sidebar.toggled .nav-item .collapsing {\n        display: none;\n        transition: none\n    }\n\n    .sidebar.toggled .nav-item .collapse,\n    .sidebar.toggled .nav-item .collapsing {\n        margin: 0\n    }\n\n    .sidebar.toggled .nav-item:last-child {\n        margin-bottom: 1rem\n    }\n\n    .sidebar.toggled .nav-item .nav-link {\n        text-align: center;\n        padding: .75rem 1rem;\n        width: 6.5rem\n    }\n\n    .sidebar.toggled .nav-item .nav-link span {\n        font-size: .65rem;\n        display: block\n    }\n\n    .sidebar.toggled .nav-item .nav-link i {\n        margin-right: 0\n    }\n\n    .sidebar.toggled .nav-item .nav-link[data-toggle=collapse]::after {\n        display: none\n    }\n\n    .sidebar.toggled .sidebar-brand .sidebar-brand-icon i {\n        font-size: 2rem\n    }\n\n    .sidebar.toggled .sidebar-brand .sidebar-brand-text {\n        display: none\n    }\n\n    .sidebar.toggled .sidebar-heading {\n        text-align: center\n    }\n}\n\n.sidebar-light .sidebar-brand {\n    color: #6e707e\n}\n\n.sidebar-light hr.sidebar-divider {\n    border-top: 1px solid #eaecf4\n}\n\n.sidebar-light .sidebar-heading {\n    color: #b7b9cc\n}\n\n.sidebar-light .nav-item .nav-link {\n    color: #858796\n}\n\n.sidebar-light .nav-item .nav-link i {\n    color: #d1d3e2\n}\n\n.sidebar-light .nav-item .nav-link:active,\n.sidebar-light .nav-item .nav-link:focus,\n.sidebar-light .nav-item .nav-link:hover {\n    color: #6e707e\n}\n\n.sidebar-light .nav-item .nav-link:active i,\n.sidebar-light .nav-item .nav-link:focus i,\n.sidebar-light .nav-item .nav-link:hover i {\n    color: #6e707e\n}\n\n.sidebar-light .nav-item .nav-link[data-toggle=collapse]::after {\n    color: #b7b9cc\n}\n\n.sidebar-light .nav-item.active .nav-link {\n    color: #6e707e\n}\n\n.sidebar-light .nav-item.active .nav-link i {\n    color: #6e707e\n}\n\n.sidebar-light #sidebarToggle {\n    background-color: #eaecf4\n}\n\n.sidebar-light #sidebarToggle::after {\n    color: #b7b9cc\n}\n\n.sidebar-light #sidebarToggle:hover {\n    background-color: #dddfeb\n}\n\n.sidebar-dark .sidebar-brand {\n    color: #fff\n}\n\n.sidebar-dark hr.sidebar-divider {\n    border-top: 1px solid rgba(255, 255, 255, .15)\n}\n\n.sidebar-dark .sidebar-heading {\n    color: rgba(255, 255, 255, .4)\n}\n\n.sidebar-dark .nav-item .nav-link {\n    color: rgba(255, 255, 255, .8)\n}\n\n.sidebar-dark .nav-item .nav-link i {\n    color: rgba(255, 255, 255, .3)\n}\n\n.sidebar-dark .nav-item .nav-link:active,\n.sidebar-dark .nav-item .nav-link:focus,\n.sidebar-dark .nav-item .nav-link:hover {\n    color: #fff\n}\n\n.sidebar-dark .nav-item .nav-link:active i,\n.sidebar-dark .nav-item .nav-link:focus i,\n.sidebar-dark .nav-item .nav-link:hover i {\n    color: #fff\n}\n\n.sidebar-dark .nav-item .nav-link[data-toggle=collapse]::after {\n    color: rgba(255, 255, 255, .5)\n}\n\n.sidebar-dark .nav-item.active .nav-link {\n    color: #fff\n}\n\n.sidebar-dark .nav-item.active .nav-link i {\n    color: #fff\n}\n\n.sidebar-dark #sidebarToggle {\n    background-color: rgba(255, 255, 255, .2)\n}\n\n.sidebar-dark #sidebarToggle::after {\n    color: rgba(255, 255, 255, .5)\n}\n\n.sidebar-dark #sidebarToggle:hover {\n    background-color: rgba(255, 255, 255, .25)\n}\n\n.sidebar-dark.toggled #sidebarToggle::after {\n    color: rgba(255, 255, 255, .5)\n}\n\n.btn-circle {\n    border-radius: 100%;\n    height: 2.5rem;\n    width: 2.5rem;\n    font-size: 1rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center\n}\n\n.btn-circle.btn-sm,\n.btn-group-sm>.btn-circle.btn {\n    height: 1.8rem;\n    width: 1.8rem;\n    font-size: .75rem\n}\n\n.btn-circle.btn-lg,\n.btn-group-lg>.btn-circle.btn {\n    height: 3.5rem;\n    width: 3.5rem;\n    font-size: 1.35rem\n}\n\n.btn-icon-split {\n    padding: 0;\n    overflow: hidden;\n    display: inline-flex;\n    align-items: stretch;\n    justify-content: center\n}\n\n.btn-icon-split .icon {\n    background: rgba(0, 0, 0, .15);\n    display: inline-block;\n    padding: .375rem .75rem\n}\n\n.btn-icon-split .text {\n    display: inline-block;\n    padding: .375rem .75rem\n}\n\n.btn-group-sm>.btn-icon-split.btn .icon,\n.btn-icon-split.btn-sm .icon {\n    padding: .25rem .5rem\n}\n\n.btn-group-sm>.btn-icon-split.btn .text,\n.btn-icon-split.btn-sm .text {\n    padding: .25rem .5rem\n}\n\n.btn-group-lg>.btn-icon-split.btn .icon,\n.btn-icon-split.btn-lg .icon {\n    padding: .5rem 1rem\n}\n\n.btn-group-lg>.btn-icon-split.btn .text,\n.btn-icon-split.btn-lg .text {\n    padding: .5rem 1rem\n}\n\n.card .card-header .dropdown {\n    line-height: 1\n}\n\n.card .card-header .dropdown .dropdown-menu {\n    line-height: 1.5\n}\n\n.card .card-header[data-toggle=collapse] {\n    text-decoration: none;\n    position: relative;\n    padding: .75rem 3.25rem .75rem 1.25rem\n}\n\n.card .card-header[data-toggle=collapse]::after {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding-right: 1.725rem;\n    line-height: 51px;\n    font-weight: 900;\n    content: '\\f107';\n    font-family: 'Font Awesome 5 Free';\n    color: #d1d3e2\n}\n\n.card .card-header[data-toggle=collapse].collapsed {\n    border-radius: .35rem\n}\n\n.card .card-header[data-toggle=collapse].collapsed::after {\n    content: '\\f105'\n}\n\n.chart-area {\n    position: relative;\n    height: 10rem;\n    width: 100%\n}\n\n@media (min-width:768px) {\n    .chart-area {\n        height: 20rem\n    }\n}\n\n.chart-bar {\n    position: relative;\n    height: 10rem;\n    width: 100%\n}\n\n@media (min-width:768px) {\n    .chart-bar {\n        height: 20rem\n    }\n}\n\n.chart-pie {\n    position: relative;\n    height: 15rem;\n    width: 100%\n}\n\n@media (min-width:768px) {\n    .chart-pie {\n        height: calc(20rem - 43px) !important\n    }\n}\n\n.bg-login-image {\n    background: url(https://source.unsplash.com/K4mSJ7kc0As/600x800);\n    background-position: center;\n    background-size: cover\n}\n\n.bg-register-image {\n    background: url(https://source.unsplash.com/Mv9hjnEUHR4/600x800);\n    background-position: center;\n    background-size: cover\n}\n\n.bg-password-image {\n    background: url(https://source.unsplash.com/oWTW-jNGl9I/600x800);\n    background-position: center;\n    background-size: cover\n}\n\nform.user .custom-checkbox.small label {\n    line-height: 1.5rem\n}\n\nform.user .form-control-user {\n    font-size: .8rem;\n    border-radius: 10rem;\n    padding: 1.5rem 1rem\n}\n\nform.user .btn-user {\n    font-size: .8rem;\n    border-radius: 10rem;\n    padding: .75rem 1rem\n}\n\n.btn-google {\n    color: #fff;\n    background-color: #ea4335;\n    border-color: #fff\n}\n\n.btn-google:hover {\n    color: #fff;\n    background-color: #e12717;\n    border-color: #e6e6e6\n}\n\n.btn-google.focus,\n.btn-google:focus {\n    color: #fff;\n    background-color: #e12717;\n    border-color: #e6e6e6;\n    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)\n}\n\n.btn-google.disabled,\n.btn-google:disabled {\n    color: #fff;\n    background-color: #ea4335;\n    border-color: #fff\n}\n\n.btn-google:not(:disabled):not(.disabled).active,\n.btn-google:not(:disabled):not(.disabled):active,\n.show>.btn-google.dropdown-toggle {\n    color: #fff;\n    background-color: #d62516;\n    border-color: #dfdfdf\n}\n\n.btn-google:not(:disabled):not(.disabled).active:focus,\n.btn-google:not(:disabled):not(.disabled):active:focus,\n.show>.btn-google.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)\n}\n\n.btn-facebook {\n    color: #fff;\n    background-color: #3b5998;\n    border-color: #fff\n}\n\n.btn-facebook:hover {\n    color: #fff;\n    background-color: #30497c;\n    border-color: #e6e6e6\n}\n\n.btn-facebook.focus,\n.btn-facebook:focus {\n    color: #fff;\n    background-color: #30497c;\n    border-color: #e6e6e6;\n    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)\n}\n\n.btn-facebook.disabled,\n.btn-facebook:disabled {\n    color: #fff;\n    background-color: #3b5998;\n    border-color: #fff\n}\n\n.btn-facebook:not(:disabled):not(.disabled).active,\n.btn-facebook:not(:disabled):not(.disabled):active,\n.show>.btn-facebook.dropdown-toggle {\n    color: #fff;\n    background-color: #2d4373;\n    border-color: #dfdfdf\n}\n\n.btn-facebook:not(:disabled):not(.disabled).active:focus,\n.btn-facebook:not(:disabled):not(.disabled):active:focus,\n.show>.btn-facebook.dropdown-toggle:focus {\n    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, .5)\n}\n\n.error {\n    color: #5a5c69;\n    font-size: 7rem;\n    position: relative;\n    line-height: 1;\n    width: 12.5rem\n}\n\n@-webkit-keyframes noise-anim {\n    0% {\n        clip: rect(49px, 9999px, 40px, 0)\n    }\n\n    5% {\n        clip: rect(75px, 9999px, 72px, 0)\n    }\n\n    10% {\n        clip: rect(97px, 9999px, 93px, 0)\n    }\n\n    15% {\n        clip: rect(15px, 9999px, 9px, 0)\n    }\n\n    20% {\n        clip: rect(14px, 9999px, 92px, 0)\n    }\n\n    25% {\n        clip: rect(18px, 9999px, 94px, 0)\n    }\n\n    30% {\n        clip: rect(17px, 9999px, 20px, 0)\n    }\n\n    35% {\n        clip: rect(71px, 9999px, 59px, 0)\n    }\n\n    40% {\n        clip: rect(42px, 9999px, 84px, 0)\n    }\n\n    45% {\n        clip: rect(56px, 9999px, 25px, 0)\n    }\n\n    50% {\n        clip: rect(46px, 9999px, 14px, 0)\n    }\n\n    55% {\n        clip: rect(47px, 9999px, 1px, 0)\n    }\n\n    60% {\n        clip: rect(64px, 9999px, 58px, 0)\n    }\n\n    65% {\n        clip: rect(89px, 9999px, 92px, 0)\n    }\n\n    70% {\n        clip: rect(56px, 9999px, 39px, 0)\n    }\n\n    75% {\n        clip: rect(80px, 9999px, 71px, 0)\n    }\n\n    80% {\n        clip: rect(8px, 9999px, 13px, 0)\n    }\n\n    85% {\n        clip: rect(66px, 9999px, 68px, 0)\n    }\n\n    90% {\n        clip: rect(68px, 9999px, 4px, 0)\n    }\n\n    95% {\n        clip: rect(56px, 9999px, 14px, 0)\n    }\n\n    100% {\n        clip: rect(28px, 9999px, 53px, 0)\n    }\n}\n\n@keyframes noise-anim {\n    0% {\n        clip: rect(49px, 9999px, 40px, 0)\n    }\n\n    5% {\n        clip: rect(75px, 9999px, 72px, 0)\n    }\n\n    10% {\n        clip: rect(97px, 9999px, 93px, 0)\n    }\n\n    15% {\n        clip: rect(15px, 9999px, 9px, 0)\n    }\n\n    20% {\n        clip: rect(14px, 9999px, 92px, 0)\n    }\n\n    25% {\n        clip: rect(18px, 9999px, 94px, 0)\n    }\n\n    30% {\n        clip: rect(17px, 9999px, 20px, 0)\n    }\n\n    35% {\n        clip: rect(71px, 9999px, 59px, 0)\n    }\n\n    40% {\n        clip: rect(42px, 9999px, 84px, 0)\n    }\n\n    45% {\n        clip: rect(56px, 9999px, 25px, 0)\n    }\n\n    50% {\n        clip: rect(46px, 9999px, 14px, 0)\n    }\n\n    55% {\n        clip: rect(47px, 9999px, 1px, 0)\n    }\n\n    60% {\n        clip: rect(64px, 9999px, 58px, 0)\n    }\n\n    65% {\n        clip: rect(89px, 9999px, 92px, 0)\n    }\n\n    70% {\n        clip: rect(56px, 9999px, 39px, 0)\n    }\n\n    75% {\n        clip: rect(80px, 9999px, 71px, 0)\n    }\n\n    80% {\n        clip: rect(8px, 9999px, 13px, 0)\n    }\n\n    85% {\n        clip: rect(66px, 9999px, 68px, 0)\n    }\n\n    90% {\n        clip: rect(68px, 9999px, 4px, 0)\n    }\n\n    95% {\n        clip: rect(56px, 9999px, 14px, 0)\n    }\n\n    100% {\n        clip: rect(28px, 9999px, 53px, 0)\n    }\n}\n\n.error:after {\n    content: attr(data-text);\n    position: absolute;\n    left: 2px;\n    text-shadow: -1px 0 #e74a3b;\n    top: 0;\n    color: #5a5c69;\n    background: #f8f9fc;\n    overflow: hidden;\n    clip: rect(0, 900px, 0, 0);\n    animation: noise-anim 2s infinite linear alternate-reverse\n}\n\n@-webkit-keyframes noise-anim-2 {\n    0% {\n        clip: rect(16px, 9999px, 10px, 0)\n    }\n\n    5% {\n        clip: rect(22px, 9999px, 29px, 0)\n    }\n\n    10% {\n        clip: rect(6px, 9999px, 68px, 0)\n    }\n\n    15% {\n        clip: rect(85px, 9999px, 95px, 0)\n    }\n\n    20% {\n        clip: rect(65px, 9999px, 91px, 0)\n    }\n\n    25% {\n        clip: rect(93px, 9999px, 68px, 0)\n    }\n\n    30% {\n        clip: rect(10px, 9999px, 27px, 0)\n    }\n\n    35% {\n        clip: rect(37px, 9999px, 25px, 0)\n    }\n\n    40% {\n        clip: rect(12px, 9999px, 23px, 0)\n    }\n\n    45% {\n        clip: rect(40px, 9999px, 18px, 0)\n    }\n\n    50% {\n        clip: rect(19px, 9999px, 71px, 0)\n    }\n\n    55% {\n        clip: rect(2px, 9999px, 35px, 0)\n    }\n\n    60% {\n        clip: rect(16px, 9999px, 69px, 0)\n    }\n\n    65% {\n        clip: rect(8px, 9999px, 65px, 0)\n    }\n\n    70% {\n        clip: rect(30px, 9999px, 57px, 0)\n    }\n\n    75% {\n        clip: rect(14px, 9999px, 4px, 0)\n    }\n\n    80% {\n        clip: rect(39px, 9999px, 30px, 0)\n    }\n\n    85% {\n        clip: rect(22px, 9999px, 35px, 0)\n    }\n\n    90% {\n        clip: rect(58px, 9999px, 71px, 0)\n    }\n\n    95% {\n        clip: rect(34px, 9999px, 90px, 0)\n    }\n\n    100% {\n        clip: rect(67px, 9999px, 68px, 0)\n    }\n}\n\n@keyframes noise-anim-2 {\n    0% {\n        clip: rect(16px, 9999px, 10px, 0)\n    }\n\n    5% {\n        clip: rect(22px, 9999px, 29px, 0)\n    }\n\n    10% {\n        clip: rect(6px, 9999px, 68px, 0)\n    }\n\n    15% {\n        clip: rect(85px, 9999px, 95px, 0)\n    }\n\n    20% {\n        clip: rect(65px, 9999px, 91px, 0)\n    }\n\n    25% {\n        clip: rect(93px, 9999px, 68px, 0)\n    }\n\n    30% {\n        clip: rect(10px, 9999px, 27px, 0)\n    }\n\n    35% {\n        clip: rect(37px, 9999px, 25px, 0)\n    }\n\n    40% {\n        clip: rect(12px, 9999px, 23px, 0)\n    }\n\n    45% {\n        clip: rect(40px, 9999px, 18px, 0)\n    }\n\n    50% {\n        clip: rect(19px, 9999px, 71px, 0)\n    }\n\n    55% {\n        clip: rect(2px, 9999px, 35px, 0)\n    }\n\n    60% {\n        clip: rect(16px, 9999px, 69px, 0)\n    }\n\n    65% {\n        clip: rect(8px, 9999px, 65px, 0)\n    }\n\n    70% {\n        clip: rect(30px, 9999px, 57px, 0)\n    }\n\n    75% {\n        clip: rect(14px, 9999px, 4px, 0)\n    }\n\n    80% {\n        clip: rect(39px, 9999px, 30px, 0)\n    }\n\n    85% {\n        clip: rect(22px, 9999px, 35px, 0)\n    }\n\n    90% {\n        clip: rect(58px, 9999px, 71px, 0)\n    }\n\n    95% {\n        clip: rect(34px, 9999px, 90px, 0)\n    }\n\n    100% {\n        clip: rect(67px, 9999px, 68px, 0)\n    }\n}\n\n.error:before {\n    content: attr(data-text);\n    position: absolute;\n    left: -2px;\n    text-shadow: 1px 0 #4e73df;\n    top: 0;\n    color: #5a5c69;\n    background: #f8f9fc;\n    overflow: hidden;\n    clip: rect(0, 900px, 0, 0);\n    animation: noise-anim-2 3s infinite linear alternate-reverse\n}\n\nfooter.sticky-footer {\n    padding: 2rem 0;\n    flex-shrink: 0\n}\n\nfooter.sticky-footer .copyright {\n    line-height: 1;\n    font-size: .8rem\n}\n\nbody.sidebar-toggled footer.sticky-footer {\n    width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
